let TempRecipeData = [
  {
    title: "Chewy No-Bake Peanut Butter Dark Chocolate Oat Bars",
    category: "Snack",
    time: "10 mins",
    description:
      "Chewy no-bake peanut butter dark chocolate oat bars are a delightful and energy-boosting treat that requires minimal effort to make. These bars combine the rich flavors of peanut butter and dark chocolate with the wholesome goodness of oats, creating a satisfying and delicious snack for any time of the day.",
    img: "https://cdn.pickuplimes.com/cache/55/65/5565540b32a3e1bc3e4be475d473b7cd.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/52/ee/52eef76899709a973222d9d5b7f15cae.jpg",
      "https://cdn.pickuplimes.com/cache/cd/0f/cd0f9524910279f63f4d45a586e2911b.jpg",
      "https://cdn.pickuplimes.com/cache/17/7a/177ab14057fc88cbd16f98cec97bd194.jpg",
      "https://cdn.pickuplimes.com/cache/0f/90/0f904bdc5b7b015c0fb8c702e8ad1e52.jpg",
    ],
    directions: [
      "Line an 8x8-inch square baking dish with parchment paper, leaving some overhang on the sides for easy removal of the bars later.",
      "In a microwave-safe bowl or on the stovetop, gently melt the creamy peanut butter, maple syrup, and coconut oil together until they form a smooth mixture.",
      "Stir in the vanilla extract and a pinch of salt for added flavor.",
      "Add the quick oats to the peanut butter mixture and mix until all the oats are well coated.",
      "Gently fold in the dark chocolate chips, distributing them evenly throughout the mixture.",
      "Transfer the oat mixture to the prepared baking dish and press it down firmly using the back of a spoon or your hands to create an even layer.",
      "For best results, refrigerate the bars for at least 2 hours or until they are firm and set.",
      "Once the bars have chilled and set, lift them out of the baking dish using the parchment paper overhang.",
      "Place the slab of bars on a cutting board and cut them into desired sizes.",
      "Serve these delicious and chewy no-bake peanut butter dark chocolate oat bars as a satisfying snack or a sweet treat anytime you need an energy boost.",
      "Store any leftover bars in an airtight container in the refrigerator for up to a week.",
    ],
    ingredients: [
      {
        ingredient: "Creamy peanut butter",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Maple syrup",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Coconut oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Quick oats",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Dark chocolate chips",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "pinch",
        quantity: null,
      },
    ],
  },
  {
    title: "Sun-Dried Tomato & Roasted Vegetable Tart",
    category: "Main",
    time: "10 mins",
    description:
      "Sun-Dried Tomato & Roasted Vegetable Tart is a delectable savory pastry that brings together the rich flavors of sun-dried tomatoes and roasted vegetables. The buttery and flaky tart crust is filled with a delicious mixture of caramelized onions, roasted bell peppers, zucchini, eggplant, and tangy sun-dried tomatoes. This elegant tart is perfect for a special brunch or as a delightful appetizer.",
    img: "https://cdn.pickuplimes.com/cache/0f/09/0f0917f6ea2be7b7a2a34a982248ebeb.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/90/b3/90b3f3915241127b6023e3e383a89110.jpg",
      "https://cdn.pickuplimes.com/cache/6a/2a/6a2aaebf51bcad696edba61afcebd836.jpg",
      "https://cdn.pickuplimes.com/cache/24/b9/24b9d2cd96107a5db5bd246fb693396b.jpg",
      "https://cdn.pickuplimes.com/cache/c1/35/c135676df53639dc91473bed2ee45afc.jpg",
    ],
    directions: [
      "Preheat the oven to 375°F (190°C).",
      "Roll out the tart crust and fit it into a tart pan. Prick the bottom with a fork and blind bake it in the preheated oven for about 10 minutes until it becomes lightly golden. Remove from the oven and set aside.",
      "In a large mixing bowl, toss the sliced red bell pepper, yellow bell pepper, zucchini, eggplant, and red onion with olive oil, balsamic vinegar, fresh thyme leaves, salt, and black pepper.",
      "Spread the marinated vegetables on a baking sheet and roast them in the preheated oven for 20-25 minutes or until they become tender and slightly caramelized. Stir the vegetables occasionally to ensure even cooking.",
      "While the vegetables are roasting, drain the soaked sun-dried tomatoes and chop them into small pieces.",
      "Once the vegetables are done roasting, remove them from the oven and let them cool slightly.",
      "Spread the chopped sun-dried tomatoes over the pre-baked tart crust.",
      "Layer the roasted vegetables over the sun-dried tomatoes in the tart crust.",
      "If desired, sprinkle vegan cheese over the top of the vegetables.",
      "Bake the assembled tart in the oven for an additional 15-20 minutes until the crust is golden and the cheese (if used) has melted.",
      "Remove the tart from the oven and let it cool for a few minutes before serving.",
      "Slice the Sun-Dried Tomato & Roasted Vegetable Tart and enjoy it warm as a delightful and flavorful treat!",
    ],
    ingredients: [
      {
        ingredient: "Tart crust (store-bought or homemade)",
        unit: "",
        quantity: "1",
      },
      {
        ingredient: "Red bell pepper, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Yellow bell pepper, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Zucchini, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Eggplant, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Red onion, thinly sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Sun-dried tomatoes, soaked in hot water",
        unit: "g",
        quantity: 100,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Balsamic vinegar",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Fresh thyme leaves",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Vegan cheese (optional)",
        unit: "g",
        quantity: 100,
      },
    ],
  },
  {
    title: "Raspberry Rose Chocolate Bark",
    category: "Dessert",
    time: "60 mins",
    description:
      "Raspberry Rose Chocolate Bark is a luxurious and elegant dessert that combines the richness of dark chocolate with the sweetness of raspberries and the floral aroma of rose petals. This exquisite treat is made by melting dark chocolate and spreading it on a parchment-lined baking sheet. Fresh raspberries are then scattered over the melted chocolate, and dried rose petals are gently pressed into the surface, adding a delicate and aromatic touch. Once the chocolate has cooled and hardened, it's broken into irregular pieces to create the beautiful and indulgent chocolate bark. The combination of flavors and textures in this bark makes it a perfect gift or a stunning addition to any dessert table or special occasion.",
    img: "https://cdn.pickuplimes.com/cache/00/92/00922e458139c741c4dcae6b7dcd9265.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/aa/04/aa04a39b0d45aa18a59d5607f98436f0.jpg",
      "https://cdn.pickuplimes.com/cache/9b/63/9b63c29b197e0f3b803ed67f6def6a4e.jpg",
      "https://cdn.pickuplimes.com/cache/38/ab/38abdd84623212e633d5c65a49d640e5.jpg",
      "https://cdn.pickuplimes.com/cache/d8/73/d873e952b7c2f684c9e15518fd78b677.jpg",
    ],
    directions: [
      "Line a baking sheet or tray with parchment paper and set it aside.",
      "In a microwave-safe bowl, melt the dark chocolate in the microwave, stirring every 20 seconds until smooth.",
      "Stir in the dried raspberries, edible dried rose petals, and rose water into the melted chocolate. Mix until the ingredients are well combined.",
      "Pour the chocolate mixture onto the prepared parchment paper and spread it out into an even layer with a spatula.",
      "Sprinkle the freeze-dried raspberry powder over the top of the chocolate bark, adding a pop of color and flavor.",
      "If desired, decorate the bark with edible gold or silver leaf for an elegant touch.",
      "Place the tray in the refrigerator for about 30-40 minutes to allow the chocolate bark to set completely.",
      "Once the chocolate is firm, break the bark into irregular pieces.",
      "Transfer the raspberry rose chocolate bark to an airtight container and store it in the refrigerator until ready to serve.",
      "Enjoy the delightful blend of flavors and textures in this raspberry rose chocolate bark as a decadent treat or share it with loved ones as a special gift.",
    ],
    ingredients: [
      {
        ingredient: "Dark chocolate (vegan, if preferred)",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Dried raspberries",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Edible dried rose petals",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Rose water",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Freeze-dried raspberry powder",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Edible gold leaf (optional, for decoration)",
        unit: "for decoration",
        quantity: null,
      },
      {
        ingredient: "Edible silver leaf (optional, for decoration)",
        unit: "for decoration",
        quantity: null,
      },
    ],
  },
  {
    title: "Vegan Breakfast Waffles",
    category: "Breakfast",
    time: "30 mins",
    description:
      "Vegan breakfast waffles are a delicious and cruelty-free morning treat. These waffles are made without any animal products, but they are still fluffy and flavorful, making them a perfect breakfast option for vegans and non-vegans alike.",
    img: "https://cdn.pickuplimes.com/cache/1c/51/1c5108ea4fe296662cb3575b9549b1b4.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/e2/8a/e28ad7f2cc7fae2c141376419d820007.jpg",
      "https://cdn.pickuplimes.com/cache/51/f3/51f302c2277de42cad76251296656ee9.jpg",
      "https://cdn.pickuplimes.com/cache/83/47/83477be995c302fc884d6be2865c8b40.jpg",
      "https://cdn.pickuplimes.com/cache/a6/0b/a60b2b55a955c963f04a17918c860222.jpg",
    ],
    directions: [
      "Preheat your waffle maker according to the manufacturer's instructions.",
      "In a large mixing bowl, whisk together the all-purpose flour, baking powder, salt, and coconut sugar (or any granulated sugar).",
      "Add the almond milk, applesauce, vegetable oil (or melted coconut oil), and vanilla extract to the dry ingredients. Mix until a smooth batter forms, but be careful not to overmix.",
      "Once the waffle maker is hot, lightly grease it with cooking spray or oil to prevent sticking.",
      "Pour the waffle batter onto the hot waffle maker, using the amount recommended for your specific waffle maker size.",
      "Close the lid and cook the waffles according to your waffle maker's instructions, usually about 4-5 minutes or until golden and crispy.",
      "Carefully remove the cooked waffles from the waffle maker and transfer them to a plate.",
      "Serve the vegan breakfast waffles warm, topped with fresh berries or sliced fruits, and drizzle with maple syrup or any vegan syrup of your choice.",
      "Enjoy these delicious and animal-friendly vegan breakfast waffles to start your day on a delightful note!",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Baking powder",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Coconut sugar or any granulated sugar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Almond milk or any plant-based milk",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Applesauce",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Vegetable oil or melted coconut oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Fresh berries or sliced fruits (for serving)",
        unit: "for topping",
        quantity: null,
      },
      {
        ingredient: "Maple syrup or any vegan syrup",
        unit: "for drizzling",
        quantity: null,
      },
    ],
  },
  {
    title: "Double Chocolate Mug Cake",
    category: "Dessert",
    time: "5 mins",
    description:
      "Double Chocolate Mug Cake is a quick and indulgent dessert that can be prepared in just a few minutes using a microwave. This delectable single-serving cake is loaded with rich chocolate flavor, thanks to the combination of cocoa powder and chocolate chips in the batter. Made with simple pantry ingredients like all-purpose flour, sugar, vegetable oil or melted butter, milk (dairy or non-dairy), and a pinch of baking powder, this mug cake is mixed in a mug and microwaved to perfection. The result is a moist and gooey chocolate cake that's perfect for satisfying your sweet cravings on a whim. Enjoy this warm and decadent treat straight from the mug or top it with a scoop of ice cream or a dollop of whipped cream for an extra delightful experience.",
    img: "https://cdn.pickuplimes.com/cache/ca/cc/cacce0d3c7d198cfcf68adff599643eb.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/14/31/1431a02531c8ac5811325502b6241ad6.jpg",
      "https://cdn.pickuplimes.com/cache/54/d3/54d3bea09cb16c5e1d7973a6891e82f0.jpg",
      "https://cdn.pickuplimes.com/cache/59/41/5941cb5eba899f50b9beef3ca58c8e5b.jpg",
      "https://cdn.pickuplimes.com/cache/7e/b0/7eb09937c94b7a5b66235e758cd1add9.jpg",
    ],
    directions: [
      "In a microwave-safe mug, whisk together the all-purpose flour, granulated sugar, cocoa powder, baking powder, and a pinch of salt.",
      "Add the milk, vegetable oil, and vanilla extract to the dry ingredients in the mug. Mix until the batter is smooth and no lumps remain.",
      "Stir in the chocolate chips to distribute them evenly throughout the batter.",
      "Place the mug in the microwave and cook on high for about 1 minute and 30 seconds to 2 minutes. Cooking time may vary depending on your microwave's power. The cake should rise and become firm to the touch.",
      "Remove the mug from the microwave, and let the double chocolate mug cake cool for a minute or two before serving.",
      "If desired, dust the top of the mug cake with powdered sugar for a decorative touch.",
      "You can enjoy the double chocolate mug cake as is or add a scoop of vanilla ice cream on top for an extra indulgent treat.",
      "Dig in and savor the warm and chocolaty goodness of this quick and delightful dessert!",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "tablespoons",
        quantity: 4,
      },
      {
        ingredient: "Granulated sugar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Cocoa powder",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "pinch",
        quantity: null,
      },
      {
        ingredient: "Milk (non-dairy milk for vegan option)",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Chocolate chips",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Powdered sugar (for dusting, optional)",
        unit: "for dusting",
        quantity: null,
      },
      {
        ingredient: "Vanilla ice cream (for serving, optional)",
        unit: "for serving",
        quantity: null,
      },
    ],
  },
  {
    title: "Ranch Flavoured Roasted Chickpeas",
    category: "Snack",
    time: "30 mins",
    description:
      "Ranch-flavored roasted chickpeas are a delicious and crunchy snack that packs a punch of savory and zesty flavors. These roasted chickpeas are coated in a homemade ranch seasoning blend and baked to perfection, creating a delightful and protein-packed snack that's perfect for munching on anytime you need a tasty and satisfying treat.",
    img: "https://cdn.pickuplimes.com/cache/97/32/9732c19f8999ad5e58d47d4b25dfa307.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/43/d8/43d86d94194924d0da63a5aeea075bf8.jpg",
      "https://cdn.pickuplimes.com/cache/c9/bd/c9bda65760ee6b9433ba7dcccf29d74e.jpg",
      "https://cdn.pickuplimes.com/cache/fd/d5/fdd58eb384844fcb843ca20a790d9eda.jpg",
      "https://cdn.pickuplimes.com/cache/b0/27/b027e61c8be34073b0dfc4dcb248a6a6.jpg",
    ],
    directions: [
      "Preheat your oven to 400°F (200°C) and line a baking sheet with parchment paper.",
      "Rinse and drain the canned chickpeas thoroughly. Pat them dry with a paper towel to remove excess moisture.",
      "In a bowl, toss the chickpeas with olive oil until they are evenly coated.",
      "In a separate small bowl, combine the dried dill, dried parsley, garlic powder, onion powder, dried chives, salt, black pepper, paprika, and a pinch of cayenne pepper if you prefer a bit of heat.",
      "Sprinkle the ranch seasoning mixture over the chickpeas and toss them again to ensure the seasoning is evenly distributed.",
      "Spread the seasoned chickpeas in a single layer on the prepared baking sheet.",
      "Roast the ranch-flavored chickpeas in the preheated oven for about 25-30 minutes or until they become golden brown and crispy, shaking the baking sheet occasionally to prevent sticking.",
      "Keep a close eye on the chickpeas in the last few minutes of roasting to avoid burning.",
      "Remove the baking sheet from the oven and let the roasted chickpeas cool completely on the sheet.",
      "Once cooled, transfer the ranch-flavored roasted chickpeas to an airtight container for storage.",
      "Enjoy these savory and crunchy chickpeas as a delightful and guilt-free snack or as a tasty topping for salads and soups!",
      "Store any leftover roasted chickpeas in an airtight container at room temperature for up to a week.",
      "Feel free to adjust the ranch seasoning to suit your taste preferences, adding more or less of any ingredient as desired.",
    ],
    ingredients: [
      {
        ingredient: "Canned chickpeas (garbanzo beans)",
        unit: "2 cans",
        quantity: null,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Dried dill",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Dried parsley",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Onion powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Dried chives",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Paprika",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Cayenne pepper (optional, for heat)",
        unit: "pinch",
        quantity: null,
      },
    ],
  },
  {
    title: "Chunky Avocado Mango Salsa",
    category: "Appetizer",
    time: "20 mins",
    description:
      "Chunky avocado mango salsa is a fresh and colorful salsa that brings together the creaminess of avocado and the sweetness of ripe mangoes with a burst of tangy lime and a kick of jalapeño. This delightful salsa is perfect for dipping, topping grilled meats or fish, or adding a burst of flavor to tacos and salads.",
    img: "https://cdn.pickuplimes.com/cache/48/6e/486eda55d468294326c9f84863602b28.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/0f/64/0f64e2bf4ca37823766e110c6b32e661.jpg",
      "https://cdn.pickuplimes.com/cache/6c/3f/6c3f601432022a676c150380fabe132d.jpg",
      "https://cdn.pickuplimes.com/cache/0b/d4/0bd4ed5b02566edffdb6feed2aecae27.jpg",
      "https://cdn.pickuplimes.com/cache/b5/33/b533d77e0f08fa83da38a96f473b5127.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the diced mango, diced avocados, diced red bell pepper, finely chopped red onion, finely chopped jalapeño pepper, and chopped fresh cilantro.",
      "Drizzle the fresh lime juice over the salsa.",
      "Season the salsa with salt and black pepper.",
      "Gently toss all the ingredients together until well combined, being careful not to mash the avocado too much to keep a chunky texture.",
      "Let the chunky avocado mango salsa sit for a few minutes to allow the flavors to meld together.",
      "Serve the salsa in a bowl alongside tortilla chips, grilled meats or fish, or use it as a topping for tacos and salads.",
      "Enjoy this vibrant and flavorful chunky avocado mango salsa as a delicious and refreshing addition to your meals!",
    ],
    ingredients: [
      {
        ingredient: "Ripe mango, diced",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Ripe avocados, diced",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Red bell pepper, diced",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Red onion, finely chopped",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Jalapeño pepper, seeds removed and finely chopped",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Fresh cilantro, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh lime juice",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Rainbow Veggie Sushi Rolls",
    category: "Main",
    time: "60 mins",
    description:
      "Rainbow Veggie Sushi Rolls are a colorful and delicious vegan sushi option that's perfect for sushi lovers and plant-based enthusiasts alike. These sushi rolls are filled with a variety of fresh and vibrant vegetables, such as avocado, cucumber, carrot, bell peppers, and purple cabbage. The combination of colors and flavors makes these rolls a feast for the eyes and the taste buds!",
    img: "https://cdn.pickuplimes.com/cache/fb/48/fb48864fc406a0138288431d922162fc.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/1a/4a/1a4a1a3fe90e24ec37da2096f05d53ce.jpg",
      "https://cdn.pickuplimes.com/cache/6d/52/6d528b9a92f7133cda085d17b7911025.jpg",
      "https://cdn.pickuplimes.com/cache/0e/14/0e14988af11953d60d0006e3f805db6b.jpg",
      "https://cdn.pickuplimes.com/cache/a5/6b/a56b14748a32c452c5ef6d82b4318450.jpg",
    ],
    directions: [
      "Prepare all the vegetables by thinly slicing and julienned them into long strips. Set them aside.",
      "Lay a bamboo sushi rolling mat on a clean surface. Place a sheet of nori seaweed, shiny side down, on the mat.",
      "Dip your fingers in water to prevent the rice from sticking, then spread an even layer of sushi rice over the nori sheet, leaving about 1 inch of nori uncovered at the top.",
      "In the center of the rice, arrange the sliced avocado, cucumber, julienned carrot, red bell pepper, yellow bell pepper, and purple cabbage in a rainbow pattern.",
      "Drizzle soy sauce or tamari and rice vinegar over the vegetables.",
      "Carefully lift the bamboo mat from the edge closest to you, and start rolling the sushi away from you, using the mat to shape it into a tight roll.",
      "Once the roll is complete, wet the exposed nori edge with water and press to seal the sushi roll.",
      "Using a sharp knife, slice the sushi roll into individual pieces, wiping the knife with a damp cloth between cuts.",
      "Arrange the Rainbow Veggie Sushi Rolls on a serving platter.",
      "Sprinkle toasted sesame seeds over the rolls for added flavor and presentation.",
      "Serve the sushi rolls with pickled ginger, wasabi, and soy sauce or tamari on the side for dipping.",
      "Enjoy these colorful and tasty Rainbow Veggie Sushi Rolls as a delightful and healthy meal!",
    ],
    ingredients: [
      {
        ingredient: "Sushi rice, cooked and seasoned",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Nori seaweed sheets",
        unit: "sheets",
        quantity: 4,
      },
      {
        ingredient: "Avocado, thinly sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Cucumber, julienned",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Carrot, julienned",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Red bell pepper, julienned",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Yellow bell pepper, julienned",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Purple cabbage, thinly sliced",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Soy sauce or tamari",
        unit: "tablespoons",
        quantity: 4,
      },
      {
        ingredient: "Rice vinegar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Toasted sesame seeds",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Pickled ginger (optional)",
        unit: "",
        quantity: "for serving",
      },
      {
        ingredient: "Wasabi (optional)",
        unit: "",
        quantity: "for serving",
      },
      {
        ingredient: "Soy sauce or tamari (for dipping)",
        unit: "",
        quantity: "for serving",
      },
    ],
  },
  {
    title: "Almond Brownie Cookies",
    category: "Dessert",
    time: "30 mins",
    description:
      "Almond Brownie Cookies are delightful treats that bring together the best of both worlds – the rich and fudgy texture of brownies and the nutty goodness of almonds. These cookies are made with a combination of almond flour, cocoa powder, and chopped almonds, which gives them a delectable and chewy texture. The addition of almond extract enhances the nutty flavor, while ingredients like vegan butter or coconut oil, sugar, and a flax egg (a mixture of ground flaxseed and water) bind the cookie dough together. Once baked to perfection, these almond brownie cookies boast a crackly top and a soft, gooey center that's perfect for indulging in warm from the oven or pairing with a glass of almond milk for a delightful treat.",
    img: "https://cdn.pickuplimes.com/cache/07/39/07393646ca0d65a83ca1f3ad665b38e8.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/20/77/2077f72238f9ae62f41dab8279a3ab47.jpg",
      "https://cdn.pickuplimes.com/cache/bd/9e/bd9e9c6f9688568b2c24148cccf1d267.jpg",
      "https://cdn.pickuplimes.com/cache/6f/45/6f457dc51cc2e55223425cca162a4458.jpg",
      "https://cdn.pickuplimes.com/cache/aa/45/aa45d9709ee47497234edac2f200d360.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C) and line a baking sheet with parchment paper.",
      "In a microwave-safe bowl, melt the semi-sweet chocolate and vegan butter together, stirring every 20 seconds until smooth.",
      "In a separate bowl, mix the flaxseed meal and water to create a flax egg. Let it sit for a few minutes to thicken.",
      "Add the granulated sugar, brown sugar, and vanilla extract to the flax egg and mix well.",
      "Pour the melted chocolate mixture into the flax egg mixture and stir until well combined.",
      "In another bowl, whisk together the all-purpose flour, cocoa powder, baking powder, and salt.",
      "Add the dry ingredients to the wet ingredients and mix until a thick cookie dough forms.",
      "Fold in the sliced almonds into the cookie dough for added crunch and flavor.",
      "Scoop about 1-2 tablespoons of cookie dough and drop it onto the prepared baking sheet, leaving enough space between each cookie.",
      "Gently flatten each cookie slightly with your fingers or the back of a spoon.",
      "Bake the almond brownie cookies in the preheated oven for about 10-12 minutes or until the edges are set and the tops are slightly cracked.",
      "Remove the cookies from the oven and let them cool on the baking sheet for a few minutes before transferring them to a wire rack to cool completely.",
      "Enjoy the delightful almond brownie cookies as a decadent treat or share them with friends and family for a moment of sweet indulgence!",
    ],
    ingredients: [
      {
        ingredient: "Semi-sweet chocolate (vegan, if preferred)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Vegan butter",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Granulated sugar",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Brown sugar",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Flaxseed meal",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 6,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Cocoa powder",
        unit: "tablespoons",
        quantity: 0.25,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Sliced almonds",
        unit: "cups",
        quantity: 0.5,
      },
    ],
  },
  {
    title: "Roasted Lemon Turmeric Hummus",
    category: "Appetizer",
    time: "40 mins",
    description:
      "Roasted lemon turmeric hummus is a zesty and flavorful twist on traditional hummus. Roasting the lemon gives it a slightly caramelized and mellow flavor, while the addition of turmeric brings a warm and earthy taste. This creamy and vibrant hummus is perfect as a dip, spread, or a tasty accompaniment to your favorite dishes.",
    img: "https://cdn.pickuplimes.com/cache/b9/d2/b9d24af04c0f3299d70d4f5a7de42ac7.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/69/2c/692cb05b5f5ae1060aa171bbac822339.jpg",
      "https://cdn.pickuplimes.com/cache/25/b4/25b44a789e3e148c975ffd5137ed9870.jpg",
      "https://cdn.pickuplimes.com/cache/ef/10/ef107a2a78517be7cfeb85647ea5fefa.jpg",
      "https://cdn.pickuplimes.com/cache/7b/ce/7bcea714d6a8fbe9db14b4cad7483389.jpg",
    ],
    directions: [
      "Preheat your oven to 400°F (200°C).",
      "Cut the lemon in half, and place it on a baking sheet cut side down.",
      "Roast the lemon in the preheated oven for about 20-25 minutes or until it becomes slightly caramelized and softened.",
      "Once the lemon is roasted, remove it from the oven and let it cool slightly.",
      "In a food processor, combine the cooked chickpeas, tahini, roasted lemon juice, olive oil, minced garlic, ground turmeric, salt, and black pepper.",
      "Blend the ingredients until the mixture becomes smooth and creamy.",
      "While the food processor is running, slowly drizzle in the water to achieve your desired consistency.",
      "Taste the roasted lemon turmeric hummus and adjust the seasonings to your liking, adding more salt or turmeric if desired.",
      "Transfer the hummus to a serving bowl.",
      "Drizzle a little olive oil over the hummus and sprinkle some paprika for added color and flavor.",
      "Serve the roasted lemon turmeric hummus as a delicious dip, spread, or accompaniment to your favorite dishes.",
      "Enjoy the delightful combination of flavors in this creamy and vibrant hummus!",
    ],
    ingredients: [
      {
        ingredient: "Chickpeas, cooked and drained",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Tahini",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Roasted lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Ground turmeric",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Paprika and olive oil (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Loaded Chili Sweet Potato Fries",
    category: "Appetizer",
    time: "45 mins",
    description:
      "Loaded chili sweet potato fries are a scrumptious and indulgent treat that combines the sweetness of roasted sweet potato fries with savory and spicy chili toppings. These fries are then generously loaded with delicious toppings, making them a satisfying meal or a delightful appetizer for any occasion.",
    img: "https://cdn.pickuplimes.com/cache/7e/fe/7efe4b77048bf8f97917556863dc91c9.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/aa/3d/aa3d75090b028fe6037a90d02e4b765f.jpg",
      "https://cdn.pickuplimes.com/cache/8c/69/8c69d4b3c940b726b7a39b31356f3ad3.jpg",
      "https://cdn.pickuplimes.com/cache/05/14/051496c8cc87859ee31fc7df4c6014b3.jpg",
      "https://cdn.pickuplimes.com/cache/0f/30/0f30bdbfc740f736891bf87b80e37969.jpg",
    ],
    directions: [
      "Preheat your oven to 425°F (220°C) and line a baking sheet with parchment paper.",
      "In a large bowl, toss the sweet potato fries with olive oil, chili powder, garlic powder, paprika, ground cumin, salt, and black pepper until the fries are evenly coated with the seasoning.",
      "Spread the seasoned sweet potato fries in a single layer on the prepared baking sheet.",
      "Roast the sweet potato fries in the preheated oven for about 25-30 minutes or until they are crispy and golden brown, flipping them once halfway through for even cooking.",
      "While the fries are roasting, heat the canned chili in a saucepan over medium heat until it's warmed through.",
      "Once the sweet potato fries are done roasting, remove them from the oven and let them cool slightly.",
      "To assemble the loaded chili sweet potato fries, place the roasted fries on a serving platter or individual plates.",
      "Top the fries with the warm chili, shredded cheddar cheese, diced red onion, and chopped fresh cilantro.",
      "Add dollops of sour cream on top for a creamy finish.",
      "Serve the loaded chili sweet potato fries immediately as a delicious and hearty meal or a crowd-pleasing appetizer.",
      "Enjoy the irresistible combination of sweet and spicy flavors in these loaded chili sweet potato fries!",
    ],
    ingredients: [
      {
        ingredient: "Sweet potatoes, peeled and cut into fries",
        unit: "cups",
        quantity: 4,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Chili powder",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Paprika",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Canned chili (vegetarian or meat-based)",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Shredded cheddar cheese (vegan or regular)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Diced red onion",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Chopped fresh cilantro",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Sour cream (vegan or regular)",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Apple Pie Overnight Oats",
    category: "Breakfast",
    time: "10 mins",
    description:
      "Apple pie overnight oats are a comforting and flavorful breakfast that captures the essence of a classic apple pie. These oats are prepared the night before, ensuring a hassle-free and delicious morning meal.",
    img: "https://cdn.pickuplimes.com/cache/9d/cc/9dcc29b31a0f80253847d5280146ec54.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/b2/03/b203e834ccc0c83ade07a49b0f50ed97.jpg",
      "https://cdn.pickuplimes.com/cache/84/1a/841af3e853c14c4355d9d06d0eacc016.jpg",
      "https://cdn.pickuplimes.com/cache/47/84/4784780bf9e217f4eac71782adeec6e7.jpg",
      "https://cdn.pickuplimes.com/cache/91/d2/91d2b3cd17876941b53cf1fee6fcb6a0.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the rolled oats, almond milk, Greek yogurt, honey or maple syrup, vanilla extract, ground cinnamon, and ground nutmeg. Mix well until all the ingredients are well combined.",
      "Add the diced apple to the oat mixture and stir to evenly distribute the apple pieces.",
      "Divide the apple pie overnight oats into individual jars or containers with lids for easy storage and portability.",
      "If you'd like to add some extra crunch and flavor, sprinkle chopped nuts over the top of each portion.",
      "Cover the jars or containers with lids and refrigerate them overnight, or for at least 6-8 hours, to allow the oats to soak up the flavors and become tender.",
      "In the morning, give the apple pie overnight oats a good stir before serving.",
      "Enjoy the comforting taste of apple pie in a convenient and nutritious breakfast that's perfect for busy mornings!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Almond milk (or any milk of your choice)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Greek yogurt",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Apple, diced (peeled and cored)",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Honey or maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground nutmeg",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Chopped nuts (e.g., pecans, walnuts) (optional)",
        unit: "tablespoons",
        quantity: null,
      },
    ],
  },
  {
    title: "Crunchy Pecan & Cranberry Granola",
    category: "Snack",
    time: "25 mins",
    description:
      "Crunchy pecan & cranberry granola is a delicious and nutritious homemade cereal that combines the rich flavor of pecans with the tartness of dried cranberries. This granola is loaded with wholesome oats, nuts, seeds, and sweetened with a touch of maple syrup, creating a delightful and crunchy treat to enjoy with yogurt, milk, or as a snack on its own.",
    img: "https://cdn.pickuplimes.com/cache/23/59/23596901ac89541835865af46c94d1e1.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/bb/77/bb779ae4af121edff7ead323f55a1cf3.jpg",
      "https://cdn.pickuplimes.com/cache/55/98/559878a2dce0ec9deb0a1188d600371b.jpg",
      "https://cdn.pickuplimes.com/cache/39/bf/39bfebd0adae8e60926a9d1e789042fd.jpg",
      "https://cdn.pickuplimes.com/cache/a2/ab/a2ab158b204114cd5147b208d0debc69.jpg",
    ],
    directions: [
      "Preheat your oven to 325°F (160°C) and line a large baking sheet with parchment paper.",
      "In a large mixing bowl, combine the old-fashioned rolled oats, chopped pecans, dried cranberries, unsweetened shredded coconut, pumpkin seeds, ground cinnamon, and salt.",
      "In a separate small bowl, whisk together the maple syrup, melted coconut oil, and vanilla extract.",
      "Pour the wet ingredients over the dry ingredients in the large mixing bowl.",
      "Stir well until all the dry ingredients are coated with the wet mixture, ensuring everything is evenly combined.",
      "Spread the granola mixture in an even layer on the prepared baking sheet.",
      "Bake the crunchy pecan & cranberry granola in the preheated oven for about 15-20 minutes or until it turns golden brown and crispy, stirring the mixture every 5 minutes to ensure even toasting.",
      "Keep a close eye on the granola to prevent it from burning.",
      "Remove the baking sheet from the oven and let the granola cool completely on the sheet. It will continue to crisp up as it cools.",
      "Once cooled, transfer the crunchy pecan & cranberry granola to an airtight container for storage.",
      "Enjoy this delightful and nutritious granola with your favorite yogurt, milk, or as a crunchy snack any time of the day!",
      "Store any leftover granola in an airtight container at room temperature for up to two weeks.",
      "Feel free to customize the granola by adding other nuts, seeds, or dried fruits to suit your taste preferences.",
    ],
    ingredients: [
      {
        ingredient: "Old-fashioned rolled oats",
        unit: "cups",
        quantity: 3,
      },
      {
        ingredient: "Pecans, chopped",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Dried cranberries",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Unsweetened shredded coconut",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Pumpkin seeds (pepitas)",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Maple syrup",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Coconut oil, melted",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoon",
        quantity: 1,
      },
    ],
  },
  {
    title: "Leek and Spinach Tofu Quiche",
    category: "Main",
    time: "60 mins",
    description:
      "Leek and Spinach Tofu Quiche is a delightful and nutritious vegan twist on the classic quiche. A flaky and savory crust holds a flavorful filling made with sautéed leeks, spinach, and crumbled tofu seasoned with aromatic herbs and spices. Baked to perfection, this quiche is a hearty and satisfying dish for any meal of the day!",
    img: "https://cdn.pickuplimes.com/cache/b6/8f/b68f1e2404a1133747d643b0fb7725ea.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/01/41/0141dc139855fbaf24d8846b13dc19f9.jpg",
      "https://cdn.pickuplimes.com/cache/45/9a/459a8bccd7f6f3786d63f358db8f07b1.jpg",
      "https://cdn.pickuplimes.com/cache/e1/4f/e14f5ff0ec5d0054ea23e7013ff0a973.jpg",
      "https://cdn.pickuplimes.com/cache/4b/e6/4be62c33c206df9532bf24e83fe97c1a.jpg",
    ],
    directions: [
      "Preheat the oven to 375°F (190°C). If using a store-bought pie crust, follow the package instructions for pre-baking. If making a homemade crust, pre-bake it in a pie dish for about 10 minutes until lightly golden.",
      "In a pan, heat olive oil over medium heat. Add the sliced leeks and sauté until they become soft and slightly caramelized. Add the fresh spinach leaves and cook until wilted. Remove from heat.",
      "In a bowl, mix the crumbled firm tofu, coconut milk, nutritional yeast, turmeric powder, garlic powder, onion powder, ground black pepper, and salt. Stir until well combined.",
      "Add the sautéed leeks and spinach to the tofu mixture and mix everything together.",
      "Pour the tofu filling into the pre-baked pie crust and spread it evenly.",
      "Bake the quiche in the preheated oven for 30-35 minutes, or until the filling is set and lightly browned on top.",
      "Remove the quiche from the oven and let it cool for a few minutes before slicing and serving.",
      "Enjoy the delicious Leek and Spinach Tofu Quiche as a satisfying and flavorful meal!",
    ],
    ingredients: [
      {
        ingredient: "Pie crust (store-bought or homemade)",
        unit: "",
        quantity: "1",
      },
      {
        ingredient: "Leeks, cleaned and sliced",
        unit: "g",
        quantity: 200,
      },
      {
        ingredient: "Fresh spinach leaves",
        unit: "g",
        quantity: 100,
      },
      {
        ingredient: "Firm tofu, drained and crumbled",
        unit: "g",
        quantity: 300,
      },
      {
        ingredient: "Coconut milk",
        unit: "ml",
        quantity: 200,
      },
      {
        ingredient: "Nutritional yeast",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Turmeric powder",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Onion powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground black pepper",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Vegan Caramel Popcorn",
    category: "Snack",
    time: "30 mins",
    description:
      "Vegan caramel popcorn is a delightful and addictive snack that combines the classic crunch of popcorn with a sweet and gooey caramel coating. This homemade version of caramel popcorn is made without any dairy or animal products, making it a perfect treat for vegans and non-vegans alike.",
    img: "https://cdn.pickuplimes.com/cache/d4/57/d457e16401863ba31ac04f89f6074b02.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/8c/95/8c951040eba66bf377efdd2504cf6276.jpg",
      "https://cdn.pickuplimes.com/cache/d9/27/d92790e74b1ff283022b10d309d9b00f.jpg",
      "https://cdn.pickuplimes.com/cache/3a/15/3a15f9c8f249342f3e14648b4052a292.jpg",
      "https://cdn.pickuplimes.com/cache/72/03/7203659d835e3612f7c954a199d522b3.jpg",
    ],
    directions: [
      "Preheat your oven to 250°F (120°C) and line a large baking sheet with parchment paper.",
      "Spread the popped popcorn evenly on the prepared baking sheet, ensuring there are no large clumps.",
      "In a saucepan over medium heat, melt the vegan butter.",
      "Stir in the brown sugar, maple syrup or agave syrup, vanilla extract, baking soda, and salt.",
      "Bring the mixture to a boil and let it bubble for about 4-5 minutes, stirring occasionally, until it thickens and turns into a caramel sauce.",
      "Remove the saucepan from the heat and carefully pour the hot caramel sauce over the popped popcorn.",
      "Using a spatula or spoon, gently toss the popcorn to evenly coat it with the caramel sauce.",
      "Bake the caramel-coated popcorn in the preheated oven for 15-20 minutes, stirring it every 5 minutes to ensure even coating and prevent burning.",
      "Remove the caramel popcorn from the oven and let it cool completely on the baking sheet. The caramel will continue to harden as it cools.",
      "Once the caramel popcorn has cooled and hardened, break it into bite-sized clusters.",
      "Serve this addictive vegan caramel popcorn as a delicious snack for movie nights, parties, or any time you crave a sweet and crunchy treat!",
      "Store any leftover caramel popcorn in an airtight container at room temperature for up to a week.",
    ],
    ingredients: [
      {
        ingredient: "Popped popcorn",
        unit: "cups",
        quantity: 8,
      },
      {
        ingredient: "Vegan butter",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Brown sugar",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Maple syrup or agave syrup",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Baking soda",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Vibrant Roasted Beetroot Hummus",
    category: "Appetizer",
    time: "60 mins",
    description:
      "Vibrant roasted beetroot hummus is a visually stunning and delicious twist on classic hummus. The addition of roasted beetroots gives this hummus a beautiful pink color and a slightly sweet and earthy flavor that pairs perfectly with the creaminess of the chickpeas and tahini.",
    img: "https://cdn.pickuplimes.com/cache/4a/f4/4af4bfcc944fcccab0a4ae28495aae72.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/ca/fa/cafa719fe7b62b421808a8e28bc1f26c.jpg",
      "https://cdn.pickuplimes.com/cache/48/64/486466fbbec13199c09ae0dab993194b.jpg",
      "https://cdn.pickuplimes.com/cache/9f/64/9f641c2b02d3b06d5c9de388e6386fcc.jpg",
      "https://cdn.pickuplimes.com/cache/0d/21/0d217b5a403df5975b92e908ee57a0b9.jpg",
    ],
    directions: [
      "Preheat your oven to 400°F (200°C) and line a baking sheet with parchment paper.",
      "Place the peeled and cut beetroot chunks on the prepared baking sheet and drizzle them with a little olive oil. Toss to coat the beetroots evenly with the oil.",
      "Roast the beetroots in the preheated oven for about 30-40 minutes or until they are tender when pierced with a fork. Let them cool slightly before using.",
      "In a food processor, combine the roasted beetroots, cooked chickpeas, tahini, minced garlic, lemon juice, ground cumin, ground coriander, salt, and black pepper.",
      "Pulse the ingredients until they start to come together.",
      "While the food processor is running, slowly drizzle in the extra virgin olive oil and water, and continue to blend until the hummus reaches a smooth and creamy consistency.",
      "Taste the roasted beetroot hummus and adjust the seasonings to your liking, adding more salt, lemon juice, or spices if desired.",
      "Transfer the vibrant roasted beetroot hummus to a serving bowl.",
      "Garnish the hummus with chopped fresh parsley and toasted sesame seeds for added flavor and presentation.",
      "Serve the hummus with pita bread, vegetable sticks, or crackers for a colorful and delicious appetizer or snack.",
      "Enjoy the delightful combination of flavors and the beautiful color in this vibrant roasted beetroot hummus!",
    ],
    ingredients: [
      {
        ingredient: "Beetroots, peeled and cut into chunks",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Cooked chickpeas",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Tahini",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground coriander",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Extra virgin olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh parsley, chopped (for garnish)",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Toasted sesame seeds (for garnish)",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Aloo Matar",
    category: "Main",
    time: "30 mins",
    description:
      "Aloo Matar is a classic Indian vegetarian dish that combines potatoes (aloo) and green peas (matar) in a flavorful spiced tomato-based sauce. This comforting and hearty dish is perfect served with rice or Indian bread like roti or naan.",
    img: "https://cdn.pickuplimes.com/cache/47/0d/470d2c1f1353eea683a540505ca2fba8.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/a1/a4/a1a48cbbf2b7ebfbc234b29ebd431fd7.jpg",
      "https://cdn.pickuplimes.com/cache/d1/2f/d12f0382d230ecb5e7fc92cb387fba90.jpg",
      "https://cdn.pickuplimes.com/cache/55/98/55984d4835906d1a9ed8e9057ee7b002.jpg",
      "https://cdn.pickuplimes.com/cache/92/32/9232596c319b4bc70ea8afb894e60607.jpg",
    ],
    directions: [
      "In a large pan, heat vegetable oil over medium heat. Add cumin seeds and let them splutter.",
      "Add the finely chopped onion and sauté until it becomes translucent.",
      "Stir in the ginger-garlic paste and cook for a minute until the raw smell disappears.",
      "Add the diced potatoes and green peas to the pan. Mix well with the onion mixture.",
      "Pour in the pureed tomatoes and stir to coat the potatoes and peas with the tomato sauce.",
      "Add turmeric powder, ground coriander, red chili powder, garam masala, and salt. Mix all the spices well with the vegetables.",
      "Pour water into the pan and bring the mixture to a simmer. Cover the pan with a lid and let it cook for about 15-20 minutes until the potatoes are tender and the peas are cooked.",
      "Check the seasoning and adjust salt and spices if needed.",
      "Garnish the Aloo Matar with chopped fresh cilantro before serving.",
      "Serve the delicious Aloo Matar with steamed rice or Indian bread and enjoy this flavorful Indian dish!",
    ],
    ingredients: [
      {
        ingredient: "Potatoes, peeled and diced",
        unit: "medium",
        quantity: 3,
      },
      {
        ingredient: "Green peas",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Cumin seeds",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Onion, finely chopped",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Ginger-garlic paste",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Tomatoes, pureed",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Turmeric powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground coriander",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Red chili powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Garam masala",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Water",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh cilantro, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Vegan Chocolate Buttercream Frosting",
    category: "Dessert",
    time: "15 mins",
    description:
      "Vegan Chocolate Buttercream Frosting is a decadent and creamy frosting that's entirely plant-based and perfect for any chocolate lover. This luscious frosting is made with simple and vegan-friendly ingredients, including vegan butter or coconut oil, cocoa powder, powdered sugar, and a touch of non-dairy milk (such as almond, soy, or oat milk). The ingredients are whipped together until smooth and fluffy, creating a rich and velvety frosting with a deep chocolate flavor. This versatile frosting is perfect for spreading over cakes, cupcakes, or cookies, and it's sure to elevate any dessert with its delightful taste and luxurious texture. Whether you're frosting a birthday cake or simply enjoying a sweet treat, this Vegan Chocolate Buttercream Frosting is a delightful addition to your plant-based dessert repertoire.",
    img: "https://cdn.pickuplimes.com/cache/e9/a8/e9a8b0102ca2ee0436f2bc67ad0a3a9f.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/3a/1a/3a1a022fd14743d1902ba4b11e1a7a00.jpg",
      "https://cdn.pickuplimes.com/cache/58/31/5831b2627144d553ff5326945e08dea3.jpg",
      "https://cdn.pickuplimes.com/cache/8d/0e/8d0e0f1a0f48df34f357947089abcfdd.jpg",
      "https://cdn.pickuplimes.com/cache/41/e3/41e372d62478f5d7bd21ec5d1288c293.jpg",
    ],
    directions: [
      "In a large mixing bowl, beat the vegan butter with an electric mixer until creamy and smooth.",
      "Add the powdered sugar, cocoa powder, non-dairy milk, vanilla extract, and a pinch of salt to the bowl.",
      "Start mixing on low speed to avoid the powdered sugar and cocoa powder from flying everywhere. Gradually increase the speed to medium-high as the ingredients come together.",
      "Continue beating until all the ingredients are well combined, and the frosting is smooth and fluffy.",
      "Taste the frosting and adjust the sweetness or chocolate flavor if needed. You can add more powdered sugar for sweetness or more cocoa powder for a richer chocolate taste.",
      "Once the desired consistency and taste are achieved, the vegan chocolate buttercream frosting is ready to use.",
      "Spread the frosting over your cake or cupcakes using a spatula or pipe it onto your desserts for a more decorative finish.",
      "Enjoy the luscious and velvety vegan chocolate buttercream frosting on your favorite cakes, cupcakes, or any other sweet treats!",
      "Store any leftover frosting in an airtight container in the refrigerator for future use.",
    ],
    ingredients: [
      {
        ingredient: "Vegan butter (at room temperature)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Powdered sugar",
        unit: "cups",
        quantity: 3,
      },
      {
        ingredient: "Cocoa powder",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Non-dairy milk",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Pinch of salt",
        unit: "pinch",
        quantity: null,
      },
    ],
  },
  {
    title: "Nutty Granola Apple Bites",
    category: "Snack",
    time: "15 mins",
    description:
      "Nutty granola apple bites are a delicious and healthy snack that combines the natural sweetness of apples with the crunchy and nutty goodness of granola. These bite-sized treats are easy to make and perfect for satisfying your sweet tooth while providing a nutritious boost of fiber and vitamins.",
    img: "https://cdn.pickuplimes.com/cache/ac/dc/acdcdcdd4d401ef7da72a9c9716a1b1b.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/23/3c/233cd84b8e4cf7767c314b48b2754d68.jpg",
      "https://cdn.pickuplimes.com/cache/4a/c6/4ac633ba696c332845b6267bfe63f832.jpg",
      "https://cdn.pickuplimes.com/cache/70/4a/704a0c20212a0af800c078fa49dd44ae.jpg",
      "https://cdn.pickuplimes.com/cache/ca/84/ca8428771c6392b4ef5a79aafdd54b23.jpg",
    ],
    directions: [
      "Wash the apples and slice them horizontally into rounds, about 1/2 inch thick.",
      "Using a small cookie cutter or a knife, remove the core and seeds from each apple round to create a small hole in the center.",
      "Spread a thin layer of creamy nut butter on each apple round, covering the entire surface.",
      "Sprinkle the granola, chopped nuts, and dried cranberries or raisins over the nut butter layer on each apple round.",
      "If desired, drizzle a little honey or maple syrup over the toppings for added sweetness.",
      "Arrange the nutty granola apple bites on a serving platter and enjoy them immediately.",
      "These delicious and nutritious bites can be made ahead of time and stored in the refrigerator until serving.",
      "Serve the nutty granola apple bites as a delightful and satisfying snack or a fun addition to any party or gathering!",
      "Feel free to get creative with the toppings and use different types of granola, nuts, and dried fruits for variety.",
    ],
    ingredients: [
      {
        ingredient: "Apples (any crisp variety)",
        unit: "medium-sized",
        quantity: 3,
      },
      {
        ingredient: "Creamy nut butter (such as almond or peanut)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Granola (homemade or store-bought)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Chopped nuts (such as almonds or walnuts)",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Dried cranberries or raisins",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Honey or maple syrup (for drizzling, optional)",
        unit: "for drizzling",
        quantity: null,
      },
    ],
  },
  {
    title: "Zucchini Rolls with Vegan Ricotta Cheese",
    category: "Appetizer",
    time: "40 mins",
    description:
      "Zucchini rolls with vegan ricotta cheese are a delectable and healthy appetizer or light meal option. Thinly sliced zucchini is filled with a creamy and dairy-free ricotta cheese mixture, creating a flavorful and satisfying dish that is perfect for vegans and anyone looking for a delightful twist on traditional rolls.",
    img: "https://cdn.pickuplimes.com/cache/34/11/34111be5f48f5af4b55c3748fcea00c9.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/a5/85/a585077f7e278cb1f055093db78e0585.jpg",
      "https://cdn.pickuplimes.com/cache/13/66/1366a78287e954554b4218b3ad24660c.jpg",
      "https://cdn.pickuplimes.com/cache/11/af/11af560ba5168f77f3255eb9582868bc.jpg",
      "https://cdn.pickuplimes.com/cache/7f/3e/7f3eca778adcff48bb60fdb82ac10dff.jpg",
    ],
    directions: [
      "Preheat your oven to 400°F (200°C).",
      "Using a mandoline slicer or a sharp knife, thinly slice the zucchini lengthwise into long strips.",
      "In a bowl, combine the zucchini slices with extra virgin olive oil, salt, and black pepper. Toss gently to coat the zucchini evenly.",
      "Place the zucchini slices on a baking sheet lined with parchment paper, making sure they don't overlap.",
      "Roast the zucchini slices in the preheated oven for about 5-7 minutes or until they become slightly softened. Be careful not to overcook them, as they will be rolled later.",
      "While the zucchini slices are roasting, prepare the vegan ricotta cheese filling. In a bowl, mix the vegan ricotta cheese, chopped fresh basil, chopped fresh parsley, lemon zest, and garlic powder until well combined.",
      "Remove the zucchini slices from the oven and let them cool slightly.",
      "Spread a thin layer of the vegan ricotta cheese mixture onto each zucchini slice.",
      "Place a few halved cherry tomatoes at one end of each zucchini slice.",
      "Carefully roll up each zucchini slice to form a beautiful zucchini roll.",
      "Arrange the zucchini rolls on a serving platter and drizzle them with balsamic glaze for added sweetness and tang.",
      "Serve the zucchini rolls with vegan ricotta cheese as an elegant and flavorful appetizer or a light and satisfying meal.",
      "Enjoy these delicious and nutritious zucchini rolls as a delightful vegan treat!",
    ],
    ingredients: [
      {
        ingredient: "Zucchini",
        unit: "2 medium",
        quantity: null,
      },
      {
        ingredient: "Extra virgin olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Vegan ricotta cheese",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh basil leaves, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh parsley, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Lemon zest",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Cherry tomatoes, halved",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Balsamic glaze",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Chipotle Refried Beans",
    category: "Appetizer",
    time: "25 mins",
    description:
      "Chipotle refried beans are a smoky and flavorful twist on the classic refried beans. These beans are cooked with chipotle peppers in adobo sauce, giving them a delicious spicy kick and a hint of smokiness. They are a perfect side dish or filling for burritos, tacos, and enchiladas.",
    img: "https://cdn.pickuplimes.com/cache/08/a4/08a4e6c1afd7292fed4f8ee91c200ec5.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/a7/2c/a72ccf2065db0cb91524e9a892429047.jpg",
      "https://cdn.pickuplimes.com/cache/e2/bf/e2bf90be421d832f86739185b7a4af3e.jpg",
      "https://cdn.pickuplimes.com/cache/0e/1d/0e1d3a4b9ccb27ea4b8ecc1e49fca1ac.jpg",
      "https://cdn.pickuplimes.com/cache/cf/72/cf72aa8b58a457c500e1c6b102a44d21.jpg",
    ],
    directions: [
      "In a large skillet or frying pan, heat the vegetable oil over medium heat.",
      "Add the finely chopped onion and minced garlic to the pan. Sauté for about 2-3 minutes or until the onions become translucent and fragrant.",
      "Add the ground cumin and ground coriander to the pan. Stir and cook for an additional minute to toast the spices.",
      "Add the cooked pinto beans to the pan, along with the chipotle peppers in adobo sauce. Use a spoon to mash some of the beans while leaving some whole for texture.",
      "Pour in the vegetable broth or water to the pan to help create a creamy consistency. Stir the beans and let them cook for about 5-7 minutes, allowing the flavors to meld together.",
      "Season the chipotle refried beans with salt and black pepper to taste.",
      "Squeeze fresh lime juice over the beans and give them a final stir.",
      "Remove the pan from the heat, and garnish the chipotle refried beans with chopped fresh cilantro.",
      "Serve the flavorful chipotle refried beans as a delicious side dish or use them as a filling for burritos, tacos, or enchiladas.",
      "Enjoy the smoky and spicy goodness of these chipotle-infused refried beans!",
    ],
    ingredients: [
      {
        ingredient: "Cooked pinto beans",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Chipotle peppers in adobo sauce",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Onion, finely chopped",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground coriander",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Vegetable broth or water",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Fresh lime juice",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Fresh cilantro, chopped (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Vegan Chocolate Cake",
    category: "Dessert",
    time: "60 mins",
    description:
      "Vegan Chocolate Cake is a decadent and moist cake that proves you don't need eggs or dairy to create a delectable dessert. This chocolate cake is made using plant-based ingredients such as non-dairy milk (like almond, soy, or coconut milk), vegetable oil or vegan butter, and a combination of all-purpose flour, cocoa powder, and sugar. The secret to its rich and chocolaty flavor is the addition of vegan chocolate chips or cocoa in the batter. Once baked to perfection, you can frost this cake with a luscious vegan chocolate frosting or indulge in its simple goodness as is. This vegan chocolate cake is a delightful treat for vegans and non-vegans alike, and it proves that plant-based desserts can be just as satisfying and delicious as traditional ones.",
    img: "https://cdn.pickuplimes.com/cache/3e/db/3edbe8d2b6690ce42b4bbc5a81f42afc.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/61/56/6156c790a282efbef201ca6ef4036171.jpg",
      "https://cdn.pickuplimes.com/cache/ad/33/ad335dd7382d6a2f505c67e486cf0e31.jpg",
      "https://cdn.pickuplimes.com/cache/8a/b3/8ab3cbd83b07e312537315f8fc11b471.jpg",
      "https://cdn.pickuplimes.com/cache/2c/37/2c37fb7549cbfea083d70fe3482a1d97.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C). Grease and flour two 8-inch round cake pans or line them with parchment paper.",
      "In a large mixing bowl, whisk together the all-purpose flour, granulated sugar, cocoa powder, baking powder, baking soda, and salt.",
      "Add the vegetable oil, almond milk, applesauce, and vanilla extract to the dry ingredients.",
      "Mix the ingredients until the batter is smooth and well combined. Be careful not to overmix.",
      "Stir in the boiling water into the batter. The batter will be thin, which is normal.",
      "Divide the batter evenly between the prepared cake pans.",
      "Bake the cakes in the preheated oven for about 25-30 minutes or until a toothpick inserted into the center comes out clean.",
      "Once baked, remove the cakes from the oven and let them cool in the pans for about 10 minutes before transferring them to a wire rack to cool completely.",
      "If desired, you can frost the cooled cakes with vegan chocolate ganache or any other frosting of your choice.",
      "Optionally, garnish the vegan chocolate cake with fresh berries and dust with powdered sugar for a decorative touch.",
      "Slice and serve this delicious vegan chocolate cake to enjoy a delectable dessert that is free from animal products.",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Granulated sugar",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Cocoa powder",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Baking soda",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Vegetable oil",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Almond milk (or any non-dairy milk)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Applesauce",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Boiling water",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Vegan chocolate ganache (for frosting, optional)",
        unit: "for frosting",
        quantity: null,
      },
      {
        ingredient: "Fresh berries (for garnish, optional)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Powdered sugar (for dusting, optional)",
        unit: "for dusting",
        quantity: null,
      },
    ],
  },
  {
    title: "Double Tomato Bruschetta with Balsamic Reduction",
    category: "Appetizer",
    time: "20 mins",
    description:
      "Double tomato bruschetta with balsamic reduction is a vibrant and flavorful appetizer that celebrates the goodness of ripe tomatoes. This classic Italian dish features a delicious combination of fresh tomatoes, sun-dried tomatoes, garlic, basil, and a drizzle of balsamic reduction on crispy toasted bread slices.",
    img: "https://cdn.pickuplimes.com/cache/bc/00/bc003ebfd088fe4b1296eda86ca2687b.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/95/db/95db2d8ba5a2e1632f02ee460f7172b6.jpg",
      "https://cdn.pickuplimes.com/cache/0d/0e/0d0e6867adebda16444ae81c1858e69d.jpg",
      "https://cdn.pickuplimes.com/cache/11/5c/115ce28193e4a46be95fb64a14089951.jpg",
      "https://cdn.pickuplimes.com/cache/73/e8/73e8c601a050e36ef0ff653133f15e98.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the diced ripe tomatoes, chopped sun-dried tomatoes, thinly sliced fresh basil leaves, minced garlic, balsamic vinegar, extra virgin olive oil, salt, and black pepper.",
      "Gently toss all the ingredients until they are well combined. Let the mixture sit for about 10 minutes to allow the flavors to meld together.",
      "While the tomato mixture is resting, toast the bread slices. You can do this by placing the slices on a baking sheet and broiling them in the oven for a few minutes on each side until they become lightly crispy.",
      "Once the bread slices are toasted, you can rub them with a garlic clove for extra flavor.",
      "To assemble the double tomato bruschetta, top each toasted bread slice with a generous spoonful of the tomato mixture.",
      "Drizzle a little balsamic reduction over the bruschetta for added sweetness and tang.",
      "Garnish the bruschetta with additional fresh basil leaves for presentation.",
      "Serve the double tomato bruschetta immediately as a delightful and refreshing appetizer.",
      "Enjoy the burst of flavors in this classic Italian bruschetta with the sweetness of ripe tomatoes and the tanginess of balsamic reduction!",
    ],
    ingredients: [
      {
        ingredient: "Ripe tomatoes, diced",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Sun-dried tomatoes in oil, drained and chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh basil leaves, thinly sliced",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Balsamic vinegar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Extra virgin olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Baguette or Italian bread, sliced",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Balsamic reduction (store-bought or homemade)",
        unit: "for drizzling",
        quantity: null,
      },
      {
        ingredient: "Fresh basil leaves, for garnish",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Candied Coconut & Cinnamon Pecans",
    category: "Snack",
    time: "20 mins",
    description:
      "Candied coconut & cinnamon pecans are a delightful and addictive snack that combines the rich flavor of pecans with the sweet and tropical taste of candied coconut. These oven-roasted pecans are coated in a delicious blend of coconut, cinnamon, and a touch of sweetness, making them a perfect treat for parties or as a homemade gift.",
    img: "https://cdn.pickuplimes.com/cache/8c/b7/8cb70790fd59cbbd9659c30d3c8c4260.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/64/51/6451d9df4e058bbb2266a12f74225557.jpg",
      "https://cdn.pickuplimes.com/cache/40/2e/402e61a8e432250c2c96a4744a4bfe31.jpg",
      "https://cdn.pickuplimes.com/cache/39/c4/39c4aab576fe611223a44ada705d98e8.jpg",
      "https://cdn.pickuplimes.com/cache/7d/4a/7d4a94d751a55dc277cc7e536876b420.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C) and line a baking sheet with parchment paper.",
      "In a bowl, combine the pecans and shredded coconut.",
      "In a separate small bowl, whisk together the melted coconut oil, maple syrup, ground cinnamon, vanilla extract, and salt until well combined.",
      "Pour the coconut oil mixture over the pecans and coconut, and toss them until they are evenly coated.",
      "Spread the coated pecans and coconut in a single layer on the prepared baking sheet.",
      "Bake the candied coconut & cinnamon pecans in the preheated oven for about 10-12 minutes, stirring halfway through the baking time to ensure even coating.",
      "Keep an eye on them to prevent burning, as the coconut can brown quickly.",
      "Remove the baking sheet from the oven and let the pecans cool completely on the sheet.",
      "As they cool, the candied coconut & cinnamon pecans will become crunchy and delicious.",
      "Once cooled, transfer the pecans to an airtight container for storage.",
      "Enjoy these delectable candied coconut & cinnamon pecans as a delightful and irresistible snack or as a topping for salads, desserts, or yogurt!",
      "Store any leftover pecans in an airtight container at room temperature for up to two weeks.",
    ],
    ingredients: [
      {
        ingredient: "Pecans",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Shredded coconut (unsweetened)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Coconut oil, melted",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Saucy Beans on Garlic Toast",
    category: "Breakfast",
    time: "20 mins",
    description:
      "Saucy beans on garlic toast is a flavorful and comforting dish. It features a rich tomato-based sauce with tender beans served over crispy garlic toast.",
    img: "https://cdn.pickuplimes.com/cache/fe/a9/fea97238f36044081eebba2b949aaf7b.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/ef/87/ef87a16dd65935edca845907643e1cbf.jpg",
      "https://cdn.pickuplimes.com/cache/06/e3/06e3de0407ed8ee1f23b69a4ad4b5d7f.jpg",
      "https://cdn.pickuplimes.com/cache/8b/c3/8bc3d5b1baf6a8600dd43ae8091f7310.jpg",
      "https://cdn.pickuplimes.com/cache/e3/2f/e32f4ecfec2d3828aaf943cb5a81f571.jpg",
    ],
    directions: [
      "In a saucepan, heat 1 tablespoon of olive oil over medium heat. Add the finely chopped onion and cook until translucent.",
      "Add the minced garlic and cook for another minute until fragrant.",
      "Stir in the crushed tomatoes, tomato paste, vegetable broth, dried oregano, dried basil, red pepper flakes (if using), salt, and black pepper.",
      "Simmer the sauce on low heat for about 10 minutes, allowing the flavors to meld together. If the sauce becomes too thick, you can add a splash of water or broth to adjust the consistency.",
      "While the sauce is simmering, prepare the garlic toast. Mix the softened butter with minced garlic and spread it over the bread slices. Toast the bread slices in a toaster oven or regular oven until they are golden and crispy.",
      "Once the sauce has thickened and the flavors have developed, add the canned beans (drained and rinsed) to the sauce. Stir well to coat the beans in the flavorful sauce.",
      "Let the beans simmer in the sauce for an additional 5 minutes to heat through.",
      "To serve, place a generous ladle of saucy beans over each garlic toast slice.",
      "Garnish with chopped fresh parsley for a pop of color and added freshness.",
      "Enjoy the saucy beans on garlic toast while they're warm and flavorful!",
    ],
    ingredients: [
      {
        ingredient: "Canned beans (e.g., kidney beans, black beans)",
        unit: "oz",
        quantity: 15,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Onion, finely chopped",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "cloves",
        quantity: 2,
      },
      {
        ingredient: "Crushed tomatoes",
        unit: "cup",
        quantity: 1,
      },
      {
        ingredient: "Tomato paste",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Vegetable broth",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Dried oregano",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Dried basil",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Red pepper flakes (optional)",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Bread slices (e.g., baguette slices)",
        unit: "slices",
        quantity: 4,
      },
      {
        ingredient: "Butter, softened",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh parsley, chopped (for garnish)",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Super Seed Stuffed Dates",
    category: "Snack",
    time: "15 mins",
    description:
      "Super seed stuffed dates are a delicious and nutritious snack that combines the natural sweetness of dates with a crunchy and flavorful mix of super seeds. These stuffed dates are packed with a variety of seeds such as chia, flax, pumpkin, and sunflower seeds, providing a boost of protein, fiber, and essential nutrients. They are perfect for satisfying your sweet cravings while providing a healthy energy boost.",
    img: "https://cdn.pickuplimes.com/cache/2d/e8/2de851076124ca08c381ec4228092978.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/cd/e3/cde3070c5f44d7608a6a3b641907fee2.jpg",
      "https://cdn.pickuplimes.com/cache/10/c6/10c6fff54f11edfbc32a9f9908b06092.jpg",
      "https://cdn.pickuplimes.com/cache/08/e8/08e823d7318f85598644c27a4624efa8.jpg",
      "https://cdn.pickuplimes.com/cache/96/04/9604e0a9b7a51bdd188cb3737b0abab7.jpg",
    ],
    directions: [
      "Using a sharp knife, make a lengthwise cut along one side of each Medjool date to create an opening for stuffing.",
      "Remove the pits from the dates, if necessary.",
      "In a small bowl, mix together the chia seeds, flax seeds, pumpkin seeds, sunflower seeds, almond butter, shredded coconut, and cinnamon (if using).",
      "Scoop about a teaspoon of the super seed mixture into each date, pressing it gently to fill the cavity.",
      "If the dates don't close completely after stuffing, you can use your fingers to gently press the sides together.",
      "Once all the dates are stuffed, they are ready to be enjoyed!",
      "These super seed stuffed dates make for a delightful and nutritious snack that's perfect for satisfying your sweet tooth and providing a quick energy boost.",
      "Store any leftover stuffed dates in an airtight container in the refrigerator for up to a week.",
      "Feel free to experiment with the seed mixture and use your favorite combination of seeds and nuts for the stuffing.",
    ],
    ingredients: [
      {
        ingredient: "Medjool dates",
        unit: "10",
        quantity: null,
      },
      {
        ingredient: "Chia seeds",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Flax seeds",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Pumpkin seeds",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Sunflower seeds",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Almond butter (or any nut butter of choice)",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Unsweetened shredded coconut",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Cinnamon (optional, for added flavor)",
        unit: "teaspoon",
        quantity: null,
      },
    ],
  },
  {
    title: "Vegan Red Pesto",
    category: "Appetizer",
    time: "10 mins",
    description:
      "Vegan red pesto is a delightful and versatile sauce made without cheese or any animal products. This flavorful pesto features sun-dried tomatoes, basil, garlic, and nuts, making it a perfect accompaniment to pasta, sandwiches, or as a dip for vegetables.",
    img: "https://cdn.pickuplimes.com/cache/40/84/4084716f213ee9f2c6003f2be22fe96c.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/47/1c/471c014b0f9f6b9d338942d085f04311.jpg",
      "https://cdn.pickuplimes.com/cache/27/08/270811d79be55e67eaba1b427245b05f.jpg",
      "https://cdn.pickuplimes.com/cache/b1/e1/b1e1e51ba8982038ae2b4b8d994119fb.jpg",
      "https://cdn.pickuplimes.com/cache/11/e9/11e9a1e58fadf99e992b900784bcd1cd.jpg",
    ],
    directions: [
      "In a food processor, combine the sun-dried tomatoes, fresh basil leaves, toasted pine nuts or walnuts, and peeled garlic cloves.",
      "Pulse the ingredients until they are finely chopped and well combined.",
      "Add the nutritional yeast, lemon juice, extra virgin olive oil, salt, and black pepper to the food processor.",
      "Process the mixture until it forms a smooth and creamy pesto sauce.",
      "Taste the vegan red pesto and adjust the seasoning, adding more salt or lemon juice if desired.",
      "Transfer the pesto sauce to a jar or airtight container for storage.",
      "You can use the vegan red pesto immediately or refrigerate it for later use.",
      "Enjoy the delicious and dairy-free vegan red pesto as a pasta sauce, a spread for sandwiches, a dip for vegetables, or a flavorful addition to various dishes!",
    ],
    ingredients: [
      {
        ingredient: "Sun-dried tomatoes (packed in oil)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh basil leaves",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Toasted pine nuts or walnuts",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Garlic cloves, peeled",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Nutritional yeast",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Extra virgin olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Potato Crisps with Creamy Tahini Dill Dip",
    category: "Snack",
    time: "30 mins",
    description:
      "Potato crisps with creamy tahini dill dip are a delightful and flavorful snack that combines the crispy goodness of potato chips with a creamy and tangy dip. This homemade version is much healthier and tastier than store-bought chips, making it perfect for parties or a satisfying treat anytime.",
    img: "https://cdn.pickuplimes.com/cache/1d/32/1d32a53fc431acf97ff39c49fd2ddbd6.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/c5/5e/c55eb7e5882f2c2169f5a29b208bf050.jpg",
      "https://cdn.pickuplimes.com/cache/12/46/1246fd238d7ccc586d7ebf32293045cf.jpg",
      "https://cdn.pickuplimes.com/cache/5b/e6/5be619f1f262b67ae81a6231a6f266e6.jpg",
      "https://cdn.pickuplimes.com/cache/3e/2d/3e2dd9361117c9fc4c709acedca2844e.jpg",
    ],
    directions: [
      "Preheat your oven to 400°F (200°C) and line a baking sheet with parchment paper.",
      "Wash and slice the potatoes into thin rounds using a sharp knife or a mandoline slicer for even thickness.",
      "In a large bowl, toss the potato slices with olive oil, sea salt, and black pepper until they are well coated.",
      "Arrange the potato slices in a single layer on the prepared baking sheet, making sure they do not overlap.",
      "Bake the potato crisps in the preheated oven for about 20-25 minutes or until they are golden and crispy. Flip them halfway through baking to ensure even cooking.",
      "While the potato crisps are baking, prepare the creamy tahini dill dip.",
      "In a small bowl, whisk together the tahini, chopped fresh dill, lemon juice, garlic powder, water, and salt and pepper to taste.",
      "Adjust the seasoning and consistency of the dip according to your preference by adding more lemon juice, water, or salt and pepper.",
      "Once the potato crisps are done, remove them from the oven and let them cool slightly.",
      "Serve the potato crisps with the creamy tahini dill dip, and enjoy this delicious and healthier alternative to traditional chips and dip.",
      "Store any leftover potato crisps in an airtight container for a crispy snack later.",
      "Refrigerate any remaining dip in a sealed container for up to a week.",
    ],
    ingredients: [
      {
        ingredient: "Potatoes (russet or Yukon gold)",
        unit: "large",
        quantity: 3,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Sea salt",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Tahini",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Fresh dill, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt and pepper",
        unit: "to taste",
        quantity: null,
      },
    ],
  },
  {
    title: "Toasted Coconut & Almond Granola",
    category: "Breakfast",
    time: "25 mins",
    description:
      "Toasted coconut & almond granola is a crunchy and flavorful mix that makes for a delightful breakfast or snack. It's filled with the goodness of oats, toasted coconut, and crunchy almonds, sweetened with a touch of honey or maple syrup.",
    img: "https://cdn.pickuplimes.com/cache/64/5f/645fb895ceeefcfd33d5b6c1c0b821f5.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/b2/4d/b24d4ecabac74f38617e8bb75b0759f6.jpg",
      "https://cdn.pickuplimes.com/cache/e3/6e/e36e0cd9a9996442de3d5435f92bc918.jpg",
      "https://cdn.pickuplimes.com/cache/e9/c2/e9c2c8b3eb175999af506708700fc83e.jpg",
      "https://cdn.pickuplimes.com/cache/f9/24/f924cbdd66ddb80c694a5921f9fe4495.jpg",
    ],
    directions: [
      "Preheat your oven to 300°F (150°C) and line a baking sheet with parchment paper.",
      "In a large mixing bowl, combine the rolled oats, coconut flakes, and chopped almonds.",
      "In a separate small bowl, mix the honey or maple syrup, melted coconut oil, vanilla extract, cinnamon, and salt until well combined.",
      "Pour the wet mixture over the dry ingredients and toss everything together until the oats, coconut, and almonds are evenly coated.",
      "Spread the granola mixture in an even layer on the prepared baking sheet.",
      "Bake in the preheated oven for 15-20 minutes or until the granola turns golden brown, stirring halfway through to ensure even toasting.",
      "If you prefer clumps in your granola, press the mixture down with a spatula after stirring it halfway through baking.",
      "Once the granola is toasted to your desired level, remove it from the oven and let it cool completely on the baking sheet. It will crisp up as it cools.",
      "If you'd like to add dried fruit to your granola, mix it in after the granola has cooled.",
      "Transfer the toasted coconut & almond granola to an airtight container for storage. It will stay fresh and crunchy for up to two weeks.",
      "Enjoy the granola as a topping for yogurt, as a cereal with plant-based milk, or as a delightful snack on its own!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 3,
      },
      {
        ingredient: "Coconut flakes",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Almonds, chopped",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Honey or maple syrup",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Coconut oil, melted",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Dried fruit (e.g., cranberries, raisins) (optional)",
        unit: "cup",
        quantity: null,
      },
    ],
  },
  {
    title: "Vegan 'Honey' Mustard Tofu Wraps",
    category: "Main",
    time: "30 mins",
    description:
      "These Vegan 'Honey' Mustard Tofu Wraps are a delicious and wholesome plant-based meal. Crispy tofu is coated in a sweet and tangy 'honey' mustard sauce, then wrapped with fresh veggies in a tortilla. Perfect for a quick lunch or dinner!",
    img: "https://cdn.pickuplimes.com/cache/97/9d/979d97e954be26d7e3d28a47ffc2a547.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/16/df/16dfa62debecbf667dabccb41e325495.jpg",
      "https://cdn.pickuplimes.com/cache/ab/47/ab47ee29ba6c2928eea14646321da7d9.jpg",
      "https://cdn.pickuplimes.com/cache/2f/95/2f95d3bdbdb14275022d5caeae56fc21.jpg",
      "https://cdn.pickuplimes.com/cache/9f/c2/9fc2d1c15c15c51061274a7771139bcf.jpg",
    ],
    directions: [
      "Press the tofu to remove excess water, then slice it into thin strips.",
      "In a shallow bowl, mix the flour, cornstarch, salt, black pepper, garlic powder, onion powder, and paprika.",
      "Dredge the tofu strips in the flour mixture, shaking off any excess.",
      "Heat vegetable oil in a skillet over medium-high heat. Fry the tofu strips until they are golden and crispy on all sides. Set aside on a paper towel-lined plate.",
      "In a small bowl, whisk together the vegan mayonnaise, Dijon mustard, maple syrup, apple cider vinegar, and agave nectar to make the 'honey' mustard sauce.",
    ],
    ingredients: [
      {
        ingredient: "Firm tofu, drained and pressed",
        unit: "g",
        quantity: 400,
      },
      {
        ingredient: "Flour",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Cornstarch",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Onion powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Paprika",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Tortillas",
        unit: "large",
        quantity: 4,
      },
      {
        ingredient: "Lettuce leaves",
        unit: "leaves",
        quantity: 4,
      },
      {
        ingredient: "Tomato, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Red onion, thinly sliced",
        unit: "small",
        quantity: 1,
      },
      {
        ingredient: "Pickle slices",
        unit: "pieces",
        quantity: 8,
      },
      {
        ingredient: "Vegan mayonnaise",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Dijon mustard",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Apple cider vinegar",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Agave nectar",
        unit: "tablespoons",
        quantity: 1,
      },
    ],
  },
  {
    title: "Balsamic & Basil Bruschetta",
    category: "Appetizer",
    time: "20 mins",
    description:
      "Balsamic & basil bruschetta is a classic and refreshing Italian appetizer that celebrates the flavors of ripe tomatoes, fresh basil, and tangy balsamic vinegar. This simple yet delightful dish is perfect for entertaining guests or as a light and flavorful snack.",
    img: "https://cdn.pickuplimes.com/cache/3c/02/3c02c30fbeb05e6899c55b81b98ebc9d.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/eb/37/eb37074569d56a29d1188d3aa6716ce7.jpg",
      "https://cdn.pickuplimes.com/cache/36/97/36974e73ebcd152a091ff4525a62eea1.jpg",
      "https://cdn.pickuplimes.com/cache/a4/d5/a4d53780250eb05a8a0d0b0fa3d63bd8.jpg",
      "https://cdn.pickuplimes.com/cache/24/fb/24fb330cb328b9fce828df158838f662.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the diced ripe tomatoes, chopped fresh basil, minced garlic, balsamic vinegar, extra virgin olive oil, salt, and black pepper.",
      "Gently toss all the ingredients until they are well combined. Let the mixture sit for about 10 minutes to allow the flavors to meld together.",
      "While the tomato mixture is resting, toast the bread slices. You can do this by placing the slices on a baking sheet and broiling them in the oven for a few minutes on each side until they become lightly crispy.",
      "Once the bread slices are toasted, you can rub them with a garlic clove for extra flavor.",
      "To assemble the balsamic & basil bruschetta, top each toasted bread slice with a generous spoonful of the tomato mixture.",
      "Drizzle a little balsamic vinegar over the bruschetta for added sweetness and tang.",
      "Serve the balsamic & basil bruschetta immediately as a delightful and refreshing appetizer or snack.",
      "Enjoy the burst of flavors in this classic Italian bruschetta with the sweetness of ripe tomatoes, the aroma of fresh basil, and the tanginess of balsamic vinegar!",
    ],
    ingredients: [
      {
        ingredient: "Ripe tomatoes, diced",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Fresh basil leaves, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Balsamic vinegar",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Extra virgin olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Baguette or Italian bread, sliced",
        unit: "1",
        quantity: null,
      },
    ],
  },
  {
    title: "One-Bowl Chocolate Banana Bread",
    category: "Snack",
    time: "20 mins",
    description:
      "One-bowl chocolate banana bread is a delightful and moist treat that combines the rich flavor of chocolate with the natural sweetness of ripe bananas. This easy-to-make banana bread recipe requires only one bowl, making cleanup a breeze. Enjoy a slice of this delicious bread as a snack, dessert, or a comforting breakfast option.",
    img: "https://cdn.pickuplimes.com/cache/ed/82/ed8210253ffd0433848061a9fe245347.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/8c/5b/8c5b3a26b621a8aa0a5e44616217c9ec.jpg",
      "https://cdn.pickuplimes.com/cache/66/3b/663b1f70a27a03083291779333181f29.jpg",
      "https://cdn.pickuplimes.com/cache/99/07/9907ef5cdf12d463349f0b8d38611dc5.jpg",
      "https://cdn.pickuplimes.com/cache/82/21/82212cba96382db2ed35f195959e36bc.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C) and grease a 9x5-inch loaf pan.",
      "In a large mixing bowl, mash the ripe bananas with a fork until smooth.",
      "Add the vegetable oil, brown sugar, and vanilla extract to the mashed bananas, and mix well until everything is well combined.",
      "Add the all-purpose flour, cocoa powder, baking powder, baking soda, and salt to the bowl with the wet ingredients.",
      "Gently fold the dry ingredients into the wet ingredients until just combined. Be careful not to overmix.",
      "Stir in the chocolate chips and chopped walnuts, if using, until evenly distributed throughout the batter.",
      "Pour the batter into the greased loaf pan and spread it out evenly.",
      "Bake the one-bowl chocolate banana bread in the preheated oven for about 50-60 minutes or until a toothpick inserted into the center comes out clean.",
      "Remove the bread from the oven and let it cool in the pan for about 10 minutes.",
      "Carefully transfer the bread to a wire rack to cool completely before slicing and serving.",
      "Enjoy a slice of this delicious and moist chocolate banana bread as a delightful snack or dessert!",
      "Store any leftover bread in an airtight container at room temperature for up to three days.",
    ],
    ingredients: [
      {
        ingredient: "Ripe bananas, mashed",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Vegetable oil",
        unit: "cup",
        quantity: 0.3333333333333333,
      },
      {
        ingredient: "Brown sugar",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Cocoa powder",
        unit: "cup",
        quantity: 0.3333333333333333,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Baking soda",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Chocolate chips",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Chopped walnuts (optional)",
        unit: "cup",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Baked Tortilla Chips",
    category: "Appetizer",
    time: "20 mins",
    description:
      "Baked tortilla chips are a healthier and homemade alternative to store-bought chips. These crispy chips are easy to make and perfect for snacking or serving with your favorite dips and salsas.",
    img: "https://cdn.pickuplimes.com/cache/88/4f/884ffbf3de8c5673a9d33c9b22dfb3d0.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/88/4f/884ffbf3de8c5673a9d33c9b22dfb3d0.jpg",
      "https://cdn.pickuplimes.com/cache/88/4f/884ffbf3de8c5673a9d33c9b22dfb3d0.jpg",
      "https://cdn.pickuplimes.com/cache/88/4f/884ffbf3de8c5673a9d33c9b22dfb3d0.jpg",
      "https://cdn.pickuplimes.com/cache/88/4f/884ffbf3de8c5673a9d33c9b22dfb3d0.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C) and line a baking sheet with parchment paper.",
      "Stack the corn tortillas together and cut them into wedges, just like you would cut a pizza.",
      "In a large bowl, drizzle the olive oil over the tortilla wedges.",
      "Add the salt, ground cumin, chili powder, and garlic powder to the bowl.",
      "Gently toss the tortilla wedges until they are evenly coated with the oil and spices.",
      "Arrange the seasoned tortilla wedges in a single layer on the prepared baking sheet.",
      "Bake the tortilla chips in the preheated oven for about 12-15 minutes or until they become crispy and lightly golden.",
      "Keep an eye on the chips while baking to avoid burning them.",
      "Once the chips are done baking, remove them from the oven and let them cool slightly.",
      "Serve the baked tortilla chips with your favorite dips, salsa, or guacamole.",
      "Enjoy these delicious and guilt-free tortilla chips as a tasty snack or a party appetizer!",
    ],
    ingredients: [
      {
        ingredient: "Corn tortillas",
        unit: "6-inch",
        quantity: 6,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Chili powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoons",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Sweet & Spicy Miso Roasted Sweet Potatoes with Sambal Tahini Mayo",
    category: "Appetizer",
    time: "40 mins",
    description:
      "Sweet & spicy miso roasted sweet potatoes with sambal tahini mayo is a mouthwatering dish that combines the sweetness of roasted sweet potatoes with the umami flavor of miso and the heat of sambal tahini mayo. It's a perfect blend of flavors and textures that will impress your taste buds.",
    img: "https://cdn.pickuplimes.com/cache/39/5a/395a572a897d20d0e59c2882ebc1ca5e.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/64/0c/640c4db24f46fb9bd3bb2528d7a48931.jpg",
      "https://cdn.pickuplimes.com/cache/ab/6d/ab6d2bd2b8d0fdd1702cfd31d47f3b91.jpg",
      "https://cdn.pickuplimes.com/cache/0b/b0/0bb0a7f3188c461f0789930c8d20dc46.jpg",
      "https://cdn.pickuplimes.com/cache/ce/b8/ceb8ec141f596bf1e5f74c64f2f2a947.jpg",
    ],
    directions: [
      "Preheat your oven to 425°F (220°C) and line a baking sheet with parchment paper.",
      "In a bowl, whisk together the miso paste, maple syrup, soy sauce, rice vinegar, sesame oil, garlic powder, sambal oelek, salt, and black pepper to create the marinade.",
      "Add the cut sweet potatoes to the marinade and toss them until they are well coated.",
      "Spread the miso-marinated sweet potatoes in a single layer on the prepared baking sheet.",
      "Roast the sweet potatoes in the preheated oven for about 25-30 minutes or until they are tender and caramelized, flipping them once halfway through for even roasting.",
      "While the sweet potatoes are roasting, prepare the sambal tahini mayo by combining the tahini, lime juice, and water in a bowl. Whisk until smooth and creamy. Add sambal oelek to the tahini mixture and stir until well combined. Adjust the spiciness to your taste.",
      "Once the sweet potatoes are done roasting, remove them from the oven and let them cool slightly.",
      "Serve the miso roasted sweet potatoes with a drizzle of the sambal tahini mayo.",
      "Garnish with chopped fresh cilantro and sesame seeds for added flavor and presentation.",
      "Enjoy this sweet and spicy fusion of flavors in the miso roasted sweet potatoes with sambal tahini mayo as a delicious side dish or a standout main course!",
    ],
    ingredients: [
      {
        ingredient: "Sweet potatoes, peeled and cut into chunks",
        unit: "cups",
        quantity: 3,
      },
      {
        ingredient: "Miso paste",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Soy sauce",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Rice vinegar",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Sesame oil",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Sambal oelek (chili paste)",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Tahini",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Lime juice",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Fresh cilantro, chopped (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Sesame seeds (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Blueberry Almond Oatmeal",
    category: "Breakfast",
    time: "10 mins",
    description:
      "Blueberry almond oatmeal is a wholesome and delicious breakfast option. It combines the goodness of oats, the sweetness of blueberries, and the nutty flavor of almonds for a satisfying morning meal.",
    img: "https://cdn.pickuplimes.com/cache/a7/88/a7888d1136f399dc20943601f426a599.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/47/f6/47f6709bf621bf286831a105e081ada5.jpg",
      "https://cdn.pickuplimes.com/cache/1e/45/1e45908290f2b7eda155ecd97c5a3ff4.jpg",
      "https://cdn.pickuplimes.com/cache/c3/9b/c39ba6192dd149b1ff7d29760f6d123e.jpg",
      "https://cdn.pickuplimes.com/cache/35/e0/35e060fb638109dcbed8bc0683622511.jpg",
    ],
    directions: [
      "In a saucepan, bring the water to a boil over medium-high heat.",
      "Add the rolled oats and a pinch of salt to the boiling water. Stir and reduce the heat to low.",
      "Simmer the oats for about 5 minutes, stirring occasionally, until they reach your desired consistency. If you prefer thicker oatmeal, you can simmer for a few minutes longer.",
      "Pour in the almond milk and stir to combine. Let it cook for another 2-3 minutes until the oatmeal is creamy and well-cooked.",
      "Stir in the fresh or frozen blueberries, chopped almonds, maple syrup or honey, ground cinnamon, and vanilla extract. Mix everything together.",
      "Cook for an additional minute or two, allowing the blueberries to heat through.",
      "Remove the saucepan from the heat and let the oatmeal sit for a minute to cool slightly and thicken further.",
      "Serve the blueberry almond oatmeal warm in bowls. You can drizzle extra almond milk or add more toppings like additional blueberries and almonds if desired.",
      "Enjoy a nourishing and delightful bowl of blueberry almond oatmeal to kickstart your day!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cup",
        quantity: 1,
      },
      {
        ingredient: "Water",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Almond milk (or any plant-based milk)",
        unit: "cup",
        quantity: 1,
      },
      {
        ingredient: "Fresh or frozen blueberries",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Almonds, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup or honey",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Pinch of salt",
        unit: "pinch",
        quantity: null,
      },
    ],
  },
  {
    title: "Layered Chocolate Raspberry Mousse",
    category: "Dessert",
    time: "10 mins",
    description:
      "Layered Chocolate Raspberry Mousse is an exquisite dessert that combines the richness of chocolate mousse with the tartness of raspberry mousse, creating a harmonious symphony of flavors and textures. The dessert is assembled with alternating layers of velvety chocolate mousse and smooth raspberry mousse, resulting in a visually stunning and delectable treat. Each layer is carefully prepared with ingredients like dark chocolate, whipped cream, fresh raspberries, and raspberry puree to achieve a perfect balance of sweetness and tanginess. This delightful dessert is a show-stopper at any dinner party or special occasion, and it's sure to impress with its elegant appearance and delightful taste.",
    img: "https://cdn.pickuplimes.com/cache/5c/96/5c96e04bf184d165160bf71084bf5e21.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/6c/97/6c97b6c80626f9aa0833357bf9c69d83.jpg",
      "https://cdn.pickuplimes.com/cache/60/3e/603efe4b8b87b42fe95139ece34c9bae.jpg",
      "https://cdn.pickuplimes.com/cache/c7/da/c7dae1d0ae958218bab4028bf2b21392.jpg",
      "https://cdn.pickuplimes.com/cache/ea/25/ea25cb5e010d6f09812c579769eb12fc.jpg",
    ],
    directions: [
      "In a heatproof bowl, melt the chopped semi-sweet chocolate over a pot of simmering water (double boiler). Stir until smooth, then set aside to cool slightly.",
      "In a separate bowl, whip the heavy cream until soft peaks form.",
      "In another bowl, whisk together the egg yolks and granulated sugar until pale and creamy.",
      "Slowly pour the melted chocolate into the egg yolk mixture while continuously whisking to avoid cooking the eggs.",
      "Fold the whipped cream into the chocolate mixture until well combined. This creates the chocolate mousse layer.",
      "In a small bowl, sprinkle the gelatin powder over the water and let it sit for a minute to bloom.",
      "In a saucepan, gently heat the raspberry puree until warm (do not boil). Stir in the bloomed gelatin until completely dissolved.",
      "Let the raspberry mixture cool slightly before folding in the remaining whipped cream. This creates the raspberry mousse layer.",
      "In serving glasses or dessert cups, start layering the chocolate mousse and raspberry mousse alternately. You can use a piping bag for more precise layers.",
      "Chill the layered chocolate raspberry mousse in the refrigerator for at least 1 hour to set.",
      "Before serving, garnish the mousse with fresh raspberries and chocolate shavings.",
      "Enjoy this indulgent and delightful layered chocolate raspberry mousse as a perfect ending to your special meal!",
    ],
    ingredients: [
      {
        ingredient: "Semi-sweet chocolate, chopped",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Heavy cream",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Egg yolks",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Granulated sugar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Raspberry puree (strained to remove seeds)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Gelatin powder",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh raspberries (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Chocolate shavings (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Roasted Edamame: 2 Ways",
    category: "Snack",
    time: "25 mins",
    description:
      "Roasted edamame: 2 ways is a versatile and flavorful snack that features two delicious variations of roasted edamame. Edamame, young soybeans, are roasted to perfection with savory seasonings, creating a crunchy and protein-packed snack that's perfect for munching on any time of the day.",
    img: "https://cdn.pickuplimes.com/cache/37/93/37938875d7955a1aab21263e1a97f20a.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/eb/86/eb8699b454b55921215cfbd38d934ef1.jpg",
      "https://cdn.pickuplimes.com/cache/0c/3c/0c3c2ba0722309c8dbec5965d4c7b0ac.jpg",
      "https://cdn.pickuplimes.com/cache/2e/f4/2ef468e76a3bbcd3d6aca09ebaec6b4c.jpg",
      "https://cdn.pickuplimes.com/cache/02/f8/02f8d6595cef17767c9fc5338f8219a9.jpg",
    ],
    directions: [
      "Preheat your oven to 425°F (220°C) and line a baking sheet with parchment paper.",
      "In a bowl, combine the thawed edamame, olive oil, soy sauce, garlic powder, onion powder, sesame seeds, chili powder, and salt.",
      "Toss the edamame in the seasonings until they are evenly coated.",
      "For the first variation, spread the seasoned edamame in a single layer on the prepared baking sheet.",
      "Roast the edamame in the preheated oven for about 15-20 minutes or until they become golden brown and crispy, stirring them halfway through the cooking time.",
      "For the second variation, add a touch of sweetness by sprinkling a little brown sugar or maple syrup over the seasoned edamame before roasting.",
      "Spread the edamame in a single layer on the prepared baking sheet.",
      "Roast the sweet and savory edamame in the preheated oven for about 15-20 minutes or until they become golden brown and crispy, stirring them halfway through the cooking time.",
      "Remove the roasted edamame from the oven and let them cool slightly before serving.",
      "Enjoy the roasted edamame as a crunchy and flavorful snack or as a tasty addition to salads and grain bowls.",
      "Store any leftover roasted edamame in an airtight container at room temperature for up to a week.",
      "Feel free to adjust the seasonings to suit your taste preferences and create your own unique variations of roasted edamame.",
    ],
    ingredients: [
      {
        ingredient: "Frozen edamame, thawed",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Soy sauce",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Onion powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Sesame seeds",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Chili powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
    ],
  },
  {
    title: "Crunchy Sesame Snaps",
    category: "Snack",
    time: "25 mins",
    description:
      "Crunchy sesame snaps are a delightful and addictive treat that combines the nutty flavor of sesame seeds with a sweet and caramelized texture. These homemade sesame snaps are easy to make and provide a satisfying crunch that's perfect for snacking or as a delicious addition to desserts and ice creams.",
    img: "https://cdn.pickuplimes.com/cache/1c/66/1c66f4c200e84cfabb4ce2499ddd8f9d.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/45/fb/45fbf5dee2bdfe1723899ef9dac1e981.jpg",
      "https://cdn.pickuplimes.com/cache/f3/c4/f3c4b8a519383effc3f21ef8fa0189fc.jpg",
      "https://cdn.pickuplimes.com/cache/94/68/94688307e28a8d0adcd22925a6f96d7e.jpg",
      "https://cdn.pickuplimes.com/cache/3e/4e/3e4ede678295179d4f4c23fc2b8cc15d.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C) and line a baking sheet with parchment paper.",
      "In a dry skillet over medium heat, toast the white sesame seeds for about 3-4 minutes or until they turn lightly golden and fragrant. Stir them constantly to prevent burning.",
      "In a saucepan, combine the honey, granulated sugar, unsalted butter, vanilla extract, and salt. Cook over medium heat, stirring constantly until the mixture becomes smooth and starts to bubble.",
      "Add the toasted sesame seeds to the saucepan and stir well to evenly coat the seeds with the caramel mixture.",
      "Quickly pour the sesame mixture onto the prepared baking sheet and spread it out into a thin and even layer using a spatula or the back of a spoon.",
      "Bake the sesame mixture in the preheated oven for about 8-10 minutes or until it turns golden brown around the edges.",
      "Keep a close eye on the sesame snaps in the last few minutes of baking to avoid over-browning.",
      "Remove the baking sheet from the oven and let the sesame mixture cool for a few minutes to firm up.",
      "While it's still warm, cut the sesame snaps into desired shapes using a sharp knife or break them into irregular pieces for a rustic look.",
      "Allow the sesame snaps to cool completely on the baking sheet until they become firm and crunchy.",
      "Once cooled, the sesame snaps are ready to be enjoyed as a delicious and addictive snack or as a crunchy topping for desserts and ice creams.",
      "Store any leftover sesame snaps in an airtight container at room temperature for up to a week.",
      "Feel free to customize the sesame snaps by adding other ingredients like chopped nuts, dried fruits, or a sprinkle of sea salt to suit your taste preferences.",
    ],
    ingredients: [
      {
        ingredient: "White sesame seeds",
        unit: "1 cup",
        quantity: null,
      },
      {
        ingredient: "Honey",
        unit: "1/3 cup",
        quantity: null,
      },
      {
        ingredient: "Granulated sugar",
        unit: "1/4 cup",
        quantity: null,
      },
      {
        ingredient: "Unsalted butter",
        unit: "2 tablespoons",
        quantity: null,
      },
      {
        ingredient: "Vanilla extract",
        unit: "1/2 teaspoon",
        quantity: null,
      },
      {
        ingredient: "Salt",
        unit: "1/4 teaspoon",
        quantity: null,
      },
    ],
  },
  {
    title: "Quick Garlic Chili Noodles",
    category: "Main",
    time: "15 mins",
    description:
      "Quick Garlic Chili Noodles are a delicious and easy-to-make dish with a burst of flavors. Chewy noodles are coated in a savory garlic chili sauce, creating a perfect balance of heat and umami. This quick and satisfying recipe is a great option for a speedy lunch or dinner!",
    img: "https://cdn.pickuplimes.com/cache/9b/ec/9beca116bd7fb46814d44dcc060b7cf9.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/d9/e2/d9e23b0304813e47f9dc52b6c17132f0.jpg",
      "https://cdn.pickuplimes.com/cache/26/b9/26b99c955c31e914b9a0b3de1b2592ab.jpg",
      "https://cdn.pickuplimes.com/cache/96/14/9614de740ff2d1a88ecdfb2defd43db7.jpg",
      "https://cdn.pickuplimes.com/cache/4b/6a/4b6a7363630fdd18f209a96e72163bfd.jpg",
    ],
    directions: [
      "Cook the noodles according to package instructions until they are al dente. Drain and set aside.",
      "In a small bowl, mix together soy sauce, chili garlic sauce, and sesame oil to make the garlic chili sauce.",
      "In a pan, heat the minced garlic over medium heat until fragrant. Add the garlic chili sauce to the pan and stir for a minute to combine the flavors.",
      "Add the cooked noodles to the pan and toss them in the garlic chili sauce until they are evenly coated.",
      "Divide the noodles into serving bowls.",
      "Top the noodles with sliced green onions and sesame seeds.",
      "Serve the Quick Garlic Chili Noodles hot and enjoy the flavorful and spicy goodness!",
    ],
    ingredients: [
      {
        ingredient: "Noodles of your choice",
        unit: "g",
        quantity: 200,
      },
      {
        ingredient: "Soy sauce",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Chili garlic sauce",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Sesame oil",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "cloves",
        quantity: 2,
      },
      {
        ingredient: "Green onions, sliced",
        unit: "pieces",
        quantity: 2,
      },
      {
        ingredient: "Sesame seeds",
        unit: "tablespoons",
        quantity: 1,
      },
    ],
  },
  {
    title: "Homemade Beet Pasta",
    category: "Main",
    time: "10 mins",
    description:
      "Homemade Beet Pasta is a vibrant and delightful twist on traditional pasta. Made with the natural sweetness and vibrant color of beets, this pasta is a feast for the eyes and the taste buds. Enjoy the process of making your own pasta from scratch and indulge in the wonderful flavors of this homemade creation!",
    img: "https://cdn.pickuplimes.com/cache/48/fd/48fd2bb26264abd52c293912a2026611.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/71/a6/71a6e90073aabea0f4b06aa3e8975096.jpg",
      "https://cdn.pickuplimes.com/cache/b8/98/b898515337a939d4b53f1448b8cd5ede.jpg",
      "https://cdn.pickuplimes.com/cache/7a/4e/7a4e2f54421034716e46d8a4f5eac15f.jpg",
      "https://cdn.pickuplimes.com/cache/84/6f/846f7aeaa58c70c509ec26e255fb2b84.jpg",
    ],
    directions: [
      "Cook the beets until they are tender. Once cooked, blend them into a smooth puree.",
      "In a large mixing bowl, combine the all-purpose flour and salt.",
      "Create a well in the center of the flour mixture and add the beet puree, eggs, and olive oil into the well.",
      "Gently mix the wet ingredients in the well with a fork, gradually incorporating the flour until a dough starts to form.",
      "Knead the dough on a floured surface for about 5-7 minutes until it becomes smooth and elastic.",
      "Wrap the dough in plastic wrap and let it rest at room temperature for about 30 minutes.",
      "Divide the dough into smaller portions for easier handling.",
      "Using a pasta machine or a rolling pin, roll out each portion of the dough to your desired thickness.",
      "Cut the rolled dough into your preferred pasta shape, such as fettuccine, tagliatelle, or farfalle.",
      "Dust the cut pasta with a little flour to prevent sticking.",
      "Bring a large pot of salted water to a boil and cook the beet pasta for 2-3 minutes or until al dente.",
      "Drain the cooked pasta and toss it with your favorite sauce or toppings.",
      "Enjoy your vibrant and delicious Homemade Beet Pasta!",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "g",
        quantity: 300,
      },
      {
        ingredient: "Beet puree (cooked and blended beets)",
        unit: "g",
        quantity: 100,
      },
      {
        ingredient: "Eggs",
        unit: "",
        quantity: "2",
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
    ],
  },
  {
    title: "Tropical Coconut Popsicles",
    category: "Snack",
    time: "10 mins",
    description:
      "Tropical coconut popsicles are a refreshing and tropical treat that brings the flavors of coconut and various fruits together in a delightful frozen dessert. These homemade popsicles are made with creamy coconut milk, ripe tropical fruits, and a touch of sweetness, creating a cool and creamy popsicle that's perfect for beating the heat on a sunny day.",
    img: "https://cdn.pickuplimes.com/cache/50/22/50226805dabd3370192ba68e66b81a10.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/82/c3/82c31cc05ebaadedc800cdf3fc443870.jpg",
      "https://cdn.pickuplimes.com/cache/43/03/4303cff2e2096cfd2109d52af0d8dead.jpg",
      "https://cdn.pickuplimes.com/cache/6a/7b/6a7b7a16f5c345233fed9ed73da10097.jpg",
      "https://cdn.pickuplimes.com/cache/92/c8/92c8ea327c17d7dfa38871387b0d0c83.jpg",
    ],
    directions: [
      "In a blender or food processor, combine the coconut milk, pineapple chunks, mango chunks, kiwi slices, sweetener of choice (start with 2 tablespoons and adjust to your desired level of sweetness), and vanilla extract.",
      "Blend the mixture until it becomes smooth and creamy.",
      "Taste the mixture and adjust the sweetness if needed, adding more sweetener if desired.",
      "If you prefer some texture, stir in the shredded coconut into the mixture.",
      "Pour the tropical coconut mixture into popsicle molds, leaving a little space at the top for expansion during freezing.",
      "If using popsicle sticks, insert them into the molds, ensuring they are centered.",
      "Place the popsicle molds in the freezer and freeze the popsicles for at least 4-6 hours or until they are completely frozen.",
      "Once the tropical coconut popsicles are frozen, remove them from the molds by briefly running the molds under warm water to loosen the popsicles.",
      "Serve the delightful tropical coconut popsicles immediately, or store them in a resealable plastic bag or an airtight container in the freezer for up to a few weeks.",
      "Enjoy these cool and tropical treats whenever you need a refreshing and creamy popsicle to beat the heat!",
      "Feel free to customize the popsicles by adding other tropical fruits like banana, papaya, or passion fruit, according to your taste preferences.",
    ],
    ingredients: [
      {
        ingredient: "Coconut milk (full-fat)",
        unit: "1 can (13.5 oz)",
        quantity: null,
      },
      {
        ingredient: "Pineapple chunks",
        unit: "1 cup",
        quantity: null,
      },
      {
        ingredient: "Mango chunks",
        unit: "1 cup",
        quantity: null,
      },
      {
        ingredient: "Kiwi slices",
        unit: "1 cup",
        quantity: null,
      },
      {
        ingredient: "Sweetener of choice (such as honey or maple syrup)",
        unit: "2-4 tablespoons",
        quantity: null,
      },
      {
        ingredient: "Vanilla extract",
        unit: "1 teaspoon",
        quantity: null,
      },
      {
        ingredient: "Shredded coconut (optional, for texture)",
        unit: "2 tablespoons",
        quantity: null,
      },
    ],
  },
  {
    title: "Cereal Crunch Frozen Yogurt Breakfast Bars",
    category: "Breakfast",
    time: "35 mins",
    description:
      "Cereal crunch frozen yogurt breakfast bars are a delightful and refreshing morning treat. These bars feature a creamy frozen yogurt base with a crunchy cereal topping, making them a perfect grab-and-go breakfast option.",
    img: "https://cdn.pickuplimes.com/cache/1a/0e/1a0ef11e4952bc258441570e0cc789b1.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/81/15/8115b3afc95ffe95513dcc3c65fda377.jpg",
      "https://cdn.pickuplimes.com/cache/c0/56/c0562457409930404b63edf650a2f4b3.jpg",
      "https://cdn.pickuplimes.com/cache/12/47/1247b205f5969fc1643b472ee3698940.jpg",
      "https://cdn.pickuplimes.com/cache/7c/1b/7c1b0111ae3050258b6aff304ee3159e.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the Greek yogurt, honey or maple syrup, and vanilla extract. Mix well until the mixture is smooth and well combined.",
      "Line a baking dish or tray with parchment paper for easy removal of the frozen bars.",
      "Pour the yogurt mixture into the prepared baking dish, spreading it evenly to form a smooth layer.",
      "Sprinkle the cereal of your choice over the top of the yogurt layer, pressing it gently into the yogurt to adhere.",
      "Add the fresh berries on top of the cereal layer, distributing them evenly.",
      "Cover the baking dish with plastic wrap or aluminum foil to prevent any freezer odors from affecting the bars.",
      "Place the baking dish in the freezer and let it freeze for at least 5-6 hours or until the yogurt has solidified.",
      "Once the yogurt breakfast bars are frozen, remove them from the baking dish using the parchment paper and place them on a cutting board.",
      "Slice the frozen yogurt into bars or squares of your desired size.",
      "Serve the cereal crunch frozen yogurt breakfast bars immediately, or store them in an airtight container in the freezer for a quick and convenient breakfast option.",
      "Enjoy these creamy and crunchy frozen yogurt bars as a delicious and nutritious way to start your day!",
    ],
    ingredients: [
      {
        ingredient: "Greek yogurt",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Honey or maple syrup",
        unit: "tablespoons",
        quantity: 4,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Cereal of your choice (e.g., granola, corn flakes)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh berries (e.g., strawberries, blueberries)",
        unit: "cups",
        quantity: 0.5,
      },
    ],
  },
  {
    title: "Mushroom & Rice Burger",
    category: "Main",
    time: "40 mins",
    description:
      "Mushroom & Rice Burger is a delicious and wholesome vegan burger option that features a savory mushroom and rice patty. The combination of earthy mushrooms, cooked rice, and flavorful spices creates a hearty and satisfying burger. Serve it on a bun with your favorite toppings and condiments for a delightful plant-based meal!",
    img: "https://cdn.pickuplimes.com/cache/cf/a2/cfa26e153c34ebe8eb97e1f38e7b7b5a.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/db/fe/dbfeb7876a62afb34aba65ef0b68961a.jpg",
      "https://cdn.pickuplimes.com/cache/7a/66/7a667dd7822d9e0d71f6b8234c312fff.jpg",
      "https://cdn.pickuplimes.com/cache/79/a7/79a7d4c4bb3d6cc63ec15f69d49868de.jpg",
      "https://cdn.pickuplimes.com/cache/cd/c4/cdc46560a9ff900b865822931b97ddfb.jpg",
    ],
    directions: [
      "In a large skillet, heat olive oil over medium heat. Add chopped onion and minced garlic, and sauté until the onions become translucent.",
      "Add chopped cremini mushrooms to the skillet and cook until they release their moisture and become tender. Remove the skillet from the heat and let the mixture cool slightly.",
      "In a small bowl, mix ground flaxseed with water and let it sit for a few minutes to thicken. This will act as the binding agent for the burger patties.",
      "In a large mixing bowl, combine cooked white rice, sautéed mushroom and onion mixture, breadcrumbs, all-purpose flour, ground cumin, smoked paprika, salt, and black pepper.",
      "Add the flaxseed mixture to the bowl and mix everything together until well combined. The mixture should hold together when pressed.",
      "Divide the mixture into four equal portions and shape each portion into a burger patty.",
      "Heat olive oil in a skillet over medium heat. Add the burger patties to the skillet and cook for about 4-5 minutes on each side, or until they are golden and crispy.",
      "Assemble the Mushroom & Rice Burgers by placing each patty on a burger bun. Top with lettuce leaves, sliced tomato, and pickles if desired.",
      "Spread vegan mayonnaise and ketchup on the top bun, then place it on top of the assembled burger.",
      "Serve the Mushroom & Rice Burgers warm and enjoy this hearty and flavorful vegan burger!",
    ],
    ingredients: [
      {
        ingredient: "Cooked white rice",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Cremini mushrooms, finely chopped",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Onion, finely chopped",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "cloves",
        quantity: 2,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground flaxseed",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 6,
      },
      {
        ingredient: "Breadcrumbs",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "All-purpose flour",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Smoked paprika",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Olive oil (for frying)",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Burger buns",
        unit: "",
        quantity: "4",
      },
      {
        ingredient: "Lettuce leaves",
        unit: "leaves",
        quantity: 4,
      },
      {
        ingredient: "Tomato, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Pickles (optional)",
        unit: "",
        quantity: "to taste",
      },
      {
        ingredient: "Vegan mayonnaise",
        unit: "tablespoons",
        quantity: 4,
      },
      {
        ingredient: "Ketchup",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "One-Pot Tomato & Chickpea Stew",
    category: "Main",
    time: "40 mins",
    description:
      "One-Pot Tomato & Chickpea Stew is a hearty and comforting vegan dish that is full of flavor and nutrients. This stew features chickpeas cooked in a rich tomato-based broth, along with a medley of vegetables and aromatic spices. It's an easy and satisfying meal that will warm you up on any day!",
    img: "https://cdn.pickuplimes.com/cache/fc/b6/fcb60e5ade1da4a19cc8b6900db9d1d3.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/44/05/4405f5d93de89c2e9bc20aaa6533014d.jpg",
      "https://cdn.pickuplimes.com/cache/e0/f4/e0f47eb37f7f83c0f45c69b6bd5320ff.jpg",
      "https://cdn.pickuplimes.com/cache/a4/ac/a4ace2838085c353f478f10fd8689e02.jpg",
      "https://cdn.pickuplimes.com/cache/b4/ab/b4abdf10be9f0e9c19372c99fdd2188d.jpg",
    ],
    directions: [
      "In a large pot or Dutch oven, heat olive oil over medium heat.",
      "Add chopped onion and minced garlic to the pot. Sauté until the onions become translucent and fragrant.",
      "Stir in the diced carrot, potato, and red bell pepper. Cook the vegetables for a few minutes until they start to soften.",
      "Add ground cumin, ground paprika, ground coriander, chili powder (if using), salt, and black pepper to the pot. Mix well with the vegetables to coat them in the spices.",
      "Pour in the vegetable broth and crushed tomatoes. Stir to combine all the ingredients.",
      "Bring the stew to a boil, then reduce the heat to low and let it simmer for about 20 minutes or until the vegetables are tender.",
      "Add the cooked or canned chickpeas to the stew and cook for an additional 5-10 minutes to let the flavors meld together.",
      "Taste and adjust salt and spices as needed.",
      "Garnish the One-Pot Tomato & Chickpea Stew with freshly chopped parsley before serving.",
      "Serve the stew hot and enjoy the delicious and comforting flavors!",
    ],
    ingredients: [
      {
        ingredient: "Chickpeas, cooked or canned",
        unit: "g",
        quantity: 400,
      },
      {
        ingredient: "Vegetable broth",
        unit: "ml",
        quantity: 500,
      },
      {
        ingredient: "Crushed tomatoes",
        unit: "g",
        quantity: 400,
      },
      {
        ingredient: "Carrot, diced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Potato, diced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Red bell pepper, diced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Onion, chopped",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "cloves",
        quantity: 3,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground paprika",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground coriander",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Chili powder (optional)",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Fresh parsley, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "High Protein Vegan Pancakes",
    category: "Breakfast",
    time: "20 mins",
    description:
      "High protein vegan pancakes are a delicious and nutritious breakfast option. Made with plant-based ingredients, these pancakes are packed with protein and perfect for a filling morning meal.",
    img: "https://cdn.pickuplimes.com/cache/05/4c/054ccaa43b2b06a169c788371a7e254b.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/1a/34/1a34094fa6617fd0f8504e4d11aa654d.jpg",
      "https://cdn.pickuplimes.com/cache/0f/c3/0fc3bcafdc40eb30ce60153db528f117.jpg",
      "https://cdn.pickuplimes.com/cache/26/cc/26cce78106a7b077155b44255b6cf5a1.jpg",
      "https://cdn.pickuplimes.com/cache/1a/4c/1a4ca92f837e9e4dc7150790899a9c3a.jpg",
    ],
    directions: [
      "In a blender or food processor, blend the rolled oats until they form a fine flour-like consistency.",
      "Add almond flour, ripe banana, plant-based milk, maple syrup or agave syrup, vanilla extract, baking powder, and salt to the blender. Blend until all ingredients are well combined and a smooth pancake batter is formed.",
      "Let the batter rest for a few minutes to thicken slightly.",
      "Preheat a non-stick pan or griddle over medium heat. Lightly grease the pan with coconut oil or cooking spray.",
      "Once the pan is hot, pour about 1/4 cup of the pancake batter onto the pan to form each pancake.",
      "Cook the pancakes for 2-3 minutes on one side until bubbles start to form on the surface. Flip the pancakes and cook for another 1-2 minutes on the other side, or until golden brown.",
      "Repeat the process with the remaining batter until all the pancakes are cooked.",
      "Serve the high protein vegan pancakes warm, topped with fresh berries, and drizzled with maple syrup.",
      "Enjoy a nutritious and satisfying breakfast that's packed with plant-based protein!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cup",
        quantity: 1,
      },
      {
        ingredient: "Almond flour",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Banana, ripe",
        unit: "large",
        quantity: 1,
      },
      {
        ingredient: "Plant-based milk (e.g., almond milk, soy milk)",
        unit: "cup",
        quantity: 0.75,
      },
      {
        ingredient: "Maple syrup or agave syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Coconut oil or cooking spray",
        unit: "for greasing the pan",
        quantity: null,
      },
      {
        ingredient: "Fresh berries (for serving)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Maple syrup (for serving)",
        unit: "for drizzling",
        quantity: null,
      },
    ],
  },
  {
    title: "Caramel Shards",
    category: "Dessert",
    time: "20 mins",
    description:
      "Caramel shards are sweet and crunchy confections made by caramelizing sugar until it turns golden brown and then spreading it thin to cool and harden into delicate shards. These luscious caramel treats are a delightful topping for desserts like ice creams, cakes, and custards, adding a burst of rich caramel flavor and a pleasing texture. They can also be enjoyed on their own as a sweet and indulgent treat. Making caramel shards requires a careful process of melting sugar and can be customized with a touch of sea salt or other flavorings to suit your taste preferences. These shimmering caramel delights are sure to elevate any dessert or occasion with their elegant and delectable charm.",
    img: "https://cdn.pickuplimes.com/cache/65/9a/659ae8cd794e58bfdaa3ad7ae74e40a1.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/d6/d4/d6d4ec8ea48329b79b90146d85e38b06.jpg",
      "https://cdn.pickuplimes.com/cache/1a/55/1a5590ea27b27dfe9f838b9524a92a59.jpg",
      "https://cdn.pickuplimes.com/cache/c6/5d/c65daea8b46c145a26c7f74b45929288.jpg",
      "https://cdn.pickuplimes.com/cache/d8/19/d819f4726d748dfc74e6183e0a11f72b.jpg",
    ],
    directions: [
      "Line a baking sheet with parchment paper or a silicone baking mat and set it aside.",
      "In a heavy-bottomed saucepan, combine the granulated sugar and water over medium heat.",
      "Stir the mixture gently until the sugar dissolves completely.",
      "Once the sugar has dissolved, stop stirring and let the mixture come to a boil. Continue to boil the sugar syrup until it reaches a deep amber color. Be careful not to let it burn, as caramel can quickly turn from amber to burnt.",
      "Once the desired amber color is achieved, remove the saucepan from the heat.",
      "Add the cubed unsalted butter to the caramel and stir until the butter is fully melted and incorporated. Be cautious, as the mixture will bubble vigorously when the butter is added.",
      "If desired, stir in the sea salt to create a salty-sweet flavor profile.",
      "Carefully pour the hot caramel onto the prepared baking sheet, spreading it out into a thin layer using a heat-resistant spatula.",
      "Let the caramel cool and harden completely at room temperature. This should take about 15-20 minutes.",
      "Once the caramel has hardened, break it into irregular shards using your hands or a knife.",
      "Store the caramel shards in an airtight container at room temperature until ready to use.",
      "Garnish your cakes, cupcakes, ice cream, and other desserts with these delicious caramel shards for added crunch and sweetness.",
      "Enjoy the delightful texture and flavor of these homemade caramel shards!",
    ],
    ingredients: [
      {
        ingredient: "Granulated sugar",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Unsalted butter, cubed",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Sea salt (optional, for a salty-sweet flavor)",
        unit: "teaspoons",
        quantity: null,
      },
    ],
  },
  {
    title: "Fresh Salad Rolls with a Creamy Peanut Hoisin Sauce",
    category: "Appetizer",
    time: "30 mins",
    description:
      "Fresh salad rolls with a creamy peanut hoisin sauce are a light and delicious appetizer or snack that is perfect for hot days. These rolls are filled with a colorful mix of fresh vegetables, herbs, and rice vermicelli noodles, and served with a creamy and flavorful peanut hoisin sauce for dipping.",
    img: "https://cdn.pickuplimes.com/cache/48/0d/480d093aa152d81c34c8d066490cebe9.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/55/8b/558b31d6fe87639971bdb6d349dbe201.jpg",
      "https://cdn.pickuplimes.com/cache/7b/8c/7b8ce7ec476b44343ce01f586429dc12.jpg",
      "https://cdn.pickuplimes.com/cache/cb/44/cb44663ccea59e96be613ae7f610069e.jpg",
      "https://cdn.pickuplimes.com/cache/7e/dd/7edde9de34307e14f37e1dc54bed2014.jpg",
    ],
    directions: [
      "Prepare all the vegetables and herbs by washing and cutting them into thin, julienne strips.",
      "Cook the rice vermicelli noodles according to the package instructions, then rinse them under cold water to cool and prevent sticking.",
      "Fill a shallow dish or large plate with warm water. Dip one rice paper wrapper into the water for a few seconds until it softens. Place it on a clean and damp kitchen towel.",
      "On the lower third of the rice paper wrapper, arrange a few lettuce leaves, a small handful of rice vermicelli noodles, and a variety of the julienned vegetables and herbs.",
      "If using shrimp, add a couple of shrimp on top of the vegetable mixture.",
      "Fold the sides of the rice paper over the filling, then fold the bottom of the wrapper over the filling and roll it tightly to form a neat and tight roll.",
      "Repeat the process with the remaining rice paper wrappers and filling ingredients.",
      "To make the creamy peanut hoisin sauce, refer to the separate recipe for the sauce.",
      "Serve the fresh salad rolls with the creamy peanut hoisin sauce for dipping.",
      "Enjoy these refreshing and flavorful salad rolls as a light and healthy appetizer or snack!",
    ],
    ingredients: [
      {
        ingredient: "Rice paper wrappers",
        unit: "sheets",
        quantity: 10,
      },
      {
        ingredient: "Rice vermicelli noodles, cooked and cooled",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Lettuce leaves (butter lettuce or leaf lettuce)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh mint leaves",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Fresh cilantro leaves",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Carrots, julienned",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Cucumber, julienned",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Red bell pepper, julienned",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Cooked and peeled shrimp (optional)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Creamy peanut hoisin sauce",
        unit: "for dipping",
        quantity: null,
      },
    ],
  },
  {
    title: "Almond Chocolate Overnight Oats",
    category: "Breakfast",
    time: "10 mins",
    description:
      "Almond chocolate overnight oats are a delightful and indulgent breakfast that combines the rich flavors of almonds and chocolate. These oats are prepared the night before, creating a convenient and delicious morning meal.",
    img: "https://cdn.pickuplimes.com/cache/a7/9e/a79e4b330dc312a99040e3f819eb576d.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/58/71/5871b85f86ca012d6a19dced13916c8c.jpg",
      "https://cdn.pickuplimes.com/cache/e6/48/e648ebc78a177990c838e2979581aa3b.jpg",
      "https://cdn.pickuplimes.com/cache/be/44/be4437fd93177aabdd8eaaf9a0d52447.jpg",
      "https://cdn.pickuplimes.com/cache/b0/a9/b0a9acd46d721fb0025cd3de8ed5ff15.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the rolled oats, almond milk, almond butter, cocoa powder, maple syrup or honey, and vanilla extract. Mix well until all the ingredients are fully incorporated.",
      "Gently fold in the chopped almonds and dark chocolate chips, ensuring they are evenly distributed throughout the oat mixture.",
      "Divide the almond chocolate overnight oats into individual jars or containers with lids for easy storage and portability.",
      "Cover the jars or containers with lids and refrigerate them overnight, or for at least 6-8 hours, to allow the oats to absorb the flavors and become tender.",
      "In the morning, give the almond chocolate overnight oats a good stir before serving.",
      "If desired, you can top the oats with additional chopped almonds and dark chocolate chips for extra crunch and indulgence.",
      "Enjoy the decadent and nutty flavors of almond chocolate overnight oats for a delightful breakfast treat!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Almond milk (or any milk of your choice)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Almond butter",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Cocoa powder",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup or honey",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Chopped almonds",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Dark chocolate chips",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Buffalo Style Tofu Strips",
    category: "Appetizer",
    time: "30 mins",
    description:
      "Buffalo-style tofu strips are a delicious and spicy vegan twist on classic buffalo wings. These crispy tofu strips are coated in a tangy buffalo sauce, perfect for serving as a party appetizer or a flavorful main dish.",
    img: "https://cdn.pickuplimes.com/cache/62/c0/62c09c999e67abef00b6d52b9c1142e9.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/ba/0a/ba0a17790120eb1080c7ca86be5fa26b.jpg",
      "https://cdn.pickuplimes.com/cache/2d/88/2d88c9933f9e72905f7529679065065b.jpg",
      "https://cdn.pickuplimes.com/cache/22/c3/22c3a419c6a3cc95c177fd4fd7a51c7e.jpg",
      "https://cdn.pickuplimes.com/cache/7e/fe/7efe4b77048bf8f97917556863dc91c9.jpg",
    ],
    directions: [
      "Preheat your oven to 425°F (220°C). Line a baking sheet with parchment paper or lightly grease it.",
      "In a shallow bowl, mix the all-purpose flour, cornstarch, garlic powder, onion powder, smoked paprika, salt, and black pepper to create the coating mixture.",
      "Dredge each tofu strip in the coating mixture, pressing gently to adhere the mixture to the tofu. Shake off any excess flour mixture.",
      "Place the coated tofu strips on the prepared baking sheet in a single layer.",
      "Bake the tofu strips in the preheated oven for about 20 minutes, flipping them halfway through, until they are crispy and golden brown.",
      "While the tofu is baking, heat the buffalo sauce in a saucepan over low heat.",
      "Once the tofu strips are done baking, remove them from the oven and transfer them to a mixing bowl.",
      "Pour the heated buffalo sauce over the tofu strips and toss them gently to coat each strip evenly with the spicy sauce.",
      "Return the sauced tofu strips to the baking sheet and bake for an additional 5 minutes to let the sauce soak in and get slightly sticky.",
      "Remove the buffalo-style tofu strips from the oven and let them cool slightly.",
      "Garnish the tofu strips with chopped green onions for added freshness and flavor.",
      "Serve the buffalo-style tofu strips with celery sticks and, if desired, vegan ranch or blue cheese dressing for dipping.",
      "Enjoy these tasty and spicy buffalo-style tofu strips as a delicious appetizer or a satisfying main dish!",
    ],
    ingredients: [
      {
        ingredient: "Firm tofu, drained and cut into strips",
        unit: "grams",
        quantity: 400,
      },
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Cornstarch",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Onion powder",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Smoked paprika",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Buffalo sauce (store-bought or homemade)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Vegetable oil",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Green onions, chopped (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Celery sticks (for serving)",
        unit: "for serving",
        quantity: null,
      },
      {
        ingredient:
          "Vegan ranch or blue cheese dressing (for dipping, optional)",
        unit: "for dipping",
        quantity: null,
      },
    ],
  },
  {
    title: "Homemade Pie Crust",
    category: "Dessert",
    time: "60 mins",
    description:
      "Homemade pie crust is a buttery and flaky pastry that forms the foundation of delicious pies. Made from simple ingredients like all-purpose flour, cold butter or vegetable shortening, a pinch of salt, and ice water, this pie crust comes together to create a versatile and tender shell. The key to a successful pie crust is handling the dough gently and keeping the ingredients cold to achieve that sought-after flakiness. Whether you're making sweet fruit pies or savory quiches, this homemade pie crust is the perfect base for all your pie-baking adventures.",
    img: "https://cdn.pickuplimes.com/cache/ac/ef/acef0fc719706e2ceb6d996ae139755d.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/4a/f2/4af2a5c94629bc818ca5110467a1d6f7.jpg",
      "https://cdn.pickuplimes.com/cache/34/a5/34a51d02bafb7bfc400f23cb88db92c6.jpg",
      "https://cdn.pickuplimes.com/cache/3c/84/3c84e8664beb944a96f1e14c3834bed9.jpg",
      "https://cdn.pickuplimes.com/cache/4a/1b/4a1bb335f79fd347f273b0db45473f96.jpg",
    ],
    directions: [
      "In a large mixing bowl, combine the all-purpose flour, chilled and cubed unsalted butter, granulated sugar (if making a sweet pie crust), and salt.",
      "Using a pastry cutter or your fingertips, work the butter into the flour mixture until it resembles coarse crumbs with some pea-sized butter pieces remaining. The key is to keep the butter cold to achieve a flaky crust.",
      "Gradually add the ice-cold water, 1 tablespoon at a time, and mix the dough with a fork or your hands until it starts to come together. Be careful not to over-mix the dough, as it can result in a tough crust.",
      "Once the dough holds together when pressed, divide it into two equal portions.",
      "Shape each portion into a disc and wrap them separately in plastic wrap.",
      "Refrigerate the wrapped dough discs for at least 30 minutes to allow the gluten to relax and the butter to firm up.",
      "After chilling, remove one dough disc from the refrigerator and let it sit at room temperature for a few minutes to make it easier to roll.",
      "On a lightly floured surface, roll out the dough into a circle that is about 1/8 inch thick and slightly larger than your pie dish.",
      "Gently transfer the rolled-out dough to the pie dish and press it lightly into the bottom and sides.",
      "Trim any excess dough hanging over the edges of the pie dish.",
      "If making a single crust pie, you can crimp the edges decoratively. For a double crust pie, add the filling and then repeat the rolling process with the second dough disc to create the top crust. Seal and crimp the edges together.",
      "Refrigerate the pie crust for about 15 minutes before baking to prevent it from shrinking during baking.",
      "Follow the recipe instructions for your specific pie filling and baking time.",
      "Enjoy your homemade pie with the flaky and delicious crust you made from scratch!",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 2.5,
      },
      {
        ingredient: "Unsalted butter, chilled and cubed",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Granulated sugar (for sweet pies, optional)",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ice-cold water",
        unit: "tablespoons",
        quantity: -2,
      },
    ],
  },
  {
    title: "Borani Banjan - Afghan Eggplant Dish",
    category: "Main",
    time: "10 mins",
    description:
      "Borani Banjan is a traditional Afghan eggplant dish that is both hearty and flavorful. Slices of eggplant are fried until golden and then layered with a rich tomato-based sauce infused with aromatic spices. The dish is then topped with tangy yogurt sauce and fresh herbs, creating a perfect balance of flavors and textures.",
    img: "https://cdn.pickuplimes.com/cache/8d/1d/8d1d05ad51a9bf77ce66c296a8d430a7.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/bb/0a/bb0a4c8a3421c6f196e24c57765ded13.jpg",
      "https://cdn.pickuplimes.com/cache/5f/5e/5f5e6f9cba974ed88d31470fa1ea8c7a.jpg",
      "https://cdn.pickuplimes.com/cache/59/a4/59a41f92e0e61d9fb6602575fc24c4ac.jpg",
      "https://cdn.pickuplimes.com/cache/af/51/af519281f1c044fbbf8117f5fa932172.jpg",
    ],
    directions: [
      "Sprinkle salt over the sliced eggplants and let them sit for about 15 minutes to remove excess moisture. Pat them dry with paper towels.",
      "In a large skillet, heat vegetable oil over medium-high heat. Fry the eggplant slices until they turn golden brown on both sides. Remove them from the skillet and place them on a plate lined with paper towels to drain any excess oil.",
      "In the same skillet, sauté the chopped onion until it becomes translucent.",
      "Add the minced garlic and cook for another minute until fragrant.",
      "Stir in the chopped tomatoes, tomato paste, ground coriander, ground turmeric, ground paprika, ground cayenne pepper, and salt. Cook the mixture until the tomatoes break down and the sauce thickens.",
      "Layer the fried eggplant slices over the tomato sauce in the skillet. Pour the water over the eggplant and cover the skillet with a lid. Let it simmer on low heat for about 15-20 minutes to allow the flavors to meld.",
      "In a separate bowl, mix the Greek yogurt with chopped mint leaves and cilantro leaves.",
      "Once the eggplant is tender and the flavors have developed, remove the skillet from heat.",
      "Top the Borani Banjan with the yogurt sauce and garnish with additional chopped mint and cilantro leaves.",
      "Serve the dish hot with steamed rice or bread and enjoy the delightful taste of Afghan cuisine!",
    ],
    ingredients: [
      {
        ingredient: "Eggplants, sliced",
        unit: "medium",
        quantity: 2,
      },
      {
        ingredient: "Vegetable oil",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Onion, finely chopped",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "cloves",
        quantity: 3,
      },
      {
        ingredient: "Tomatoes, chopped",
        unit: "medium",
        quantity: 3,
      },
      {
        ingredient: "Tomato paste",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground coriander",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground turmeric",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground paprika",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground cayenne pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Greek yogurt",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Mint leaves, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Cilantro leaves, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Water",
        unit: "cups",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Soto Ayam - Indonesian 'Chicken' Soup",
    category: "Main",
    time: "60 mins",
    description:
      "Soto Ayam is a flavorful Indonesian 'chicken' soup, a popular dish in Indonesia. This vegan version replaces chicken with tofu or tempeh. It's a comforting and aromatic soup, infused with a rich blend of spices, coconut milk, and served with rice noodles, bean sprouts, boiled eggs (for non-vegans), and an array of toppings like fried shallots, lime wedges, and fresh cilantro.",
    img: "https://cdn.pickuplimes.com/cache/3b/3c/3b3c7c2b83eea3b6d8049399e5a31270.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/13/78/13782ec8a21f742c7d191a5c78dad35f.jpg",
      "https://cdn.pickuplimes.com/cache/c6/22/c622253610f28e4d5b1df92a9c1c37c3.jpg",
      "https://cdn.pickuplimes.com/cache/6f/44/6f44afe029db87d127ca1af2631a438b.jpg",
      "https://cdn.pickuplimes.com/cache/4f/14/4f1431151c93ef350df7e1cec5604271.jpg",
    ],
    directions: [
      "Prepare the tofu or tempeh by cutting them into bite-sized pieces.",
      "In a blender, combine lemongrass, galangal or ginger, turmeric powder, coriander powder, cumin powder, shallots, and garlic. Blend to a smooth paste.",
      "Heat vegetable oil in a pot over medium heat. Add the spice paste and sauté until fragrant.",
      "Add the vegetable broth and bring it to a boil. Reduce the heat and let it simmer for about 20 minutes.",
      "Add the coconut milk, tofu or tempeh, lime juice, salt, and white pepper powder. Simmer for another 10 minutes.",
      "Meanwhile, prepare the rice noodles according to package instructions.",
      "To serve, place a portion of rice noodles and bean sprouts in a bowl. Ladle the hot soup with tofu or tempeh over the noodles.",
      "If using, add half of a boiled egg to each bowl.",
      "Garnish with fried shallots and chopped cilantro.",
      "Serve the Soto Ayam hot with lime wedges on the side.",
      "Enjoy the delightful flavors of this Indonesian 'chicken' soup!",
    ],
    ingredients: [
      {
        ingredient: "Tofu or tempeh",
        unit: "g",
        quantity: 300,
      },
      {
        ingredient: "Rice noodles",
        unit: "g",
        quantity: 150,
      },
      {
        ingredient: "Bean sprouts",
        unit: "g",
        quantity: 100,
      },
      {
        ingredient: "Boiled eggs (optional)",
        unit: "pieces",
        quantity: 2,
      },
      {
        ingredient: "Coconut milk",
        unit: "ml",
        quantity: 400,
      },
      {
        ingredient: "Lemongrass",
        unit: "stalks",
        quantity: 2,
      },
      {
        ingredient: "Galangal or ginger",
        unit: "g",
        quantity: 20,
      },
      {
        ingredient: "Turmeric powder",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Coriander powder",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Cumin powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Shallots",
        unit: "cloves",
        quantity: 4,
      },
      {
        ingredient: "Garlic cloves",
        unit: "cloves",
        quantity: 3,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vegetable broth",
        unit: "ml",
        quantity: 800,
      },
      {
        ingredient: "Lime, juiced",
        unit: "pieces",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "White pepper powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Fried shallots, for garnish",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh cilantro, chopped, for garnish",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Lime wedges, for serving",
        unit: "pieces",
        quantity: 2,
      },
    ],
  },
  {
    title: "Coconut Mango Passion Fruit Trifle",
    category: "Dessert",
    time: "45 mins",
    description:
      "Coconut Mango Passion Fruit Trifle is a tropical and indulgent dessert that's a feast for the senses. This delightful trifle features layers of moist coconut cake, luscious mango chunks, and tangy passion fruit curd, all beautifully arranged with layers of creamy coconut whipped cream. Each layer is bursting with tropical flavors, and the combination of textures creates a delightful experience with every spoonful. This dessert is perfect for warm summer days or any occasion where you want to transport your taste buds to a tropical paradise. The vibrant colors and refreshing flavors make this trifle a show-stopping centerpiece for any dessert table, and it's sure to be a crowd-pleaser among all who savor its tropical delights.",
    img: "https://cdn.pickuplimes.com/cache/ad/75/ad755c83032fe051fa7b5d2d8286ebd3.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/83/2f/832f225b79e6af8573539f12053cc21e.jpg",
      "https://cdn.pickuplimes.com/cache/88/7b/887b94e64267b4d32f9cb2b639135891.jpg",
      "https://cdn.pickuplimes.com/cache/8b/ad/8bad0c885ec358814df2b4c253b0500c.jpg",
      "https://cdn.pickuplimes.com/cache/8e/ad/8ead428aa4f2e431ed6b7b8c4a88d8e7.jpg",
    ],
    directions: [
      "In a trifle dish or individual serving glasses, start assembling the trifle by layering the cubed coconut sponge cake at the bottom.",
      "Top the cake layer with a generous amount of diced ripe mangoes.",
      "Spread a layer of passion fruit curd over the mangoes. If you can't find passion fruit curd, you can make it by mixing passion fruit pulp with sugar and butter and heating it until thickened.",
      "Repeat the layers of cake, mangoes, and passion fruit curd until the trifle dish or glasses are filled, finishing with a layer of mangoes on top.",
      "In a separate bowl, whip the coconut cream and powdered sugar together until it forms soft peaks. Coconut cream can be obtained by chilling a can of full-fat coconut milk in the refrigerator overnight and scooping out the thick cream that separates.",
      "Spread the whipped coconut cream over the top layer of mangoes.",
      "Garnish the coconut mango passion fruit trifle with toasted coconut flakes and fresh mint leaves for a beautiful presentation.",
      "Chill the trifle in the refrigerator for at least 30 minutes before serving to allow the flavors to meld together.",
      "Serve this tropical and delightful coconut mango passion fruit trifle to impress your guests and enjoy the burst of flavors!",
    ],
    ingredients: [
      {
        ingredient: "Coconut sponge cake, cubed",
        unit: "cups",
        quantity: 4,
      },
      {
        ingredient: "Ripe mango, diced",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Passion fruit curd",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Coconut cream",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Powdered sugar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Toasted coconut flakes (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Fresh mint leaves (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Vegan Pumpkin Pie",
    category: "Dessert",
    time: "25 mins",
    description:
      "Vegan Pumpkin Pie is a delectable and creamy dessert that offers a plant-based twist on the classic holiday favorite. This luscious pie features a smooth and spiced pumpkin filling made with canned or freshly cooked pumpkin puree, coconut milk or other non-dairy milk, sweetened with maple syrup or another vegan sweetener. The pie is baked to perfection in a flaky vegan pie crust, resulting in a delightful treat that's perfect for Thanksgiving or any autumn gathering. Enjoy a slice topped with vegan whipped cream or a scoop of dairy-free ice cream for a delicious and comforting dessert experience.",
    img: "https://cdn.pickuplimes.com/cache/23/13/23138560e5a2e1533515d820bbd709d6.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/79/63/7963d4614b9f05112aa5341b1509b614.jpg",
      "https://cdn.pickuplimes.com/cache/5e/08/5e08b0a494afc9ebb0d2670420ab7dc5.jpg",
      "https://cdn.pickuplimes.com/cache/90/c5/90c52dff8aa40989b9aa830911811bdb.jpg",
      "https://cdn.pickuplimes.com/cache/5e/f3/5ef33339f242a98e711b50fdb6270640.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C).",
      "In a large mixing bowl, whisk together the pumpkin puree, coconut milk, maple syrup, cornstarch, ground cinnamon, ground ginger, ground nutmeg, ground cloves, and salt until well combined and smooth.",
      "Pour the pumpkin filling into the vegan pie crust, spreading it out evenly.",
      "Bake the vegan pumpkin pie in the preheated oven for about 50-60 minutes or until the edges are set, and the center is slightly jiggly.",
      "Once baked, remove the pie from the oven and let it cool on a wire rack.",
      "Refrigerate the pie for at least 4 hours or overnight to allow it to set completely.",
      "Serve slices of the vegan pumpkin pie with a dollop of coconut whipped cream, if desired.",
      "Enjoy this delicious and dairy-free vegan pumpkin pie as a delightful treat during the fall season or any time of the year!",
    ],
    ingredients: [
      {
        ingredient: "Pumpkin puree",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Coconut milk (full fat)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Maple syrup",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Cornstarch",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground ginger",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground nutmeg",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Ground cloves",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Vegan pie crust",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Coconut whipped cream (optional, for serving)",
        unit: "for serving",
        quantity: null,
      },
    ],
  },
  {
    title: "BBQ Cauliflower Pizza",
    category: "Main",
    time: "45 mins",
    description:
      "BBQ Cauliflower Pizza is a mouthwatering and creative twist on traditional pizza. The crust is topped with a smoky and tangy barbecue sauce, tender roasted cauliflower florets, and a combination of melty vegan cheese. This flavorful and satisfying pizza is perfect for pizza night with a plant-based twist!",
    img: "https://cdn.pickuplimes.com/cache/27/a9/27a9cfbba6bcaba8ca08d5fa28497374.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/f6/b8/f6b8542e372478e699943c7fd3c42462.jpg",
      "https://cdn.pickuplimes.com/cache/b0/da/b0da947af7552d82eafae637b26ff9be.jpg",
      "https://cdn.pickuplimes.com/cache/57/1e/571e8011ffaba903c259869d991c8100.jpg",
      "https://cdn.pickuplimes.com/cache/31/d1/31d124edd7698a9171d1a1fa9b887e7c.jpg",
    ],
    directions: [
      "Preheat the oven to the temperature specified in the pizza crust instructions or 425°F (220°C) if using homemade crust.",
      "Toss the cauliflower florets with olive oil, salt, black pepper, and red pepper flakes (if using) in a mixing bowl.",
      "Spread the seasoned cauliflower on a baking sheet and roast it in the preheated oven for about 15-20 minutes or until the cauliflower is tender and lightly browned.",
      "Remove the cauliflower from the oven and set it aside.",
      "Roll out the pizza crust on a floured surface to your desired thickness and shape.",
      "Transfer the rolled-out crust to a pizza stone or a baking sheet.",
      "Spread the barbecue sauce evenly over the pizza crust, leaving a small border around the edges.",
      "Arrange the roasted cauliflower and thinly sliced red onion over the barbecue sauce.",
      "Sprinkle the vegan cheese on top of the cauliflower and red onion.",
      "Bake the BBQ Cauliflower Pizza in the oven for an additional 12-15 minutes, or until the crust is golden and the cheese has melted.",
      "Remove the pizza from the oven and let it cool slightly.",
      "Sprinkle chopped fresh cilantro over the pizza before serving.",
      "Slice the pizza and enjoy the delicious and flavorful BBQ Cauliflower Pizza!",
    ],
    ingredients: [
      {
        ingredient: "Pizza crust (store-bought or homemade)",
        unit: "",
        quantity: "1",
      },
      {
        ingredient: "Cauliflower florets",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Barbecue sauce",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Red onion, thinly sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Vegan cheese (mozzarella or cheddar)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh cilantro, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Red pepper flakes (optional)",
        unit: "teaspoons",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Banana Coffee Muffins",
    category: "Breakfast",
    time: "30 mins",
    description:
      "Banana coffee muffins are a delectable treat that combines the flavors of ripe bananas and rich coffee. These moist and flavorful muffins are perfect for breakfast or as a delicious snack with your favorite cup of coffee.",
    img: "https://cdn.pickuplimes.com/cache/c8/14/c814a184a49a5a0de75a691ec9fb6624.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/18/eb/18eb9f38ac8133598c6edf100be545e0.jpg",
      "https://cdn.pickuplimes.com/cache/75/3f/753f04f5b12f45a053a3a71932a76522.jpg",
      "https://cdn.pickuplimes.com/cache/08/b1/08b1d9b7cbf27bc0e60b612527b78ea4.jpg",
      "https://cdn.pickuplimes.com/cache/71/8c/718ce64514515c04a31c942a5fdb839a.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C) and line a muffin tin with paper liners.",
      "In a small bowl, dissolve the instant coffee granules in hot water and set aside to cool.",
      "In a large mixing bowl, combine the mashed bananas, vegetable oil, granulated sugar, brown sugar, plant-based milk, and vanilla extract. Mix well.",
      "Add the coffee mixture to the wet ingredients and stir until everything is well combined.",
      "In a separate bowl, whisk together the all-purpose flour, baking powder, baking soda, salt, and ground cinnamon.",
      "Gradually add the dry ingredients to the wet ingredients, mixing until just combined. Be careful not to overmix; a few lumps are okay.",
      "If you're adding chopped walnuts or pecans, fold them into the muffin batter.",
      "Spoon the muffin batter into the prepared muffin tin, filling each cup about 3/4 full.",
      "Bake the muffins in the preheated oven for 18-20 minutes or until a toothpick inserted into the center of a muffin comes out clean.",
      "Remove the muffins from the oven and let them cool in the tin for a few minutes before transferring them to a wire rack to cool completely.",
      "Enjoy the delightful banana coffee muffins with a warm cup of coffee or as a tasty snack any time of the day!",
    ],
    ingredients: [
      {
        ingredient: "Ripe bananas, mashed",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Instant coffee granules",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Hot water",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Vegetable oil",
        unit: "cup",
        quantity: 0.3333333333333333,
      },
      {
        ingredient: "Granulated sugar",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Brown sugar",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Plant-based milk (e.g., almond milk, soy milk)",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Baking soda",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Chopped walnuts or pecans (optional)",
        unit: "cup",
        quantity: null,
      },
    ],
  },
  {
    title: "Tea-Infused Chocolate Mousse",
    category: "Dessert",
    time: "60 mins",
    description:
      "Tea-Infused Chocolate Mousse is a sophisticated and indulgent dessert that marries the rich flavor of chocolate with the aromatic notes of tea. This delightful mousse is made by infusing hot cream with your favorite tea leaves (such as Earl Grey, chai, or jasmine) and letting it steep to develop its unique flavors. The infused cream is then mixed with melted dark chocolate and chilled until it thickens into a luscious and velvety mousse. The combination of the deep chocolate taste and the subtle tea undertones creates a harmonious and delightful experience for your taste buds. Whether enjoyed on its own or garnished with a dollop of whipped cream and a dusting of cocoa powder, Tea-Infused Chocolate Mousse is a luxurious dessert that's sure to impress and satisfy any chocolate lover.",
    img: "https://cdn.pickuplimes.com/cache/10/11/10117d9ed699ed13ea88d262eda1fa7e.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/20/be/20be530aa7e1cb70835efe7fdebbc6c1.jpg",
      "https://cdn.pickuplimes.com/cache/39/fb/39fbbaef9850b233112e7c787929f9da.jpg",
      "https://cdn.pickuplimes.com/cache/33/92/3392b01eab92f8fbe8022fdbc76f9b8b.jpg",
      "https://cdn.pickuplimes.com/cache/a1/54/a1545f54e914054687281d8edb70e96d.jpg",
    ],
    directions: [
      "In a small saucepan, heat the full-fat coconut milk over medium heat until it starts to simmer.",
      "Add the tea leaves to the simmering coconut milk and let it steep for about 5 minutes, infusing the milk with the tea flavor. Remove the saucepan from the heat and let it cool.",
      "In a separate microwave-safe bowl, melt the semi-sweet chocolate in the microwave, stirring every 20 seconds until smooth.",
      "Once the coconut milk has cooled, strain out the tea leaves, leaving behind the infused coconut milk.",
      "In a large mixing bowl, combine the melted chocolate, infused coconut milk, maple syrup or agave syrup, vanilla extract, and a pinch of salt. Mix until well combined and smooth.",
      "Cover the mixing bowl with plastic wrap and refrigerate the chocolate mousse mixture for at least 1 hour to allow it to set and thicken.",
      "After chilling, remove the chocolate mousse from the refrigerator and give it a quick whisk to make it fluffy and airy.",
      "Divide the mousse into individual serving cups or glasses.",
      "If desired, garnish the tea-infused chocolate mousse with fresh berries and mint leaves for an elegant touch.",
      "Serve the tea-infused chocolate mousse immediately, or refrigerate it until ready to serve.",
      "Indulge in the velvety smoothness and delightful tea flavors of this exquisite chocolate mousse as a perfect ending to any meal or a special treat on its own.",
    ],
    ingredients: [
      {
        ingredient: "Semi-sweet chocolate (vegan, if preferred)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Full-fat coconut milk",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Your favorite tea leaves (e.g., Earl Grey, green tea)",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup or agave syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Pinch of salt",
        unit: "pinch",
        quantity: null,
      },
      {
        ingredient: "Fresh berries (for serving, optional)",
        unit: "for serving",
        quantity: null,
      },
      {
        ingredient: "Mint leaves (for garnish, optional)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Oven Roasted Sweet Potato & Tofu Veggie Skewers",
    category: "Appetizer",
    time: "35 mins",
    description:
      "Oven-roasted sweet potato & tofu veggie skewers are a delicious and healthy option for a flavorful vegetarian meal. These skewers are packed with colorful vegetables, sweet potatoes, and marinated tofu, all roasted to perfection in the oven.",
    img: "https://cdn.pickuplimes.com/cache/66/2e/662e45e0264e391c016b42e295d4c67e.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/9b/db/9bdb793d1d524c08d9029c8144e07d00.jpg",
      "https://cdn.pickuplimes.com/cache/70/76/7076dc3694fa14287650d40a9641227e.jpg",
      "https://cdn.pickuplimes.com/cache/46/bb/46bba913c09e3cda866c169a22f88505.jpg",
      "https://cdn.pickuplimes.com/cache/6d/9b/6d9bf26cebed267c4385d0454b5cada2.jpg",
    ],
    directions: [
      "Preheat your oven to 400°F (200°C) and line a baking sheet with parchment paper.",
      "In a bowl, combine the olive oil, balsamic vinegar, maple syrup, dried thyme, salt, and black pepper to create the marinade.",
      "Add the cubed sweet potatoes, tofu, bell peppers, red onion, cherry tomatoes, and sliced zucchini to the marinade. Gently toss everything until well coated.",
      "Thread the marinated sweet potatoes, tofu, and vegetables onto the soaked wooden skewers, alternating the ingredients for colorful skewers.",
      "Place the skewers on the prepared baking sheet in a single layer.",
      "Brush any remaining marinade over the skewers for extra flavor.",
      "Roast the sweet potato & tofu veggie skewers in the preheated oven for about 20-25 minutes or until the sweet potatoes are tender and slightly caramelized.",
      "Flip the skewers halfway through the roasting process to ensure even cooking.",
      "Once the skewers are cooked to perfection, remove them from the oven and let them cool slightly.",
      "Serve the oven-roasted sweet potato & tofu veggie skewers as a delightful and wholesome vegetarian meal.",
      "Enjoy the burst of flavors and textures in these colorful skewers, perfect for a family dinner or a gathering with friends!",
    ],
    ingredients: [
      {
        ingredient: "Sweet potatoes, peeled and cubed",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Firm tofu, cubed",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Bell peppers (assorted colors), cut into chunks",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Red onion, cut into chunks",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Cherry tomatoes",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Zucchini, sliced",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Balsamic vinegar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Dried thyme",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Wooden skewers, soaked in water",
        unit: "for skewers",
        quantity: null,
      },
    ],
  },
  {
    title: "Oven Baked Tofu Shakshuka",
    category: "Main",
    time: "45 mins",
    description:
      "Oven Baked Tofu Shakshuka is a delightful twist on the classic Middle Eastern dish. Tofu is baked in a rich and flavorful tomato sauce with bell peppers, onions, and a blend of spices. This vegan version of shakshuka is hearty, comforting, and perfect for any meal of the day!",
    img: "https://cdn.pickuplimes.com/cache/f3/f2/f3f227f68cba03cbba41c3438f28489e.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/84/ff/84ff29cb2990d4ed42a5a32a92400281.jpg",
      "https://cdn.pickuplimes.com/cache/c2/9b/c29ba78299bb302ceac3d4b8c3bbfeed.jpg",
      "https://cdn.pickuplimes.com/cache/d5/25/d525eeab528dcc6d41a229b5593920b0.jpg",
      "https://cdn.pickuplimes.com/cache/82/de/82defaa16988340daca208e21be7a729.jpg",
    ],
    directions: [
      "Preheat the oven to 375°F (190°C).",
      "In a large oven-safe skillet, heat the olive oil over medium heat.",
      "Add the chopped onion and diced red bell pepper. Sauté until softened, about 5 minutes.",
      "Stir in the minced garlic and cook for another 1-2 minutes until fragrant.",
      "Add the canned diced tomatoes, tomato paste, ground cumin, ground paprika, ground cayenne pepper, ground turmeric, salt, and black pepper. Stir well to combine all the ingredients.",
      "Gently fold in the crumbled firm tofu, making sure it's evenly distributed in the tomato sauce.",
      "Transfer the skillet to the preheated oven and bake for 25-30 minutes until the tofu is slightly browned and the sauce is bubbling.",
      "Remove from the oven and garnish with chopped fresh parsley.",
      "Serve the Oven Baked Tofu Shakshuka hot with crusty bread for a delicious and satisfying meal!",
    ],
    ingredients: [
      {
        ingredient: "Firm tofu, drained and crumbled",
        unit: "g",
        quantity: 400,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Onion, finely chopped",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Red bell pepper, diced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "cloves",
        quantity: 3,
      },
      {
        ingredient: "Canned diced tomatoes",
        unit: "g",
        quantity: 400,
      },
      {
        ingredient: "Tomato paste",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground paprika",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground cayenne pepper",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground turmeric",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Fresh parsley, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Crusty bread, for serving",
        unit: "pieces",
        quantity: 4,
      },
    ],
  },
  {
    title: "Nourishing Coconut Milk Oatmeal",
    category: "Breakfast",
    time: "15 mins",
    description:
      "Nourishing coconut milk oatmeal is a creamy and satisfying breakfast option that is enriched with the goodness of coconut milk. This comforting bowl of oatmeal is perfect for starting your day with a nourishing and delicious meal.",
    img: "https://cdn.pickuplimes.com/cache/34/1c/341c9fc362c410d9371bc48d220595b7.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/96/a4/96a46d4674a838d50c324702cd2afed2.jpg",
      "https://cdn.pickuplimes.com/cache/c5/19/c519bb39c7a32a6a49e43b241d588c37.jpg",
      "https://cdn.pickuplimes.com/cache/36/cf/36cfbad313402ac86cd1c3468beee489.jpg",
      "https://cdn.pickuplimes.com/cache/21/81/2181c64f48ca6a958dfcdedffb03ce29.jpg",
    ],
    directions: [
      "In a saucepan, combine the rolled oats, coconut milk, water, maple syrup or honey, vanilla extract, and a pinch of salt.",
      "Place the saucepan over medium heat and bring the mixture to a simmer, stirring occasionally.",
      "Reduce the heat to low and let the oatmeal cook for about 5-7 minutes, or until the oats have absorbed the liquid and reached your desired consistency.",
      "Stir the oatmeal occasionally to prevent sticking and to ensure even cooking.",
      "Once the oatmeal is creamy and fully cooked, remove the saucepan from the heat.",
      "Serve the nourishing coconut milk oatmeal in bowls and top with your favorite fresh fruits and chopped nuts.",
      "For an extra touch of coconut flavor, drizzle a little more coconut milk over the oatmeal if desired.",
      "Enjoy this comforting and nourishing bowl of coconut milk oatmeal to kickstart your day with a dose of wholesome goodness!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Coconut milk (canned)",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Water",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Maple syrup or honey",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Pinch of salt",
        unit: null,
        quantity: null,
      },
      {
        ingredient: "Fresh fruits (e.g., sliced banana, berries) for topping",
        unit: "for topping",
        quantity: null,
      },
      {
        ingredient: "Chopped nuts (e.g., almonds, coconut flakes) for topping",
        unit: "for topping",
        quantity: null,
      },
      {
        ingredient: "Drizzle of coconut milk (optional)",
        unit: "for topping",
        quantity: null,
      },
    ],
  },
  {
    title: "Spiced Walnut & Fig Muffins",
    category: "Dessert",
    time: "40 mins",
    description:
      "Spiced Walnut & Fig Muffins are delicious and moist muffins that bring together the wonderful combination of spiced flavors, crunchy walnuts, and sweet figs. These delightful muffins are made with a blend of all-purpose flour, baking powder, cinnamon, nutmeg, and a pinch of salt, creating a warm and aromatic base. Chopped walnuts and dried figs are folded into the batter, adding a delightful texture and bursts of natural sweetness. For added moisture, ingredients like non-dairy milk (such as almond or soy milk), vegetable oil, and a touch of maple syrup are used to create a luscious and tender muffin. Baked to golden perfection, these spiced walnut and fig muffins make for a delightful breakfast, snack, or treat to be enjoyed any time of the day.",
    img: "https://cdn.pickuplimes.com/cache/ff/97/ff973472ca42296355cff5a635ec5e50.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/c2/07/c20755ec8100799bf7d5efbc98b50095.jpg",
      "https://cdn.pickuplimes.com/cache/f5/45/f545b29a859b63fd4c0f033c9f539326.jpg",
      "https://cdn.pickuplimes.com/cache/48/c7/48c7c4fdb65929b303c2d1cca8442259.jpg",
      "https://cdn.pickuplimes.com/cache/a4/0a/a40a76f12a3ab5b78bcbbc0b583d4ebe.jpg",
    ],
    directions: [
      "Preheat your oven to 375°F (190°C) and line a muffin tin with paper liners.",
      "In a large mixing bowl, whisk together the all-purpose flour, granulated sugar, baking powder, ground cinnamon, ground nutmeg, and salt.",
      "In a separate bowl, mix the unsweetened applesauce, vegetable oil, non-dairy milk, and vanilla extract.",
      "Pour the wet ingredients into the dry ingredients and stir until just combined. Be careful not to overmix; the batter should be slightly lumpy.",
      "Fold in the chopped walnuts and dried figs into the muffin batter.",
      "Divide the batter evenly among the muffin cups, filling each one about two-thirds full.",
      "Bake the muffins in the preheated oven for about 20-25 minutes or until a toothpick inserted into the center of a muffin comes out clean.",
      "Remove the muffins from the oven and let them cool in the muffin tin for a few minutes before transferring them to a wire rack to cool completely.",
      "If desired, dust the cooled muffins with powdered sugar for a decorative touch.",
      "Enjoy the spiced walnut & fig muffins as a delightful breakfast or a wholesome snack to satisfy your taste buds.",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Granulated sugar",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground nutmeg",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Unsweetened applesauce",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Vegetable oil",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Non-dairy milk",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Chopped walnuts",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Dried figs, chopped",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Powdered sugar (for dusting, optional)",
        unit: "for dusting",
        quantity: null,
      },
    ],
  },
  {
    title: "Vegan Apple Pie",
    category: "Dessert",
    time: "25 mins",
    description:
      "Vegan Apple Pie is a classic and heartwarming dessert made entirely without animal products. This delightful pie features a tender and flaky vegan pie crust filled with a generous amount of thinly sliced apples mixed with sugar, cinnamon, and a touch of lemon juice for a burst of flavor. The filling is then baked to perfection until the apples are tender and the crust is golden brown. Vegan butter or coconut oil is used in the crust to create that signature flakiness without the need for traditional butter. This vegan version of the beloved apple pie is just as delicious as the classic, and it's a perfect treat to enjoy during the autumn season or any time you crave the comforting flavors of apple and cinnamon.",
    img: "https://cdn.pickuplimes.com/cache/75/64/7564a080fd361440002662320e754347.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/8e/c9/8ec988dc3d386464d5ed1cc6ff56653b.jpg",
      "https://cdn.pickuplimes.com/cache/93/f8/93f87a2eda788d9d212c5b554684b221.jpg",
      "https://cdn.pickuplimes.com/cache/73/1a/731a16bf5807324bdb0fe6d4daf7a674.jpg",
      "https://cdn.pickuplimes.com/cache/35/76/357684ed849aa1b382c3af20487a363d.jpg",
    ],
    directions: [
      "Preheat your oven to 375°F (190°C).",
      "Roll out the vegan pie crust and line a 9-inch pie dish with it. Trim any excess dough hanging over the edges and crimp the edges decoratively.",
      "In a large mixing bowl, combine the sliced apples, granulated sugar, brown sugar, lemon juice, cornstarch, ground cinnamon, ground nutmeg, salt, and vanilla extract. Toss the mixture until the apples are well coated with the sugar and spices.",
      "Transfer the apple filling to the prepared pie crust, spreading it out evenly.",
      "Dot the top of the apple filling with small pieces of vegan butter.",
      "Cover the pie with the second rolled-out pie crust if making a double-crust pie. If making a lattice crust, cut the second crust into strips and create a lattice pattern over the apple filling.",
      "Brush the top crust (or lattice) with plant-based milk to give it a golden color while baking.",
      "Sprinkle coarse sugar over the top crust for added sweetness and a sparkling appearance.",
      "Bake the vegan apple pie in the preheated oven for about 50-60 minutes or until the crust is golden brown, and the apple filling is bubbling and cooked through.",
      "If the crust starts to brown too quickly during baking, you can cover it with aluminum foil to prevent further browning.",
      "Once baked, remove the apple pie from the oven and let it cool on a wire rack before serving.",
      "Enjoy a slice of warm and fragrant vegan apple pie on its own or with a scoop of your favorite dairy-free ice cream!",
    ],
    ingredients: [
      {
        ingredient: "Vegan pie crust (store-bought or homemade)",
        unit: "1",
        quantity: null,
      },
      {
        ingredient:
          "Apples (a mix of sweet and tart varieties), peeled, cored, and sliced",
        unit: "cups",
        quantity: 6,
      },
      {
        ingredient: "Granulated sugar",
        unit: "tablespoons",
        quantity: 0.5,
      },
      {
        ingredient: "Brown sugar",
        unit: "tablespoons",
        quantity: 0.25,
      },
      {
        ingredient: "Lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Cornstarch",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground nutmeg",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Vegan butter, cut into small pieces",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Plant-based milk (for brushing the crust)",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Coarse sugar (for sprinkling on top)",
        unit: "tablespoons",
        quantity: 1,
      },
    ],
  },
  {
    title: "Watermelon Pizza",
    category: "Snack",
    time: "15 mins",
    description:
      "Watermelon pizza is a refreshing and creative summer treat that puts a fun twist on a classic fruit. This no-bake dessert resembles a pizza, but instead of a dough crust, it features a juicy slice of watermelon topped with a variety of fresh fruits, nuts, and a drizzle of honey or a sprinkle of coconut. It's a delightful and healthy dessert option for hot days.",
    img: "https://cdn.pickuplimes.com/cache/f3/8b/f38b3984d1892de875162331b8292859.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/4f/70/4f7022b381e1d17f9a81390e3909d133.jpg",
      "https://cdn.pickuplimes.com/cache/9d/74/9d7421a420b5b5ad46e06d501a354b27.jpg",
      "https://cdn.pickuplimes.com/cache/4f/70/4f7022b381e1d17f9a81390e3909d133.jpg",
      "https://cdn.pickuplimes.com/cache/9d/74/9d7421a420b5b5ad46e06d501a354b27.jpg",
    ],
    directions: [
      "Using a sharp knife, slice the watermelon into round slices, about 1 inch thick, to resemble a pizza crust.",
      "Place the watermelon rounds on a serving platter or a large plate.",
      "Arrange a colorful assortment of fresh berries, such as strawberries, blueberries, and raspberries, on top of the watermelon rounds.",
      "Add sliced kiwi to the watermelon pizza for a burst of color and tangy flavor.",
      "For added freshness, garnish the watermelon pizza with a few fresh mint leaves.",
      "If desired, drizzle a little honey or maple syrup over the fruit toppings for a touch of sweetness.",
      "For additional texture and flavor, consider sprinkling some shredded coconut or chopped nuts on top of the watermelon pizza.",
      "Serve the watermelon pizza immediately or refrigerate it briefly before serving for a chilled and refreshing dessert.",
      "Enjoy this delightful and healthy watermelon pizza as a fun summer treat or a unique addition to any party or barbecue!",
      "Feel free to get creative with the toppings and use a variety of fresh fruits and other toppings to suit your taste preferences.",
    ],
    ingredients: [
      {
        ingredient: "Watermelon (seedless)",
        unit: "1",
        quantity: null,
      },
      {
        ingredient:
          "Fresh berries (such as strawberries, blueberries, raspberries)",
        unit: "cups",
        quantity: null,
      },
      {
        ingredient: "Kiwi, sliced",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Fresh mint leaves",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Honey or maple syrup (optional, for drizzling)",
        unit: "for drizzling",
        quantity: null,
      },
      {
        ingredient: "Shredded coconut or chopped nuts (optional, for topping)",
        unit: "for topping",
        quantity: null,
      },
    ],
  },
  {
    title: "Blueberry Muffin Overnight Oats",
    category: "Breakfast",
    time: "10 mins",
    description:
      "Blueberry muffin overnight oats are a delicious and wholesome breakfast that captures the flavors of a classic blueberry muffin. These oats are prepared the night before, making them a convenient and tasty morning meal.",
    img: "https://cdn.pickuplimes.com/cache/f0/1e/f01e3aaed69239767e201f21555701f1.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/68/13/6813b6fee738729a075c7405d478aede.jpg",
      "https://cdn.pickuplimes.com/cache/60/8c/608c107558abba70b6d4a4debe36ab8a.jpg",
      "https://cdn.pickuplimes.com/cache/21/be/21be832071225bfd6d54776d26149e92.jpg",
      "https://cdn.pickuplimes.com/cache/9f/29/9f2906964facdb1eab1fb8954c4aa940.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the rolled oats, almond milk, Greek yogurt, honey or maple syrup, vanilla extract, and ground cinnamon. Mix well until all the ingredients are fully incorporated.",
      "Gently fold in the fresh blueberries, distributing them evenly throughout the mixture.",
      "Divide the blueberry muffin overnight oats into individual jars or containers with lids for easy storage and portability.",
      "If you'd like to add some extra crunch and texture, sprinkle chopped nuts over the top of each portion.",
      "Cover the jars or containers with lids and refrigerate them overnight, or for at least 6-8 hours, to allow the oats to absorb the liquid and soften.",
      "In the morning, give the blueberry muffin overnight oats a good stir before serving.",
      "Enjoy the delightful flavors of a blueberry muffin in a nutritious and convenient breakfast that's perfect for busy mornings!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Almond milk (or any milk of your choice)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Greek yogurt",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Fresh blueberries",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Honey or maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Chopped nuts (e.g., almonds, walnuts) (optional)",
        unit: "tablespoons",
        quantity: null,
      },
    ],
  },
  {
    title: "Seaweed Baked Fries with Hoisin Mayo & Sriracha Mayo",
    category: "Appetizer",
    time: "30 mins",
    description:
      "Seaweed baked fries with hoisin mayo & sriracha mayo are a unique and flavorful twist on traditional fries. These fries are coated with crispy seaweed flakes and served with two delicious dipping sauces - hoisin mayo and sriracha mayo. It's a delightful combination of Asian-inspired flavors that will elevate your snacking experience.",
    img: "https://cdn.pickuplimes.com/cache/af/73/af73ca0020b30120d256c985e8989918.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/c5/7e/c57e1e6b262ab71942a7a61ca6d72aa9.jpg",
      "https://cdn.pickuplimes.com/cache/7c/8b/7c8bcb522fa0f64fb8e575644cd0a839.jpg",
      "https://cdn.pickuplimes.com/cache/4f/43/4f438d11ef412ebbba17102fc542e332.jpg",
      "https://cdn.pickuplimes.com/cache/40/29/4029e60ec81aa9744bcbeac9d6428b69.jpg",
    ],
    directions: [
      "Preheat your oven to 425°F (220°C) and line a baking sheet with parchment paper.",
      "In a large bowl, toss the potato fries with olive oil, crushed seaweed flakes or nori, salt, and black pepper until the fries are well coated with the seaweed seasoning.",
      "Spread the seaweed-coated fries in a single layer on the prepared baking sheet.",
      "Bake the seaweed fries in the preheated oven for about 20-25 minutes or until they are crispy and golden brown, flipping them once halfway through for even roasting.",
      "While the fries are baking, prepare the dipping sauces. For the hoisin mayo, simply mix hoisin sauce with half of the mayonnaise in a bowl. For the sriracha mayo, mix sriracha sauce with the remaining mayonnaise in another bowl. Adjust the spiciness to your taste.",
      "Once the seaweed fries are done baking, remove them from the oven and let them cool slightly.",
      "Arrange the seaweed baked fries on a serving platter or individual plates.",
      "Serve the fries with the hoisin mayo and sriracha mayo dipping sauces on the side.",
      "Garnish the dipping sauces with chopped fresh chives for added flavor and presentation.",
      "Enjoy the delightful combination of seaweed-coated fries with the savory hoisin mayo and the spicy kick of sriracha mayo!",
    ],
    ingredients: [
      {
        ingredient: "Potatoes (russet or sweet potatoes), cut into fries",
        unit: "cups",
        quantity: 4,
      },
      {
        ingredient: "Seaweed flakes or nori sheets, crushed",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Mayonnaise (vegan or regular)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Hoisin sauce",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Sriracha sauce",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh chives, chopped (for garnish)",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Vanilla Caramel Cake",
    category: "Dessert",
    time: "25 mins",
    description:
      "Vanilla Caramel Cake is a heavenly dessert that combines the timeless flavor of vanilla with the luscious sweetness of caramel. This delectable cake is made with layers of moist and tender vanilla cake, which are sandwiched together with creamy caramel frosting. The frosting is made by combining rich caramel sauce with vegan butter or coconut oil and powdered sugar, creating a smooth and velvety texture that's perfect for spreading between the cake layers and frosting the entire cake. To add a touch of elegance, the cake is often adorned with a drizzle of caramel sauce, caramelized sugar shards, or a sprinkle of sea salt on top. This Vanilla Caramel Cake is an exquisite centerpiece for any celebration, and its delightful flavors are sure to leave everyone craving for more.",
    img: "https://cdn.pickuplimes.com/cache/56/53/5653ddbbcb4cf81ec800176921bb0229.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/4c/61/4c61ea64288ba90573f0dad743919ae0.jpg",
      "https://cdn.pickuplimes.com/cache/07/82/07825453530b56e6fe1a3240d5bc5cb3.jpg",
      "https://cdn.pickuplimes.com/cache/b8/8a/b88aa1ba7d4e61628cd94f10e79ddd64.jpg",
      "https://cdn.pickuplimes.com/cache/4c/3f/4c3f4895fd50844b07c6ddfbe0e3248f.jpg",
    ],
    directions: [
      "Preheat your oven to 350°F (175°C) and grease two 8-inch round cake pans. Line the bottoms with parchment paper for easy removal.",
      "In a medium bowl, whisk together the all-purpose flour, baking powder, and salt.",
      "In a separate large mixing bowl, cream the vegan butter and granulated sugar together until light and fluffy.",
      "In a small bowl, mix the flaxseed meal and water to create a flax egg. Let it sit for a few minutes to thicken.",
      "Add the flax egg and vanilla extract to the butter-sugar mixture, and beat until well combined.",
      "Alternate adding the dry ingredients and non-dairy milk to the wet ingredients, beginning and ending with the dry ingredients. Mix until just combined; do not overmix.",
      "Divide the cake batter evenly between the prepared cake pans.",
      "Drizzle the caramel sauce over the top of each cake batter in a swirling pattern.",
      "Use a butter knife to gently swirl the caramel into the cake batter for a marbled effect.",
      "Bake the cakes in the preheated oven for about 25-30 minutes or until a toothpick inserted into the center of the cakes comes out clean.",
      "Remove the cakes from the oven and let them cool in the pans for about 10 minutes before transferring them to a wire rack to cool completely.",
      "Once the cakes are completely cooled, spread a layer of vegan whipped cream or frosting on top of one cake.",
      "Place the second cake on top of the frosted one to form a sandwich.",
      "If desired, you can frost the entire cake with more whipped cream or frosting and drizzle additional caramel sauce on top for a beautiful presentation.",
      "Slice the vanilla caramel cake and serve it as a delectable and indulgent dessert for any occasion.",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 2.5,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 2.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Vegan butter",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Granulated sugar",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Flaxseed meal",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 6,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Non-dairy milk",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Caramel sauce (store-bought or homemade)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Vegan whipped cream or frosting",
        unit: "for topping",
        quantity: null,
      },
    ],
  },
  {
    title: "Shoyu Butter Udon Noodles",
    category: "Main",
    time: "20 mins",
    description:
      "Shoyu Butter Udon Noodles is a delightful Japanese dish with a perfect balance of savory and buttery flavors. Udon noodles are cooked to perfection and coated in a rich shoyu (soy sauce) and butter sauce. Topped with green onions, nori seaweed, and sesame seeds, this dish is a comforting and satisfying meal!",
    img: "https://cdn.pickuplimes.com/cache/5c/dd/5cdda20e494b5bb9c139a29d02004d18.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/70/70/7070ee19e747c7938a09e5859bd60730.jpg",
      "https://cdn.pickuplimes.com/cache/3b/3d/3b3d5eddf6714f09761c3a12218d7c6c.jpg",
      "https://cdn.pickuplimes.com/cache/49/58/495891c42a877058f20728e69d110ed5.jpg",
      "https://cdn.pickuplimes.com/cache/9d/1d/9d1dcd634085edc85c73b7f87de97df0.jpg",
    ],
    directions: [
      "Cook the udon noodles according to package instructions until they are al dente. Drain and set aside.",
      "In a saucepan, melt the unsalted butter over low heat.",
      "Add the soy sauce, mirin, and sugar to the melted butter. Stir well to combine and let the sauce simmer for a minute.",
      "Add the cooked udon noodles to the saucepan and toss them to coat evenly with the shoyu butter sauce.",
      "Divide the noodles into serving bowls.",
      "Top the noodles with sliced green onions, shredded nori seaweed, and sesame seeds.",
      "Serve the Shoyu Butter Udon Noodles immediately and enjoy the delightful fusion of flavors!",
    ],
    ingredients: [
      {
        ingredient: "Udon noodles",
        unit: "g",
        quantity: 200,
      },
      {
        ingredient: "Unsalted butter",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Soy sauce",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Mirin",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Sugar",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Green onions, sliced",
        unit: "pieces",
        quantity: 2,
      },
      {
        ingredient: "Nori seaweed, shredded",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Sesame seeds",
        unit: "tablespoons",
        quantity: 1,
      },
    ],
  },
  {
    title: "Easy Chunky Guacamole",
    category: "Snack",
    time: "15 mins",
    description:
      "Easy chunky guacamole is a simple and flavorful dip that celebrates the creaminess of ripe avocados and the freshness of tomatoes, onions, and cilantro. This guacamole is quick to prepare and perfect for dipping tortilla chips, adding to tacos, or as a delicious accompaniment to your favorite Mexican dishes.",
    img: "https://cdn.pickuplimes.com/cache/fa/55/fa5519cd8822c4e079b45e03a5a39d54.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/ed/19/ed190cfe5069cbd8ceaffb8e2c8aa44e.jpg",
      "https://cdn.pickuplimes.com/cache/fc/63/fc6324d3bbf2bfedcbbeaca0bdd04205.jpg",
      "https://cdn.pickuplimes.com/cache/5b/bd/5bbd4eb5edf49df51b2b56e7566d8836.jpg",
      "https://cdn.pickuplimes.com/cache/7f/8b/7f8b5f12aca7d356377c16dc7d2bc9e3.jpg",
    ],
    directions: [
      "Cut the ripe avocados in half, remove the pits, and scoop the flesh into a mixing bowl.",
      "Mash the avocados with a fork or potato masher to achieve your desired level of chunkiness.",
      "Add the diced tomato, finely chopped red onion, and fresh cilantro to the bowl with the mashed avocados.",
      "Squeeze in the lime juice to add brightness and prevent the avocados from browning.",
      "Sprinkle in the garlic powder, salt, and black pepper for extra flavor.",
      "For some heat, you can add finely chopped jalapeno to the guacamole.",
      "Gently stir all the ingredients together until well combined.",
      "Taste the guacamole and adjust the seasoning or lime juice if needed.",
      "Transfer the chunky guacamole to a serving bowl and garnish with a sprig of cilantro or a few tomato slices.",
      "Serve the easy chunky guacamole with your favorite tortilla chips or as a delicious topping for tacos, burritos, or any Mexican-inspired dish!",
      "Any leftovers can be stored in an airtight container in the refrigerator for up to a day. Enjoy it fresh for the best flavor and texture.",
    ],
    ingredients: [
      {
        ingredient: "Ripe avocados",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Tomato, diced",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Red onion, finely chopped",
        unit: "1/4 cup",
        quantity: null,
      },
      {
        ingredient: "Fresh cilantro, chopped",
        unit: "2 tablespoons",
        quantity: null,
      },
      {
        ingredient: "Lime juice",
        unit: "2 tablespoons",
        quantity: null,
      },
      {
        ingredient: "Garlic powder",
        unit: "1/2 teaspoon",
        quantity: null,
      },
      {
        ingredient: "Salt",
        unit: "1/2 teaspoon",
        quantity: null,
      },
      {
        ingredient: "Black pepper",
        unit: "1/4 teaspoon",
        quantity: null,
      },
      {
        ingredient: "Optional: Jalapeno, finely chopped (for heat)",
        unit: "1/2",
        quantity: null,
      },
    ],
  },
  {
    title: "Pistachio & Cranberry Energy Balls",
    category: "Snack",
    time: "15 mins",
    description:
      "Pistachio & cranberry energy balls are a nutritious and tasty snack that provides a burst of energy and a delightful combination of flavors. These no-bake energy balls are easy to make and are packed with wholesome ingredients like pistachios, cranberries, and dates, making them a perfect on-the-go snack or a quick pick-me-up during the day.",
    img: "https://cdn.pickuplimes.com/cache/ca/03/ca032015aea96fca14c253efd5a0651d.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/4f/0f/4f0f1f46d69bd831585e09fa713a8450.jpg",
      "https://cdn.pickuplimes.com/cache/ba/04/ba04a5ebd3344349de32961d225157fb.jpg",
      "https://cdn.pickuplimes.com/cache/9f/a9/9fa9d29eb6a6a15734044df8dfc08326.jpg",
      "https://cdn.pickuplimes.com/cache/72/92/72921f6055ce9df02dbed7c429d283a4.jpg",
    ],
    directions: [
      "In a food processor, combine the pistachios, dried cranberries, pitted Medjool dates, rolled oats, chia seeds, and vanilla extract.",
      "Pulse the mixture until the ingredients are finely chopped and well combined.",
      "Add the water to the food processor and continue pulsing until the mixture starts to come together into a sticky dough.",
      "If the mixture is too dry, you can add a bit more water, one tablespoon at a time, until the desired consistency is achieved.",
      "Transfer the dough to a bowl and refrigerate it for about 10-15 minutes to make it easier to handle.",
      "After chilling, take small portions of the dough and roll them into bite-sized balls between your palms.",
      "Optional: Roll the energy balls in shredded coconut to add a delicious coating.",
      "Place the pistachio & cranberry energy balls on a plate or tray lined with parchment paper.",
      "Refrigerate the energy balls for at least 30 minutes to firm up.",
      "Once the energy balls are chilled and firm, transfer them to an airtight container for storage.",
      "Enjoy these nutritious and flavorful pistachio & cranberry energy balls as a quick and satisfying snack anytime you need an energy boost!",
      "Store any leftover energy balls in the refrigerator for up to a week.",
    ],
    ingredients: [
      {
        ingredient: "Pistachios",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Dried cranberries",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Medjool dates, pitted",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Chia seeds",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoon",
        quantity: 1,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Shredded coconut (for rolling, optional)",
        unit: "for rolling",
        quantity: null,
      },
    ],
  },
  {
    title: "Coconut & Tofu Thai Red Curry",
    category: "Main",
    time: "30 mins",
    description:
      "Coconut & Tofu Thai Red Curry is a creamy and flavorful vegan dish inspired by Thai cuisine. It features tofu, colorful vegetables, and aromatic herbs and spices, all cooked in a luscious coconut milk-based red curry sauce. This delightful and comforting curry is best served over steamed jasmine rice for a complete and satisfying meal!",
    img: "https://cdn.pickuplimes.com/cache/a5/e5/a5e5d7fb475f29ab60345d01c5744a54.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/82/96/8296307f44e8d5d2f46ea8a396309489.jpg",
      "https://cdn.pickuplimes.com/cache/33/fa/33fa20100e3f3595d2c6cebb7403d637.jpg",
      "https://cdn.pickuplimes.com/cache/04/29/0429d6ef4babd07c10e9b3db1738e849.jpg",
      "https://cdn.pickuplimes.com/cache/26/9a/269a03b473f0f1a293cb85b915955557.jpg",
    ],
    directions: [
      "In a large skillet or wok, heat vegetable oil over medium heat.",
      "Add the cubed tofu and stir-fry until lightly browned on all sides. Remove the tofu from the skillet and set it aside.",
      "In the same skillet, add the sliced red bell pepper, zucchini, and snap peas. Stir-fry the vegetables for a few minutes until they are slightly tender.",
      "Add the Thai red curry paste to the skillet and stir it with the vegetables to coat them evenly.",
      "Pour in the coconut milk and stir to combine with the vegetables and curry paste.",
      "Add the lime leaves, soy sauce, and brown sugar to the skillet. Stir well to incorporate the flavors.",
      "Let the curry simmer for about 10 minutes to allow the flavors to meld together and the vegetables to fully cook.",
      "Return the stir-fried tofu to the skillet and gently mix it with the curry.",
      "Tear the fresh basil leaves and add them to the curry. Stir to combine.",
      "Simmer the Coconut & Tofu Thai Red Curry for an additional 2-3 minutes until everything is heated through.",
      "Serve the curry hot over steamed jasmine rice.",
      "Enjoy the creamy and aromatic Coconut & Tofu Thai Red Curry!",
    ],
    ingredients: [
      {
        ingredient: "Firm tofu, cubed",
        unit: "g",
        quantity: 400,
      },
      {
        ingredient: "Red bell pepper, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Zucchini, sliced",
        unit: "medium",
        quantity: 1,
      },
      {
        ingredient: "Snap peas",
        unit: "g",
        quantity: 100,
      },
      {
        ingredient: "Coconut milk",
        unit: "ml",
        quantity: 400,
      },
      {
        ingredient: "Thai red curry paste",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Soy sauce",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Brown sugar",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Lime leaves",
        unit: "pieces",
        quantity: 2,
      },
      {
        ingredient: "Fresh basil leaves",
        unit: "handful",
        quantity: 1,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Cooked jasmine rice",
        unit: "g",
        quantity: 300,
      },
    ],
  },
  {
    title: "Fabulously Healthy Buckwheat Pancakes",
    category: "Breakfast",
    time: "25 mins",
    description:
      "Fabulously healthy buckwheat pancakes are a nutritious twist on the classic pancakes. These pancakes are made with wholesome ingredients like buckwheat flour and almond milk, making them a guilt-free and delicious breakfast option.",
    img: "https://cdn.pickuplimes.com/cache/0c/0f/0c0f41d9fb865aeeee9a5865453a4245.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/99/6c/996c4d1f94af131eacc15f2b5cc07656.jpg",
      "https://cdn.pickuplimes.com/cache/c7/e8/c7e829db7f89d7ec438c7cb5abb609c4.jpg",
      "https://cdn.pickuplimes.com/cache/76/37/76370425e32059ad17b679af85c89394.jpg",
      "https://cdn.pickuplimes.com/cache/3e/c2/3ec22370961679788d263f7b188b7cce.jpg",
    ],
    directions: [
      "In a large mixing bowl, whisk together the buckwheat flour, whole wheat flour, baking powder, salt, and ground cinnamon.",
      "In a separate bowl, combine the almond milk, mashed banana, maple syrup, and vanilla extract. Mix well until the wet ingredients are well incorporated.",
      "Pour the wet ingredients into the dry ingredients and stir until just combined. Be careful not to overmix; a few lumps are okay.",
      "Let the pancake batter rest for about 5 minutes to allow the flours to absorb the liquid.",
      "Preheat a non-stick skillet or griddle over medium heat. Add a little coconut oil or cooking oil to the skillet to prevent sticking.",
      "Once the skillet is hot, pour about 1/4 cup of the pancake batter onto the skillet for each pancake.",
      "Cook the pancakes for about 2-3 minutes on each side or until bubbles form on the surface and the edges look set.",
      "Flip the pancakes and cook for an additional 2-3 minutes on the other side until they are cooked through and lightly browned.",
      "Remove the pancakes from the skillet and keep them warm. Repeat the process with the remaining batter.",
      "Serve the fabulously healthy buckwheat pancakes topped with fresh berries and chopped nuts for extra flavor and nutrition.",
      "Drizzle with a little maple syrup if desired, and enjoy these wholesome and delicious pancakes for a nourishing breakfast!",
    ],
    ingredients: [
      {
        ingredient: "Buckwheat flour",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Whole wheat flour",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Baking powder",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Almond milk (or any plant-based milk)",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Banana, mashed",
        unit: "large",
        quantity: 1,
      },
      {
        ingredient: "Maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Coconut oil (or any cooking oil)",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient:
          "Fresh berries (e.g., blueberries, strawberries) for topping",
        unit: "cups",
        quantity: null,
      },
      {
        ingredient: "Chopped nuts (e.g., almonds, walnuts) for topping",
        unit: "tablespoons",
        quantity: null,
      },
    ],
  },
  {
    title: "Spicy Garlic Tofu",
    category: "Appetizer",
    time: "25 mins",
    description:
      "Spicy garlic tofu is a flavorful and protein-packed dish that will satisfy your taste buds. This tofu is infused with spicy and garlicky flavors, making it a delicious addition to stir-fries, rice bowls, salads, or simply enjoyed on its own.",
    img: "https://cdn.pickuplimes.com/cache/2f/92/2f92995926d24418402cff4847593bc7.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/56/af/56aff2ebab2141b4557c605d9cbcc953.jpg",
      "https://cdn.pickuplimes.com/cache/12/ac/12ac47f775d73c80a24265e74612ab49.jpg",
      "https://cdn.pickuplimes.com/cache/b2/44/b24470ed96f08c81b371059dede12b29.jpg",
      "https://cdn.pickuplimes.com/cache/6d/68/6d68e0074d6c04c13460f4ef574fc05c.jpg",
    ],
    directions: [
      "Start by pressing the tofu to remove excess water. Wrap the tofu block in a clean kitchen towel or paper towels, then place something heavy on top (like a cutting board or a heavy pan). Let it sit for about 15 minutes to press out the water.",
      "In a bowl, combine the cornstarch, soy sauce, chili garlic sauce, sesame oil, and minced garlic to make the marinade.",
      "Cut the pressed tofu into cubes and add them to the marinade. Gently toss the tofu cubes until they are well coated in the spicy garlic marinade. Let the tofu marinate for about 10 minutes.",
      "In a large skillet or non-stick pan, heat the vegetable oil over medium heat.",
      "Add the marinated tofu cubes to the hot pan, making sure not to overcrowd them. Cook the tofu for about 3-4 minutes on each side, or until they become golden brown and crispy.",
      "Once the tofu is cooked to your desired crispiness, remove it from the pan and place it on a plate lined with paper towels to absorb any excess oil.",
      "Garnish the spicy garlic tofu with chopped green onions and toasted sesame seeds for extra flavor and presentation.",
      "Serve the spicy garlic tofu as a delicious and protein-rich main dish or as a tasty addition to your favorite stir-fries, rice bowls, or salads.",
      "Enjoy the bold and spicy flavors of this tofu dish that's sure to be a hit with tofu lovers and non-tofu lovers alike!",
    ],
    ingredients: [
      {
        ingredient: "Firm tofu, drained and cubed",
        unit: "grams",
        quantity: 400,
      },
      {
        ingredient: "Cornstarch",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Soy sauce",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Chili garlic sauce",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Sesame oil",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Minced garlic",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Green onions, chopped (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Toasted sesame seeds (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Herby Garlic Cream 'Cheese'",
    category: "Breakfast",
    time: "10 mins",
    description:
      "Herby garlic cream 'cheese' is a flavorful and creamy vegan alternative to traditional cream cheese. This dairy-free spread is infused with herbs and garlic, making it a delicious topping for bagels, toast, crackers, or as a dip for veggies.",
    img: "https://cdn.pickuplimes.com/cache/8d/92/8d92e4a983abac2e5dc81079797c6b88.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/d5/ea/d5ea320b78a458ec82d59726d9342b28.jpg",
      "https://cdn.pickuplimes.com/cache/48/03/4803138f6e14cdf7af6e85613800bac2.jpg",
      "https://cdn.pickuplimes.com/cache/bb/79/bb796fcb19368f0837ad19bef879be40.jpg",
      "https://cdn.pickuplimes.com/cache/a0/bf/a0bf61cc9b50e07ea160e262e00a10ee.jpg",
    ],
    directions: [
      "In a high-speed blender or food processor, combine the soaked and drained cashews, nutritional yeast, fresh lemon juice, garlic cloves, chopped parsley, chives, dill, and salt.",
      "Blend the mixture on high until it becomes smooth and creamy. If needed, add a couple of tablespoons of water to achieve your desired consistency.",
      "Taste the herby garlic cream 'cheese' and adjust the seasoning, adding more salt or lemon juice if necessary.",
      "Transfer the cream 'cheese' to a sealable container or jar.",
      "Refrigerate the herby garlic cream 'cheese' for at least 30 minutes to allow the flavors to meld together and the spread to firm up slightly.",
      "Once chilled, use the herby garlic cream 'cheese' as a delicious and creamy topping for bagels, toast, or crackers.",
      "You can also enjoy it as a dip for sliced vegetables, or use it as a creamy spread in sandwiches or wraps.",
      "Store any leftover cream 'cheese' in the refrigerator for up to a week.",
      "Enjoy this delightful and herby garlic cream 'cheese' as a tasty vegan alternative to traditional cream cheese!",
    ],
    ingredients: [
      {
        ingredient: "Cashews, soaked and drained",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Nutritional yeast",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Garlic cloves",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Fresh parsley, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh chives, chopped",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Fresh dill, chopped",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Kimchi Noodle Jar",
    category: "Main",
    time: "20 mins",
    description:
      "Kimchi Noodle Jar is a convenient and flavorful meal that you can prepare ahead of time. This jar is packed with layers of delicious ingredients, including spicy kimchi, noodles, vegetables, and a savory sauce. Simply pour hot water into the jar, let it sit for a few minutes, and enjoy a satisfying and delicious noodle dish on the go!",
    img: "https://cdn.pickuplimes.com/cache/45/ad/45ada01aa4beb2e0ca912c68bd2b3d6a.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/e7/aa/e7aaf75cb5dde77d5eb64ee86045a6eb.jpg",
      "https://cdn.pickuplimes.com/cache/d2/e7/d2e7e232890a381338caef4be4639f43.jpg",
      "https://cdn.pickuplimes.com/cache/a5/ed/a5ed3662f78fdb763cc416d82c2023d5.jpg",
      "https://cdn.pickuplimes.com/cache/4f/a7/4fa765757b1dc031e0ffab8506a1d625.jpg",
    ],
    directions: [
      "Cook the instant ramen noodles according to the package instructions. Drain and set them aside.",
      "In a small bowl, mix soy sauce, rice vinegar, toasted sesame oil, and chili garlic sauce to create the savory sauce.",
      "In a clean and dry jar, layer the ingredients in the following order: first, add the kimchi at the bottom of the jar, followed by shredded carrots, julienned cucumber, sliced green onions, sesame seeds, and shredded toasted seaweed.",
      "Place the cooked ramen noodles on top of the layered vegetables.",
      "Pour the prepared sauce over the noodles and make sure it's evenly distributed.",
      "Close the jar tightly with the lid and store it in the refrigerator until ready to eat.",
      "When you're ready to enjoy the Kimchi Noodle Jar, simply pour hot water into the jar until it covers the noodles and vegetables.",
      "Close the jar with the lid and let it sit for a few minutes to allow the noodles to cook and the flavors to blend.",
      "Give the jar a good shake to mix everything together.",
      "Open the jar, grab a pair of chopsticks, and enjoy your delicious and convenient Kimchi Noodle Jar!",
    ],
    ingredients: [
      {
        ingredient: "Instant ramen noodles",
        unit: "packet",
        quantity: 1,
      },
      {
        ingredient: "Kimchi",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Carrot, shredded",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Cucumber, julienned",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Green onions, sliced",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Sesame seeds",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Toasted seaweed (nori), shredded",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Soy sauce",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Rice vinegar",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Toasted sesame oil",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Chili garlic sauce",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Hot water",
        unit: "cups",
        quantity: 1,
      },
    ],
  },
  {
    title: "Chocolate Coconut Nut Butter Balls",
    category: "Dessert",
    time: "20 mins",
    description:
      "Chocolate Coconut Nut Butter Balls are delectable and energy-boosting treats that bring together the delightful combination of chocolate, coconut, and nut butter. These no-bake delights are made with a blend of nut butter (such as almond, peanut, or cashew butter), shredded coconut, cocoa powder, and a natural sweetener like maple syrup or agave. The ingredients are mixed together to form a dough that's rolled into bite-sized balls. The outer coating of shredded coconut adds a delightful crunch and enhances the coconut flavor. These indulgent yet nutritious balls are perfect as a snack, dessert, or a pre or post-workout treat, offering a satisfying and wholesome way to curb your sweet cravings while providing a boost of protein and healthy fats.",
    img: "https://cdn.pickuplimes.com/cache/08/be/08bee1e1be1fde9216c126af2f8260ed.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/14/f0/14f0bc97949c2dfd619008429ff49bb8.jpg",
      "https://cdn.pickuplimes.com/cache/f2/f3/f2f3c95a9ae40c0c079f74a3c44de314.jpg",
      "https://cdn.pickuplimes.com/cache/b5/11/b511c8e1e18600529b19a806efbb4638.jpg",
      "https://cdn.pickuplimes.com/cache/26/52/26526d1299ace0467667e4ca542928ac.jpg",
    ],
    directions: [
      "In a large mixing bowl, combine the nut butter, coconut flour, maple syrup, and vanilla extract. Mix until the ingredients are well combined and form a dough-like consistency.",
      "Stir in the shredded coconut to add texture and flavor to the mixture.",
      "Using your hands, roll the dough into bite-sized balls and place them on a parchment-lined baking sheet. If the mixture is too sticky, you can refrigerate it for a few minutes to make it easier to handle.",
      "In a microwave-safe bowl, melt the dark chocolate chips and coconut oil in the microwave, stirring every 20 seconds until smooth.",
      "Dip each nut butter ball into the melted chocolate, coating it evenly.",
      "Place the chocolate-coated balls back on the parchment-lined baking sheet.",
      "If desired, sprinkle a pinch of sea salt over the chocolate-coated balls for a delightful sweet-savory contrast.",
      "Refrigerate the chocolate coconut nut butter balls for about 10-15 minutes to allow the chocolate to set.",
      "Once the chocolate coating is firm, the balls are ready to enjoy!",
      "Store any leftovers in an airtight container in the refrigerator for future snacking.",
      "Indulge in the chocolatey goodness of these nutritious and delicious chocolate coconut nut butter balls whenever you need a quick pick-me-up or a satisfying treat!",
    ],
    ingredients: [
      {
        ingredient: "Nut butter (e.g., almond butter, peanut butter)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Coconut flour",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Maple syrup",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Shredded coconut (unsweetened)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Dark chocolate chips (dairy-free for vegan option)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Coconut oil",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Sea salt (optional, for sprinkling)",
        unit: "pinch",
        quantity: null,
      },
    ],
  },
  {
    title: "Fruity Caramelized Onion & Feta Pizza",
    category: "Main",
    time: "45 mins",
    description:
      "Fruity Caramelized Onion & Feta Pizza is a delightful combination of sweet, savory, and tangy flavors. The pizza features a thin and crispy crust topped with caramelized onions, feta cheese, and a medley of colorful fruits such as figs and grapes. Finished with a drizzle of balsamic glaze, this unique pizza is a true taste sensation!",
    img: "https://cdn.pickuplimes.com/cache/05/29/0529a21d22e3cd127619d73067213db5.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/47/19/47197fc28a898c56e7557a81ca6011cb.jpg",
      "https://cdn.pickuplimes.com/cache/2c/90/2c90a06fbda43d0d0ca220c85efa9a66.jpg",
      "https://cdn.pickuplimes.com/cache/1b/3b/1b3ba1ce777276b43ad378077cd61952.jpg",
      "https://cdn.pickuplimes.com/cache/3c/ab/3cab913c2a2e1431bbfb764dac22418b.jpg",
    ],
    directions: [
      "Preheat the oven to the temperature specified in the pizza dough instructions or 425°F (220°C) if using homemade dough.",
      "In a pan, heat olive oil over medium-low heat. Add the thinly sliced red onions and cook them slowly until they caramelize and turn golden brown. This process may take around 15-20 minutes. Season the caramelized onions with salt and black pepper.",
      "Roll out the pizza dough on a floured surface to your desired thickness and shape.",
      "Transfer the rolled-out dough to a baking sheet or a pizza stone.",
      "Spread the caramelized onions evenly over the pizza dough.",
      "Top the onions with sliced fresh figs and halved red grapes.",
      "Sprinkle the crumbled feta cheese over the fruits.",
      "Bake the pizza in the preheated oven for 15-20 minutes, or until the crust is golden and crispy, and the cheese has melted.",
      "Remove the pizza from the oven and drizzle balsamic glaze over the top.",
      "Add a handful of fresh arugula on top of the pizza.",
      "Slice the Fruity Caramelized Onion & Feta Pizza and serve it while it's hot.",
      "Enjoy the wonderful blend of flavors in this unique and delicious pizza!",
    ],
    ingredients: [
      {
        ingredient: "Pizza dough (store-bought or homemade)",
        unit: "",
        quantity: "1",
      },
      {
        ingredient: "Red onions, thinly sliced",
        unit: "medium",
        quantity: 2,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Fresh figs, sliced",
        unit: "pieces",
        quantity: 6,
      },
      {
        ingredient: "Red grapes, halved",
        unit: "g",
        quantity: 100,
      },
      {
        ingredient: "Feta cheese, crumbled",
        unit: "g",
        quantity: 150,
      },
      {
        ingredient: "Balsamic glaze",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Fresh arugula",
        unit: "handful",
        quantity: 1,
      },
    ],
  },
  {
    title: "Stewed Berries",
    category: "Breakfast",
    time: "15 mins",
    description:
      "Stewed berries are a simple and delightful treat that brings out the natural sweetness and juiciness of the berries. This warm and comforting dessert or topping is perfect for adding to yogurt, oatmeal, pancakes, or enjoying on its own.",
    img: "https://cdn.pickuplimes.com/cache/8f/44/8f44a6121b1b601939cfaf96f9218eb3.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/4f/01/4f01f5bdb04044c5346863742ec26821.jpg",
      "https://cdn.pickuplimes.com/cache/94/e4/94e4974419cec9cb74042ccc10319c15.jpg",
      "https://cdn.pickuplimes.com/cache/30/bc/30bcaa449a079d7ddbb7e1ad8078503d.jpg",
      "https://cdn.pickuplimes.com/cache/ea/87/ea877e916314154855d458397764b04f.jpg",
    ],
    directions: [
      "In a saucepan, combine the mixed berries, granulated sugar, 2 tablespoons of water, lemon juice, and vanilla extract.",
      "Place the saucepan over medium heat and bring the mixture to a simmer, stirring gently to coat the berries with the sugar and liquid.",
      "Allow the berries to simmer for about 5-7 minutes, or until they soften and release their juices, stirring occasionally.",
      "In a small bowl, mix the cornstarch and 2 tablespoons of cold water to create a slurry.",
      "Slowly pour the cornstarch slurry into the simmering berries while stirring continuously. This will help thicken the berry sauce.",
      "Continue to simmer the berry mixture for an additional 1-2 minutes, or until the sauce thickens to your desired consistency.",
      "Remove the saucepan from the heat and let the stewed berries cool slightly before serving.",
      "Enjoy the warm and delicious stewed berries as a topping for yogurt, oatmeal, pancakes, waffles, or any other dessert of your choice.",
      "You can also refrigerate any leftover stewed berries in an airtight container for a tasty treat later!",
    ],
    ingredients: [
      {
        ingredient:
          "Mixed berries (e.g., strawberries, blueberries, raspberries)",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Granulated sugar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Lemon juice",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Cornstarch",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Cold water",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Shir Berinj - Afghan Rice Pudding",
    category: "Dessert",
    time: "25 mins",
    description:
      "Shir Berinj is a comforting and traditional Afghan rice pudding that brings together the warmth of aromatic spices with the creamy goodness of rice and milk. This delicious dessert is made by simmering rice in water until it becomes tender, then adding milk, sugar, and cardamom to create a rich and creamy pudding. The rice pudding is further enriched with slivered almonds, pistachios, and a sprinkle of rosewater, which add a delightful nutty flavor and floral aroma. Served warm or chilled, Shir Berinj is a delightful treat enjoyed on special occasions and gatherings, offering a taste of Afghan culture and the sweetness of cherished memories.",
    img: "https://cdn.pickuplimes.com/cache/fb/70/fb7035a59dfb6fefd38d7944c29730e7.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/ec/04/ec04d3f41224d917b73d293f8a2591b3.jpg",
      "https://cdn.pickuplimes.com/cache/b2/e5/b2e5f71d1964915c8d53bcf3a3fa4fbd.jpg",
      "https://cdn.pickuplimes.com/cache/81/5e/815e32674e50eb8fd8663e7fced4864c.jpg",
      "https://cdn.pickuplimes.com/cache/e3/74/e374e3a5cfe46bccf8042ef9e1f213be.jpg",
    ],
    directions: [
      "Wash the basmati rice thoroughly and soak it in water for about 30 minutes. Drain the rice after soaking.",
      "In a medium-sized pot, bring 2 cups of water to a boil, and then add the soaked rice. Cook the rice over medium heat until it becomes soft and fully cooked. The water should be absorbed during the cooking process.",
      "Once the rice is cooked, add the milk to the pot and bring the mixture to a gentle simmer. Stir occasionally to prevent sticking or burning.",
      "Gradually add the sugar and ground cardamom to the rice-milk mixture. Continue to stir until the sugar is fully dissolved.",
      "Let the rice pudding simmer on low heat for about 30-40 minutes until it thickens and develops a creamy consistency.",
      "Stir in the rose water to infuse the pudding with its aromatic flavor. Adjust the sweetness to your preference by adding more sugar if needed.",
      "Remove the pot from the heat and let the rice pudding cool slightly.",
      "Serve the Shir Berinj in individual bowls or a large serving dish.",
      "Garnish the rice pudding with slivered almonds, pistachios, ground cinnamon, and dried rose petals, if desired, for an extra touch of flavor and elegance.",
      "You can enjoy Shir Berinj warm or chilled, making it a versatile and delightful dessert for any occasion.",
    ],
    ingredients: [
      {
        ingredient: "Basmati rice",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Water",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Milk",
        unit: "cups",
        quantity: 4,
      },
      {
        ingredient: "Sugar",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Ground cardamom",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Rose water",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Slivered almonds (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Pistachios (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Ground cinnamon (for garnish)",
        unit: "for garnish",
        quantity: null,
      },
      {
        ingredient: "Dried rose petals (for garnish, optional)",
        unit: "for garnish",
        quantity: null,
      },
    ],
  },
  {
    title: "Strawberry Mango Salsa with Baked Pita Chips",
    category: "Appetizer",
    time: "30 mins",
    description:
      "Strawberry mango salsa with baked pita chips is a vibrant and refreshing appetizer that combines the sweetness of ripe strawberries and mangoes with the zing of lime and the kick of jalapeño. This colorful and flavorful salsa is served with crispy baked pita chips for a delightful and healthy snack.",
    img: "https://cdn.pickuplimes.com/cache/03/38/03386172eeee6aab495a25900da7a7d8.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/8f/06/8f0690e09fd0099fdcf5931979c2ab23.jpg",
      "https://cdn.pickuplimes.com/cache/37/31/3731a3aa78ef016158174cbd03e365c6.jpg",
      "https://cdn.pickuplimes.com/cache/2c/b4/2cb49d099b888f7a36084bf17a47e373.jpg",
      "https://cdn.pickuplimes.com/cache/f3/c4/f3c47cd44a0654e8a50200c4057311f7.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the diced strawberries, diced mangoes, finely chopped red onion, chopped fresh cilantro, and finely chopped jalapeño pepper.",
      "In a separate small bowl, whisk together the lime juice and honey (or agave syrup) until well combined.",
      "Pour the lime-honey mixture over the strawberry mango mixture.",
      "Season the salsa with salt and black pepper, then gently toss all the ingredients together until well combined.",
      "Let the strawberry mango salsa sit for about 10 minutes to allow the flavors to meld together.",
      "While the salsa is resting, preheat your oven to 350°F (175°C).",
      "Arrange the pita triangles on a baking sheet in a single layer.",
      "Brush both sides of the pita triangles with olive oil.",
      "Bake the pita triangles in the preheated oven for about 10-12 minutes or until they become crispy and lightly golden brown.",
      "Once the pita chips are ready, remove them from the oven and let them cool slightly.",
      "Serve the strawberry mango salsa in a bowl alongside the crispy baked pita chips.",
      "Enjoy this delightful and colorful salsa with the baked pita chips for a refreshing and tasty snack!",
    ],
    ingredients: [
      {
        ingredient: "Strawberries, diced",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Mango, diced",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Red onion, finely chopped",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Fresh cilantro, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Jalapeño pepper, seeds removed and finely chopped",
        unit: "1",
        quantity: null,
      },
      {
        ingredient: "Lime juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Honey or agave syrup",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Pita bread, cut into triangles",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Baked Berry & Pecan Oatmeal",
    category: "Breakfast",
    time: "45 mins",
    description:
      "Baked berry & pecan oatmeal is a delightful and hearty breakfast dish that combines the sweetness of berries with the nutty flavor of pecans. Baking the oatmeal creates a warm and comforting texture, perfect for a satisfying morning meal.",
    img: "https://cdn.pickuplimes.com/cache/3c/b2/3cb27762647af731f9b15bb565b6367d.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/a8/f2/a8f2244479b4a6d6b8cd2ac297db9e37.jpg",
      "https://cdn.pickuplimes.com/cache/27/34/27349204ca4842534ee3e60e7f89bcfc.jpg",
      "https://cdn.pickuplimes.com/cache/84/1c/841c09858f6fe39bb353d831c92f5ece.jpg",
      "https://cdn.pickuplimes.com/cache/7a/1d/7a1d8fb1159f50e4a0fb24d4fe3515ac.jpg",
    ],
    directions: [
      "Preheat your oven to 375°F (190°C) and lightly grease a baking dish.",
      "In a large mixing bowl, combine the rolled oats, chopped pecans, mixed berries, brown sugar, baking powder, cinnamon, and salt. Mix well until the ingredients are evenly distributed.",
      "In a separate bowl, whisk together the almond milk, egg, melted butter, and vanilla extract.",
      "Pour the wet mixture over the dry ingredients and stir until everything is well combined.",
      "Transfer the oatmeal mixture to the prepared baking dish, spreading it out evenly.",
      "Bake the berry & pecan oatmeal in the preheated oven for about 25-30 minutes or until the top is golden brown and the oatmeal is set.",
      "Remove the oatmeal from the oven and let it cool for a few minutes before serving.",
      "Drizzle with maple syrup before serving for added sweetness, if desired.",
      "Enjoy the warm and delicious baked berry & pecan oatmeal as a wholesome and comforting breakfast!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Pecans, chopped",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient:
          "Mixed berries (e.g., blueberries, raspberries, strawberries)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Brown sugar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Cinnamon",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Almond milk (or any milk of your choice)",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Egg",
        unit: "large",
        quantity: 1,
      },
      {
        ingredient: "Butter, melted",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Maple syrup (for serving)",
        unit: "for drizzling",
        quantity: null,
      },
    ],
  },
  {
    title: "Cranberry Lime Bliss Balls",
    category: "Snack",
    time: "20 mins",
    description:
      "Cranberry lime bliss balls are a delightful and nutritious snack that combines the tangy flavors of cranberries with the zesty taste of lime. These no-bake bliss balls are easy to make and packed with natural sweetness and goodness.",
    img: "https://cdn.pickuplimes.com/cache/db/6b/db6b7a326eed9542c98fd39ee012966b.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/35/4b/354b85572bde0ee94ccf22f882330320.jpg",
      "https://cdn.pickuplimes.com/cache/27/78/2778d5f1d592c2ca209fe6c675d1d0e8.jpg",
      "https://cdn.pickuplimes.com/cache/c0/f2/c0f2346813b6e5eea39dd9351e0bdc55.jpg",
      "https://cdn.pickuplimes.com/cache/f4/fe/f4fed13a76e234445fafea0d25828bfc.jpg",
    ],
    directions: [
      "In a food processor, combine the dried cranberries, almonds, shredded coconut, lime zest, lime juice, maple syrup, vanilla extract, and a pinch of salt.",
      "Pulse the ingredients until they are well combined and form a sticky dough.",
      "If the mixture is too dry, you can add a bit more lime juice or maple syrup to reach the desired consistency.",
      "Line a baking sheet or tray with parchment paper.",
      "Using your hands, roll the cranberry lime mixture into bite-sized balls and place them on the prepared baking sheet.",
      "If desired, you can roll the bliss balls in additional shredded coconut for a decorative coating.",
      "Once all the mixture is used and shaped into balls, refrigerate the bliss balls for about 10-15 minutes to firm up.",
      "After chilling, the cranberry lime bliss balls are ready to be enjoyed!",
      "Store any leftovers in an airtight container in the refrigerator for up to a week.",
      "Grab these delicious and nutritious cranberry lime bliss balls as a quick and satisfying snack on the go or anytime you crave a burst of flavor.",
    ],
    ingredients: [
      {
        ingredient: "Dried cranberries",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Almonds",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Shredded coconut (unsweetened)",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Lime zest",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Lime juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Pinch of salt",
        unit: "pinch",
        quantity: null,
      },
      {
        ingredient: "Additional shredded coconut (for rolling, optional)",
        unit: "for rolling",
        quantity: null,
      },
    ],
  },
  {
    title: "Chocolate Chia Breakfast Pudding",
    category: "Snack",
    time: "10 mins",
    description:
      "Chocolate chia breakfast pudding is a nutritious and delicious way to start your day. This creamy and indulgent pudding is packed with chia seeds, which provide a boost of fiber, protein, and omega-3 fatty acids. Enjoy this delightful treat for breakfast or as a satisfying dessert.",
    img: "https://cdn.pickuplimes.com/cache/c3/50/c350d0aa085dda7a12465d2d36f3bcd5.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/2c/82/2c82ebf446c5b2246986bce7af500baf.jpg",
      "https://cdn.pickuplimes.com/cache/98/b5/98b5810fbc03ce679d05d1a3eafc8e6f.jpg",
      "https://cdn.pickuplimes.com/cache/67/67/67671c7b95c0a6e74366462ee5982371.jpg",
      "https://cdn.pickuplimes.com/cache/a8/2c/a82cea50ae34e7e45a29507e5c6a2361.jpg",
    ],
    directions: [
      "In a bowl or jar, combine the chia seeds, cocoa powder, maple syrup or agave syrup, and vanilla extract.",
      "Pour the almond milk (or any non-dairy milk of your choice) into the bowl and mix well until all the ingredients are fully combined.",
      "Cover the bowl or jar with a lid or plastic wrap and refrigerate it overnight or for at least 4-6 hours to allow the chia seeds to absorb the liquid and thicken into a pudding-like consistency.",
      "Before serving, give the chocolate chia pudding a good stir to ensure an even texture.",
      "Divide the pudding into individual serving cups or bowls.",
      "If desired, top the chocolate chia breakfast pudding with fresh berries, sliced bananas, chopped nuts or seeds, and coconut flakes for added flavor and texture.",
      "Enjoy the creamy and chocolaty goodness of this nutritious pudding for a delightful breakfast or a guilt-free dessert!",
      "Store any leftover chocolate chia breakfast pudding in the refrigerator for up to three days.",
    ],
    ingredients: [
      {
        ingredient: "Chia seeds",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Cocoa powder",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup or agave syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Almond milk (or any non-dairy milk)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh berries or sliced bananas (for topping, optional)",
        unit: "for topping",
        quantity: null,
      },
      {
        ingredient: "Chopped nuts or seeds (for topping, optional)",
        unit: "for topping",
        quantity: null,
      },
      {
        ingredient: "Coconut flakes (for topping, optional)",
        unit: "for topping",
        quantity: null,
      },
    ],
  },
  {
    title: "Sun-Dried Tomato & White Bean Dip",
    category: "Appetizer",
    time: "15 mins",
    description:
      "Sun-dried tomato & white bean dip is a creamy and flavorful dip that is perfect for parties, gatherings, or as a tasty snack. The combination of sun-dried tomatoes and white beans creates a rich and savory dip that pairs well with crackers, vegetable sticks, or pita bread.",
    img: "https://cdn.pickuplimes.com/cache/e8/1c/e81c2b02498eac2bc8f28aadecaf1385.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/a2/05/a205efa608fab199b288b93b14386d95.jpg",
      "https://cdn.pickuplimes.com/cache/94/85/9485d58943be573271dab3044bbbdcd2.jpg",
      "https://cdn.pickuplimes.com/cache/48/6e/486eda55d468294326c9f84863602b28.jpg",
      "https://cdn.pickuplimes.com/cache/d0/ed/d0ed2a0bf8e6a426d9d469e737d34df9.jpg",
    ],
    directions: [
      "In a food processor, combine the white beans, sun-dried tomatoes, minced garlic, fresh lemon juice, tahini, extra virgin olive oil, water, ground cumin, salt, and black pepper.",
      "Blend the ingredients until the mixture becomes smooth and creamy. If needed, you can add more water or olive oil to achieve your desired consistency.",
      "Taste the sun-dried tomato & white bean dip and adjust the seasonings to your liking. You can add more lemon juice, salt, or red pepper flakes for added spice if desired.",
      "Transfer the dip to a serving bowl.",
      "Garnish the dip with chopped fresh parsley for added flavor and presentation.",
      "Serve the sun-dried tomato & white bean dip with crackers, vegetable sticks, or pita bread.",
      "Enjoy this delicious and nutritious dip as a crowd-pleasing appetizer or a satisfying snack!",
    ],
    ingredients: [
      {
        ingredient: "White beans (cannellini beans), drained and rinsed",
        unit: "cups",
        quantity: 1.5,
      },
      {
        ingredient: "Sun-dried tomatoes (packed in oil), drained",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Fresh lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Tahini",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Extra virgin olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Fresh parsley, chopped (for garnish)",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Red pepper flakes (optional, for added spice)",
        unit: "teaspoons",
        quantity: null,
      },
    ],
  },
  {
    title: "Strawberry Cheesecake Overnight Oats",
    category: "Breakfast",
    time: "10 mins",
    description:
      "Strawberry cheesecake overnight oats are a delightful and indulgent breakfast that combines the flavors of creamy cheesecake and sweet strawberries. These oats are prepared the night before, making them a convenient and delicious morning meal.",
    img: "https://cdn.pickuplimes.com/cache/04/e7/04e7325683a350b5510919851095dc87.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/69/e1/69e122e56c165b2b7bc505f67763689c.jpg",
      "https://cdn.pickuplimes.com/cache/0e/77/0e77c7956c806c0267580274cdd15e26.jpg",
      "https://cdn.pickuplimes.com/cache/72/24/7224fa2093574efc7b974f217a831a51.jpg",
      "https://cdn.pickuplimes.com/cache/70/c7/70c747b6e5f1c676e312ab88baf9cfd3.jpg",
    ],
    directions: [
      "In a mixing bowl, combine the rolled oats, Greek yogurt, milk, cream cheese, honey or maple syrup, and vanilla extract. Mix well until all the ingredients are thoroughly combined and the mixture is creamy.",
      "Gently fold in the chopped fresh strawberries, being careful not to crush them too much.",
      "Divide the mixture into individual jars or containers with lids for easy storage and portability.",
      "Sprinkle the crushed graham crackers over the top of each portion, creating a delicious cheesecake-like crust.",
      "Cover the jars or containers with lids and refrigerate them overnight, or for at least 6-8 hours, to allow the oats to soften and flavors to meld together.",
      "In the morning, give the strawberry cheesecake overnight oats a good stir before serving.",
      "Enjoy the creamy and fruity goodness of strawberry cheesecake in a convenient and nutritious breakfast option!",
    ],
    ingredients: [
      {
        ingredient: "Rolled oats",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Greek yogurt",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Milk (e.g., almond milk, cow's milk)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Cream cheese",
        unit: "ounces",
        quantity: 2,
      },
      {
        ingredient: "Honey or maple syrup",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Fresh strawberries, chopped",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Graham crackers, crushed",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Savoury Sun-Dried Tomato & Olive Muffins",
    category: "Snack",
    time: "30 mins",
    description:
      "Savory sun-dried tomato & olive muffins are a delicious and flavorful treat that brings together the tangy taste of sun-dried tomatoes and the briny goodness of olives in a moist and savory muffin. These muffins are perfect for breakfast, brunch, or as a delightful accompaniment to soups and salads.",
    img: "https://cdn.pickuplimes.com/cache/46/0c/460c5dba80e73cd4d794bcf6cc98334f.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/58/6f/586f3bf0c0d5824c9c09ff2bd6675613.jpg",
      "https://cdn.pickuplimes.com/cache/b4/7f/b47fbaa847c59479178fbc1c104ea042.jpg",
      "https://cdn.pickuplimes.com/cache/c0/10/c0103a10dbd1dcda99721c14e8c32d39.jpg",
      "https://cdn.pickuplimes.com/cache/ad/8a/ad8a86f2a7d83265d4e631aaa9b9190e.jpg",
    ],
    directions: [
      "Preheat your oven to 375°F (190°C) and line a muffin tin with paper liners or grease it with olive oil.",
      "In a large mixing bowl, whisk together the all-purpose flour, baking powder, baking soda, and salt.",
      "In a separate bowl, combine the flaxseed meal and water, and let it sit for a few minutes to form a flax egg.",
      "To the flax egg, add the olive oil and unsweetened almond milk, and whisk everything together.",
      "Pour the wet ingredients into the bowl with the dry ingredients and stir until just combined.",
      "Fold in the chopped sun-dried tomatoes, Kalamata olives, chopped fresh basil leaves, nutritional yeast, garlic powder, and black pepper.",
      "Scoop the muffin batter into the prepared muffin tin, filling each cup about 2/3 full.",
      "Bake the savory sun-dried tomato & olive muffins in the preheated oven for about 15-18 minutes or until a toothpick inserted into the center of a muffin comes out clean.",
      "Remove the muffins from the oven and let them cool in the muffin tin for a few minutes before transferring them to a wire rack to cool completely.",
      "Serve these delightful savory muffins warm or at room temperature as a tasty and satisfying snack or side dish.",
      "Any leftover muffins can be stored in an airtight container at room temperature for up to three days or in the refrigerator for up to a week.",
      "Enjoy the savory sun-dried tomato & olive muffins with your favorite spreads or simply on their own for a flavorful treat!",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Baking soda",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Olive oil",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Unsweetened almond milk (or any plant-based milk)",
        unit: "cup",
        quantity: 1,
      },
      {
        ingredient: "Flaxseed meal",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Water",
        unit: "tablespoons",
        quantity: 6,
      },
      {
        ingredient: "Sun-dried tomatoes, chopped",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Kalamata olives, pitted and chopped",
        unit: "cup",
        quantity: 0.5,
      },
      {
        ingredient: "Fresh basil leaves, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Nutritional yeast",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Garlic powder",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
    ],
  },
  {
    title: "Rocky Mountain Chocolate Bark",
    category: "Dessert",
    time: "60 mins",
    description:
      "Rocky Mountain Chocolate Bark is a delightful and indulgent treat inspired by the rugged beauty of the Rocky Mountains. This luxurious chocolate bark is made with a base of rich and smooth dark chocolate, which is then generously adorned with an array of delicious toppings. The toppings can vary but often include a combination of nuts like almonds, pecans, and walnuts, as well as dried fruits such as cranberries, cherries, and apricots. To add a touch of elegance, some versions of Rocky Mountain Chocolate Bark may also feature a sprinkle of sea salt or a drizzle of caramel. The result is a harmonious blend of textures and flavors that create a truly irresistible dessert. Whether you're enjoying it as a special treat for yourself or gifting it to a loved one, Rocky Mountain Chocolate Bark is sure to delight and impress with its exquisite taste and presentation.",
    img: "https://cdn.pickuplimes.com/cache/f2/b2/f2b206f8b83f964465d1467f7e716599.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/20/7d/207dae43822942850fa6d999ffb154cb.jpg",
      "https://cdn.pickuplimes.com/cache/74/03/74038a16bf674386a017bdfa59490a90.jpg",
      "https://cdn.pickuplimes.com/cache/f2/b2/f2b206f8b83f964465d1467f7e716599.jpg",
      "https://cdn.pickuplimes.com/cache/df/d0/dfd01a368b88d797ae3ce1ff47403e61.jpg",
    ],
    directions: [
      "Line a baking sheet or tray with parchment paper and set it aside.",
      "In a microwave-safe bowl, melt the dark chocolate in the microwave, stirring every 20 seconds until smooth.",
      "Pour the melted dark chocolate onto the prepared parchment paper, spreading it out into an even layer with a spatula.",
      "In another microwave-safe bowl, melt the white chocolate in the microwave, stirring every 20 seconds until smooth.",
      "Drizzle the melted white chocolate over the dark chocolate in a zigzag pattern.",
      "Sprinkle the chopped almonds, chopped pecans, dried cranberries, and shredded coconut over the top of the melted chocolates.",
      "Gently press down the toppings with the back of a spoon to ensure they adhere to the chocolate.",
      "If desired, sprinkle sea salt flakes over the top of the bark for a delightful sweet-savory contrast.",
      "Place the tray in the refrigerator for about 30-40 minutes to allow the chocolate bark to set completely.",
      "Once the chocolate is firm, break the rocky mountain chocolate bark into irregular pieces.",
      "Transfer the bark to an airtight container and store it in the refrigerator until ready to serve.",
      "Indulge in the rich and delicious rocky mountain chocolate bark as a delightful treat or share it with friends and family for a delightful and indulgent experience.",
    ],
    ingredients: [
      {
        ingredient: "Dark chocolate (vegan, if preferred)",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "White chocolate (vegan, if preferred)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Almonds, chopped",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Pecans, chopped",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Dried cranberries",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Shredded coconut (unsweetened)",
        unit: "cups",
        quantity: 0.25,
      },
      {
        ingredient: "Sea salt flakes",
        unit: "for sprinkling",
        quantity: null,
      },
    ],
  },
  {
    title: "Samosa Sweet Potato Breakfast Wraps with Tofu Scramble",
    category: "Breakfast",
    time: "40 mins",
    description:
      "Samosa sweet potato breakfast wraps with tofu scramble are a delicious and savory breakfast option inspired by the flavors of samosas. These wraps feature a flavorful sweet potato filling and a protein-packed tofu scramble, making them a satisfying and hearty morning meal.",
    img: "https://cdn.pickuplimes.com/cache/7f/18/7f18d27037d9d0a3283664cb48e89aff.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/8c/a6/8ca6b0173a78267e40132e4c30b9b1bc.jpg",
      "https://cdn.pickuplimes.com/cache/69/ee/69ee43e67716dba318517ea4cfc4f560.jpg",
      "https://cdn.pickuplimes.com/cache/f8/be/f8be9b49c3cc516db6ad940a6199cdcb.jpg",
      "https://cdn.pickuplimes.com/cache/af/77/af7742257a36a35b41ab73cdfd0a5d70.jpg",
    ],
    directions: [
      "Preheat your oven to 425°F (220°C). Place the diced sweet potatoes on a baking sheet, drizzle with cooking oil, and toss to coat. Roast in the preheated oven for about 20 minutes or until the sweet potatoes are tender and slightly crispy.",
      "In the meantime, prepare the tofu scramble. In a skillet, heat 1 tablespoon of cooking oil over medium heat. Add the crumbled tofu, chopped red onion, and minced garlic. Cook for about 5 minutes, stirring occasionally.",
      "Add the curry powder, ground cumin, ground coriander, turmeric, salt, and black pepper to the tofu mixture. Stir well to coat the tofu and cook for an additional 2-3 minutes to let the flavors meld together. Remove from heat and stir in the chopped cilantro.",
      "In a separate skillet, heat the remaining 1 tablespoon of cooking oil over medium heat. Add the cooked chickpeas and frozen green peas. Cook for about 5 minutes, stirring occasionally, until the peas are cooked through.",
      "Add the roasted sweet potatoes to the chickpeas and green peas mixture. Mix everything together and cook for an additional 2-3 minutes to let the flavors blend.",
      "Warm the tortilla wraps in a dry skillet or microwave for a few seconds to make them pliable.",
      "To assemble the wraps, spoon the sweet potato filling and tofu scramble onto each tortilla wrap. Roll the wraps tightly, folding in the sides as you go.",
      "Serve the samosa sweet potato breakfast wraps with tofu scramble immediately, or wrap them in foil for a convenient on-the-go breakfast!",
      "Enjoy the delicious and savory flavors of these breakfast wraps inspired by samosas.",
    ],
    ingredients: [
      {
        ingredient: "Sweet potatoes, peeled and diced",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Cooked chickpeas",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Frozen green peas",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Curry powder",
        unit: "teaspoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Ground coriander",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Turmeric",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Tofu, crumbled",
        unit: "grams",
        quantity: 200,
      },
      {
        ingredient: "Red onion, finely chopped",
        unit: "cup",
        quantity: 0.25,
      },
      {
        ingredient: "Garlic cloves, minced",
        unit: "2",
        quantity: null,
      },
      {
        ingredient: "Fresh cilantro, chopped",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Tortilla wraps",
        unit: "large",
        quantity: null,
      },
      {
        ingredient: "Cooking oil",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
  {
    title: "Quick-Cooking Millet Breakfast Porridge",
    category: "Breakfast",
    time: "15 mins",
    description:
      "Quick-cooking millet breakfast porridge is a nutritious and delicious way to start your day. Millet cooks up quickly, and this creamy porridge is filled with warming flavors and a delightful texture, making it a perfect breakfast option.",
    img: "https://cdn.pickuplimes.com/cache/33/95/33958861e4bc02e79a9985eef7631428.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/4a/12/4a1233891f265e6cfe60e2542efe00dd.jpg",
      "https://cdn.pickuplimes.com/cache/2c/38/2c384b0f276818f3874c4aa7974f1cd3.jpg",
      "https://cdn.pickuplimes.com/cache/57/e9/57e9dd82509e04541f37c2a46d53519f.jpg",
      "https://cdn.pickuplimes.com/cache/bd/4b/bd4bbda9d24ca81ef45d51f1c46bab7c.jpg",
    ],
    directions: [
      "Rinse the millet thoroughly under cold water and drain well.",
      "In a saucepan, combine the rinsed millet, water, almond milk, maple syrup or honey, ground cinnamon, and vanilla extract.",
      "Place the saucepan over medium heat and bring the mixture to a boil.",
      "Once it starts boiling, reduce the heat to low, cover the saucepan with a lid, and let the millet simmer for about 10 minutes or until the liquid is mostly absorbed and the millet is tender.",
      "Stir the porridge occasionally to prevent sticking and to ensure even cooking.",
      "Once the millet is cooked to a creamy consistency, remove the saucepan from the heat.",
      "Serve the quick-cooking millet breakfast porridge in bowls and top with your favorite fresh fruits and chopped nuts or seeds.",
      "For an extra touch of creaminess, drizzle a little more almond milk over the porridge if desired.",
      "Enjoy this comforting and wholesome millet breakfast porridge to kickstart your day with a nourishing meal!",
    ],
    ingredients: [
      {
        ingredient: "Millet",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Water",
        unit: "cups",
        quantity: 2,
      },
      {
        ingredient: "Almond milk (or any plant-based milk)",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Maple syrup or honey",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Ground cinnamon",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Fresh fruits (e.g., sliced banana, berries) for topping",
        unit: "for topping",
        quantity: null,
      },
      {
        ingredient:
          "Chopped nuts or seeds (e.g., almonds, chia seeds) for topping",
        unit: "for topping",
        quantity: null,
      },
      {
        ingredient: "Drizzle of almond milk (optional)",
        unit: "for topping",
        quantity: null,
      },
    ],
  },
  {
    title: "Vegan Blueberry Mug Cake",
    category: "Dessert",
    time: "5 mins",
    description:
      "Vegan Blueberry Mug Cake is a quick and delightful dessert that can be made in just a few minutes using a microwave. This single-serving cake is bursting with juicy blueberries and is entirely plant-based, free from eggs and dairy. Made with simple vegan pantry ingredients like all-purpose flour, sugar, non-dairy milk (such as almond, soy, or oat milk), vegetable oil or melted coconut oil, and a pinch of baking powder, this mug cake is mixed in a mug and microwaved to perfection. The result is a tender and moist blueberry cake with the sweetness of the berries and a hint of vanilla. Enjoy this warm and comforting treat straight from the mug or add a drizzle of vegan frosting or a sprinkle of powdered sugar for an extra touch of sweetness.",
    img: "https://cdn.pickuplimes.com/cache/8c/a5/8ca5da953dbfdbd5e97c944dd372873e.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/27/28/2728c427824f0cccf25f7b7f7bfcb19e.jpg",
      "https://cdn.pickuplimes.com/cache/c7/d9/c7d91201da4e083f1fbd9cde1afd3af4.jpg",
      "https://cdn.pickuplimes.com/cache/66/b2/66b2416e08df4bc658fd492d6c051c79.jpg",
      "https://cdn.pickuplimes.com/cache/85/e6/85e62e0fccf6d7500302f6b4484acad8.jpg",
    ],
    directions: [
      "In a microwave-safe mug, whisk together the all-purpose flour, granulated sugar, baking powder, and a pinch of salt.",
      "Add the almond milk, vegetable oil, and vanilla extract to the dry ingredients in the mug. Mix until the batter is smooth and no lumps remain.",
      "Gently fold in the blueberries into the batter, distributing them evenly throughout.",
      "Place the mug in the microwave and cook on high for about 1 minute and 30 seconds to 2 minutes. Cooking time may vary depending on your microwave's power. The cake should rise and become firm to the touch.",
      "Remove the mug from the microwave, and let the blueberry mug cake cool for a minute or two before serving.",
      "If desired, drizzle some maple syrup over the top of the cake for added sweetness and a burst of flavor.",
      "Indulge in the warm and fruity goodness of this vegan blueberry mug cake for a delightful dessert experience.",
    ],
    ingredients: [
      {
        ingredient: "All-purpose flour",
        unit: "tablespoons",
        quantity: 4,
      },
      {
        ingredient: "Granulated sugar",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Salt",
        unit: "pinch",
        quantity: null,
      },
      {
        ingredient: "Almond milk (or any non-dairy milk)",
        unit: "tablespoons",
        quantity: 3,
      },
      {
        ingredient: "Vegetable oil",
        unit: "tablespoons",
        quantity: 1,
      },
      {
        ingredient: "Vanilla extract",
        unit: "teaspoons",
        quantity: 0.25,
      },
      {
        ingredient: "Blueberries",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Maple syrup (for drizzling, optional)",
        unit: "for drizzling",
        quantity: null,
      },
    ],
  },
  {
    title: "Baked Green Pea & Chickpea Falafels",
    category: "Main",
    time: "60 mins",
    description:
      "Baked Green Pea & Chickpea Falafels are a delightful and healthy twist on the classic falafels. These falafels are packed with the goodness of green peas and chickpeas, mixed with flavorful herbs and spices. Baking them instead of frying makes them crispy on the outside and tender on the inside. Enjoy them in pita bread, salads, or as a tasty snack!",
    img: "https://cdn.pickuplimes.com/cache/85/da/85dad352246d6800168e4714e7fd452a.jpg",
    images: [
      "https://cdn.pickuplimes.com/cache/c6/27/c627d424c0429c9e71fce06db579b5b2.jpg",
      "https://cdn.pickuplimes.com/cache/73/59/7359b685429913f8df684b140a5ff996.jpg",
      "https://cdn.pickuplimes.com/cache/bb/57/bb577ccd44d0c5db5685ac7fb49b784c.jpg",
      "https://cdn.pickuplimes.com/cache/4d/d5/4dd54c16ff50f0c6c24bda879a4843a3.jpg",
    ],
    directions: [
      "Preheat the oven to 375°F (190°C). Line a baking sheet with parchment paper.",
      "In a food processor, combine green peas, cooked chickpeas, fresh parsley, fresh cilantro, garlic cloves, ground cumin, ground coriander, baking powder, salt, and black pepper.",
      "Pulse the ingredients until a coarse and slightly chunky mixture forms. Be careful not to over-process; you want some texture in the falafel mixture.",
      "Transfer the falafel mixture to a mixing bowl and stir in lemon juice, olive oil, and all-purpose flour. Mix well until everything is evenly combined.",
      "Using your hands, shape the falafel mixture into small patties or balls. Place them on the prepared baking sheet.",
      "Bake the falafels in the preheated oven for about 25-30 minutes or until they are golden and crispy on the outside.",
      "Remove the falafels from the oven and let them cool slightly before serving.",
      "Enjoy the Baked Green Pea & Chickpea Falafels in pita bread with your favorite toppings and sauces, or serve them as a healthy and flavorful snack!",
    ],
    ingredients: [
      {
        ingredient: "Green peas, thawed if frozen",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Cooked chickpeas",
        unit: "cups",
        quantity: 1,
      },
      {
        ingredient: "Fresh parsley leaves",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Fresh cilantro leaves",
        unit: "cups",
        quantity: 0.5,
      },
      {
        ingredient: "Garlic cloves",
        unit: "cloves",
        quantity: 2,
      },
      {
        ingredient: "Ground cumin",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Ground coriander",
        unit: "teaspoons",
        quantity: 1,
      },
      {
        ingredient: "Baking powder",
        unit: "teaspoons",
        quantity: 0.5,
      },
      {
        ingredient: "Salt",
        unit: "teaspoon",
        quantity: 0.5,
      },
      {
        ingredient: "Black pepper",
        unit: "teaspoon",
        quantity: 0.25,
      },
      {
        ingredient: "Lemon juice",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "Olive oil",
        unit: "tablespoons",
        quantity: 2,
      },
      {
        ingredient: "All-purpose flour",
        unit: "tablespoons",
        quantity: 2,
      },
    ],
  },
];

for (let a = 1; a <= TempRecipeData.length; a++) {
  TempRecipeData[a - 1]._id = a;
}

export default TempRecipeData;
